/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-inner-declarations */
const loadImageBlueimp = require('blueimp-load-image');
import { v4 as uuidv4 } from 'uuid';
import {
    clearBorder,
    focusCanvas,
    getCanvasElementTitle,
    selectCanvasElements,
    toggleElementLock,
    toggleElementOverlay,
    toggleElementPrintArea,
    toggleElementVisibility,
    updateCanvasSelection,
    updateElementsOrderFromZIndex
} from '@/utils/elementsUtils';

import { buildStyledQrConfig, setQrData } from '@/utils/qrCodeUtils';
import { UndoRedoManager } from '@/utils/undoRedoManager/undoRedoManager.js';
import { mmToPixels, pixelsToMm, mmToInches, pptxUnitsToPixels, pptxFontSizeToPixels } from '@/utils/unitsUtils';
import * as Sentry from '@sentry/browser';
import { getTemplateProduct, getTemplateProductColorImages } from '@/api/admin/templateProducts';
import { getTemplateProductVariantOptions, getGuideSpecs } from '@/api/templateProduct';
import { getBeforeMergeData, getBeforeMergeDataWithoutVariants } from '@/api/product';
import { createSetFromDesignTemplate } from '@/api/admin/designTemplates';
import { getProgress } from '@/api/storesApp/optionSets';
import { pollUntilComplete } from '@/utils/promiseUtils';
import { getPodProviderById } from '@/api/admin/podProvider';
import { getMyProductBasesPod } from '@/api/podProvider';
import { buildCloudFrontUrl, getExtension } from '@/utils/pathUtils';
import {
    calculateBoundingBox,
    getCurrentSelectionAsImage,
    handleDownloadCurrentCanvasAsImage,
    inferFormatFromImage,
    loadAndResizeImageIntoBase64,
    uploadImageToS3
} from '@/utils/imageUtils';
import { getPlaceholderSize, getProduct as getPodProduct } from '@/utils/podAssignmentUtils';
import * as mapUtils from '../../services/util/mapUtils';
import * as sourceElementUtils from '../../services/util/sourceElementUtils';
import * as starMapUtils from '../../services/util/starMapUtils';
import { createTextEffect, createTextEffectHandlers, cleanupDeletedTextEffects } from '@/utils/textMaskEffects';
import { createTextPatternHandlers, parsePatternConfig } from '@/utils/textPatternEffects';
import { getDesign, saveDesign } from '@/api/admin/designs';
import { SaveAs } from '@/typings/designStudio/saveAs';
import ImageFilter from '@/typings/ImageFilter';
import { initializePaper } from '@/angular-app/libs/TextTransform/PaperUtils';
import CustomilyCalendar from '@customily/customily-calendar';
import { generateCustomilyCalendar } from '@/utils/customilyCalendarUtils';
import { tryParseJson } from '@/utils/objectUtils';
import fontManagerService from '@/utils/fontManagerService';
import { loadClipPathFromObject, sanitizeSvgString, parseSvgMaskShape, applySvgMaskClipPath } from '@/utils/fabricUtils';
import { IndexDbService } from '../../services/util/indexDbService';
import useDesignStudio from '@/composables/useDesignStudio';
import store from '@/store';
import { useColor } from '@/composables/color';
import { ImageEffectsService } from '@/utils/imageEffectsService';
import { MAP_STYLE_PRESETS } from '@/components/DesignStudio/MapStyleProperties/presets';
import { getElementType } from '@/utils/elementTypeUtils';
import useGroupManager from '@/modules/layers/composables/useGroupManager';
import StoreType from '@/typings/storeType';
import { ValueFormat } from '@/typings/designStudio/sourceElementTypes';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('CreateStepOneCtrl', createStepOneCtrl);

    /**
     * Controller for the first step of creating a product.
     * @param {Object} $scope - The scope object.
     * @param {Object} $timeout - The timeout service.
     * @param {Object} $location - The location service.
     * @param {Object} $q - The promise service.
     * @param {Object} $mdToast - The toast service.
     * @param {Object} $interval - The interval service.
     * @param {Object} $window - The window object.
     * @param {Object} FontManagerService - The font manager service.
     * @param {Object} MultipleFontService - The multiple font service.
     * @param {Object} ProductService - The product service.
     * @param {Object} ImageUtilService - The image utility service.
     * @param {Object} $rootScope - The root scope object.
     * @param {Object} ProductAPIService - The product API service.
     * @param {Object} $mdDialog - The dialog service.
     * @param {Object} blockUI - The block UI service.
     * @param {Object} TestImageService - The test image service.
     * @param {Object} ColorSamplerService - The color sampler service.
     * @param {Object} DynamicVectorService - The dynamic vector service.
     * @param {Object} DynamicImageService - The dynamic image service.
     * @param {Object} MultipleFileUploadService - The multiple file upload service.
     * @param {Object} CanvasUtilService - The canvas utility service.
     * @param {Object} LibrariesUtilService - The libraries utility service.
     * @param {Object} LibrariesAPIService - The libraries API service.
     * @param {Object} TextService - The text service.
     * @param {Object} ElementsColorService - The elements color service.
     * @param {Object} ConfigService - The configuration service.
     * @param {Object} ExecutionService - The execution service.
     * @param {Object} RemoveBgService - The Remove.bg API service.
     * @param {Object} CustomilyRmbgService - The Customily Remove Background service.
     * @param {Object} CustomilyFaceCutOutService - The Customily Face Cut service.
     * @param {Object} CustomilyImageFilterService - The Customily Image Filter service.
     * @param {Object} VectorUtilService - The vector utility service.
     * @param {Object} QrUtilService - The QR utility service
     * @param {Object} MelcoAPIService - The Melco API service.
     * @param {Object} CutoutProUtilService - The Cutout Pro utility service.
     * @param {Object} ImageFilterManagerService - The image filter manager service.
     * @param {Object} MdDialogService - The Material dialog service.
     */
    function createStepOneCtrl(
        $scope,
        $timeout,
        $location,
        $q,
        $mdToast,
        $interval,
        $window,
        FontManagerService,
        MultipleFontService,
        ProductService,
        ImageUtilService,
        $rootScope,
        $sce,
        ProductAPIService,
        $mdDialog,
        blockUI,
        TestImageService,
        ColorSamplerService,
        DynamicVectorService,
        DynamicImageService,
        MultipleFileUploadService,
        TextureService,
        CanvasUtilService,
        LibrariesUtilService,
        LibrariesAPIService,
        TextService,
        ElementsColorService,
        ConfigService,
        ExecutionService,
        RemoveBgService,
        CustomilyRmbgService,
        CustomilyFaceCutOutService,
        CustomilyImageFilterService,
        VectorUtilService,
        QrUtilService,
        MelcoAPIService,
        CutoutProUtilService,
        ImageFilterManagerService,
        MdDialogService,
        DesignStudioSaveService,
        OpenAIService,
        CrosswordService,
        UsersAPIService,
        SpotifyService,
        AuthService,
        TemplatePermissionsService
    ) {
        $rootScope.headerMode = 'single';
        $rootScope.showTemplateResizeBtn = true;

        // Template permissions
        $scope.canSave = true;
        $scope.saveDisabledText = '';

        // Default page dimension in millimeters
        $scope.page = {
            pageWidthDim: 100,
            pageHeightDim: 100,
            productName: 'Sample Template',
            fromImage: null,
            exportFormat: 'png',
            exportColorMode: 'rgb',
            mergeOutput: false,
            MergeFiles: false,
            referenceId: null,
            layoutOptimization: true,
            measureUnit: ''
        };

        $scope.showPreviewBackgroundModal = false;

        $scope.isImageEffectsEnabled = process.env.VUE_APP_IMAGE_EFFECTS_ENABLED === 'true';

        $scope.pageDimensions = [];

        const { getColorObj } = useColor();
        const { init: initGroupManager, get: getGroupManager } = useGroupManager();

        const updatePageDimensions = (id, newWidth, newHeight) => {
            const pageDim = $scope.pageDimensions?.[id - 1];
            if (!pageDim || newWidth != pageDim.width || newHeight != pageDim.height) {
                const newVal = JSON.parse(JSON.stringify($scope.pageDimensions));
                newVal[id - 1] = {
                    width: newWidth,
                    height: newHeight
                };
                $scope.pageDimensions = newVal;
            }
        };

        const deletePageDimensions = (id) => {
            const newVal = $scope.pageDimensions.filter((_, i) => i != id - 1);
            $scope.pageDimensions = JSON.parse(JSON.stringify(newVal));
        };

        $scope.$watch('pageDimensions.length', function (newLen) {
            if (newLen <= 1) {
                $scope.page.MergeFiles = false;
            }
        });

        $scope.$watch('beforeMergeProduct', function (newValue) {
            $scope.isPreMergeFlow = !!newValue;
        });

        $scope.MAX_IMAGE_SIZE = ConfigService.MAX_PREVIEW_IMAGE_SIZE;
        $scope.isPreMergeFlow = false;
        $scope.beforeMergeDesignsToBeProcessed = [];
        $scope.beforeMergePreviews = [];
        $scope.beforeMergeOriginalPrintAreas = {};
        $scope.beforeMergeDefaultPreviewId = null;
        $scope.beforeMergeActivePreviewId = null;
        $scope.beforeMergeIsDefaultActive = true;
        $scope.beforeMergeEditingPrintAreaId = null;
        $scope.beforeMergeAdjustedDeltas = null;
        $scope.beforeMergeProduct = $rootScope.beforeMergeProduct ?? null;
        $scope.defaultCrosswordText = 'customily,crossword,example';
        $scope.beforeMergeNextPath = '/store/podSelection';
        $scope.designTitle = '';
        let colorModeChanged = false;
        $scope.skipTemplateExitAlert = false;
        $scope.canEditId = false;
        $scope.pngPpiError = false;
        $scope.hasPrintAreaElements = false;
        $scope.hasMetaFilteredImages = false;
        $scope.hasTextToImage = false;
        $scope.previewMode = $location.$$path == '/createProduct3';
        $scope.childTemplateProduct = ProductService.getChildTemplateProduct();
        $scope.childTemplateProductParentId = $location.search().parentId;
        $scope.isChildTemplateProduct = $scope.childTemplateProduct && $scope.childTemplateProduct.parentId;
        $scope.editMode = $scope.isChildTemplateProduct ? false : ProductService.getProduct().id != '';
        $scope.pod = $scope.editMode ? $location.search().pod : '';
        $scope.productGuidPromise = $scope.editMode
            ? Promise.resolve(ProductService.getProduct().id)
            : ProductAPIService.generateProductGUID();
        $scope.colorSamplerActive = false;
        $scope.isBackgroundEPS = false;
        // We use this flag to indicate whether or not the user updated the reference image when editing the product
        $scope.reloadedNonEPSBaseImage = false;
        $scope.showBaseFileReplace = false;
        $scope.showPodProductAssignerModal = false;
        $scope.showVariantsConfiguratorModal = false;
        $scope.showProductSpecsModal = false;

        $scope.atLeastOneTexturedElement = false;
        $scope.atLeastOneTextWithShadow = false;
        $scope.melcoTextIds = [];
        $scope.melcoIsValidId = true;
        $scope.hasWilcomCredentials = false;
        UsersAPIService.getMe().then(function (user) {
            $scope.hasWilcomCredentials = !!user.HasWilcomCredentials;
        });
        $scope.forMyDesigns = !!$location.search().forMyDesigns;
        $scope.isImportedDesign = !!$location.search().imported;
        $scope.fromProductView = $location.search().designedFor?.length;
        $rootScope.shProduct = $scope.fromProductView
            ? {
                  id: $location.search().designedFor.split('+:#')[0],
                  name: $location.search().designedFor.split('+:#')[1]
              }
            : null;
        $scope.beforeMergeCreateDesignHeaderName = $rootScope.productBuilderDesign?.title || null;
        $scope.fromListing = !!$location.search().fromListing || false;
        // Canvas properties
        $scope.DPI = 300;
        $scope.exportPPI = 300;
        const minCanvasSize = 1024;
        const maxCanvasSize = 1024;
        $scope.elementAlignType = 'selection';
        let canvasWidth = 0;
        let canvasHeight = 0;
        let canvas = null;

        // Base EPS
        let baseImagePath = '';
        let baseEPSPath = '';
        let baseImageToUpload = null;

        let baseImageToUploadEPS = [];

        // Library names
        $scope.selectedColorLibraryName = '';
        $scope.selectedFontLibraryName = '';
        $scope.selectedImageLibraryName = '';
        $scope.selectedVectorLibraryName = '';

        $scope.selectedSpotifyPlayer = null;
        $scope.textAsMaskStoredObjects = {};

        // Text
        $scope.textSelected = null;
        $scope.selectedTextProperties = {
            text: '',
            centerX: 0,
            centerY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            minSizePx: 0,
            maxSizePx: 0,
            multiline: false,
            verticalText: false,
            caps: false,
            fontPath: '',
            fontName: '',
            color: '#000000',
            id: 0,
            currentFontSize: 0,
            outlineWidth: 0,
            textAlign: 'center',
            textVerticalAlign: 'center',
            fontOption: 0,
            fontColorOption: 1,
            fontsMap: null,
            fontColorsMap: null,
            outlineColorsMap: null,
            outlineColorOption: 1,
            tracking: 0,
            lineSpacing: 0,
            skewX: 0,
            skewY: 0,
            startAngle: 0,
            endAngle: 0,
            locked: true,
            prefix: '',
            suffix: '',
            betweenCharacters: '',
            betweenWords: '',
            referenceId: null,
            flipX: false,
            flipY: false,
            textureScale: 100,
            allowEdit: false,
            isPersonalizableText: true,
            useAsMask: false,
            useAsCutout: false,
            autofillSource: '',
            dateFormat: {},
            shadowType: null,
            shadowOffset: 0,
            shadowAngle: 0,
            shadowBlur: 0,
            shadowColorsMap: null,
            shadowColorOption: 1,
            sourceElement: null
        };
        $scope.canvaModalImportData = null;
        $scope.showFontsReplacementMatcherModal = false;
        $scope.fontsReplacementMatcherModalIsLoading = false;
        $scope.fonts = [];
        $scope.textures = [];
        $scope.crosswordTextures = [];
        //maxFontsToRenderInDropdown limits the number of fonts that we donwload from the server.
        //If the user has over maxFontsToRenderInDropdown fonts, it will just render Arial as the font family on the font dropdown.
        $scope.maxFontsToRenderInDropdown = fontManagerService.maxFontsToDownload;

        // Images
        $scope.imageSelected = null;
        $scope.selectedImageProperties = {
            centerX: 0,
            centerY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            id: 0,
            fullColor: true,
            grading: false,
            hasStaticImage: false,
            dynamicImageVariation: 1,
            dynamicImagesPath: null,
            colorPosition: 1,
            hasMask: false,
            rotationLock: false,
            coverMaskArea: false,
            removeWhiteBackground: false,
            RemoveBackground: false,
            CutoutFace: false,
            removeBackgroundCOP: false,
            CustomilyRemoveBackground: false,
            CustomilyFaceCutOut: false,
            CustomilyImageFilter: 0,
            isPencilDrawingActive: false,
            isAquaFilterActive: false,
            textToImage: false,
            imageToImage: false,
            imageToImageConfig: null,
            imageEffects: null,
            locked: true,
            flipX: false,
            flipY: false,
            isLimitImageToPlaceholder: false,
            lockMovement: false,
            lockScaling: false,
            allowEdit: false,
            CrosswordConfig: null,
            calendarConfig: null,
            outlineColor: null,
            outlineWidth: 0,
            allowSwapLibraryPosition: false,
            limitMovement: false,
            hasTextMask: false
        };

        $scope.selectedMapProps = {
            defaultStyle: MAP_STYLE_PRESETS[0].value,
            hasPin: false,
            // latitude, logitude and zoom for global map view
            latitude: 17.9,
            longitude: -37.34,
            coordinates: '-37.34, 17.90',
            availableMapStyles: MAP_STYLE_PRESETS
        };

        $scope.mapElements = null;

        $scope.starMapGeocoder = null;

        $scope.selectedStarMapProps = {
            availableStarMapStyles: starMapUtils.STAR_MAP_STYLES.map((style) => JSON.parse(angular.toJson(style)))
        };

        $scope.starMapElements = null;

        $scope.imageColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.bulkEditImageColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.imageOutlineColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.calendarTitleColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.calendarMarkerColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.calendarHighlightedColorPicker = ColorSamplerService.createEmptyColorPicker();

        $scope.apiKeys = {
            removeBg: null,
            cutoutPro: null,
            openAi: null
        };
        $scope.showApiKeyInput = {
            removeBg: false,
            cutoutPro: false,
            openAi: false
        };

        $scope.filteredFonts = $scope.fonts;
        $scope.searchFont = {
            selectedText: '',
            previousSelectedText: '',
            previousSelectedValue: '',
            searchText: ''
        };

        $scope.creditsSelected = false;

        // Warning
        $scope.showMultiEpsAlertWarning = false;

        // SVG Group
        $scope.svgSelected = null;
        $scope.selectedSVGProperties = {
            centerX: 0,
            centerY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            id: 0,
            position: 1,
            allowUserUpload: false,
            colorPosition: 1,
            applyColoring: false,
            isSolidBackground: false,
            rotationLock: false,
            coverMaskArea: false,
            locked: true,
            flipX: false,
            flipY: false,
            allowEdit: false,
            allowSwapLibraryPosition: false
        };
        $scope.hasSelectedElement = false;
        $scope.hasLockedSelectedElement = false;
        $scope.layersInstance = null;
        $scope.groupsSelected = [];
        $scope.undoManager = null;
        $scope.isLoadingProduct = true;

        // Selected Object Group
        $scope.selectedObjectGroup = null;
        $scope.selectedObjectGroupProperties = {
            centerX: 0,
            centerY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            locked: true,
            objectCount: 0
        };
        $scope.bulkEditDefaultProperties = {
            id: undefined,
            isIdMixed: false,
            centerX: 0,
            isCenterXMixed: false,
            centerY: 0,
            isCenterYMixed: false,
            rotation: 0,
            isRotationMixed: false,
            width: 0,
            isWidthMixed: false,
            height: 0,
            isHeightMixed: false,
            locked: true,
            objectCount: 0,
            skewX: 0,
            isSkewXMixed: false,
            skewY: 0,
            isSkewYMixed: false,
            imageType: undefined,
            hasMask: false,
            coverMaskArea: false,
            isLimitImageToPlaceholder: false,
            lockMovement: false,
            lockScaling: false,
            rotationLock: false,
            RemoveBackground: undefined,
            removeBackgroundCOP: false,
            CustomilyRemoveBackground: false,
            CustomilyFaceCutOut: false,
            CustomilyImageFilter: 0,
            isPencilDrawingActive: false,
            isAquaFilterActive: false,
            CutoutFace: false,
            textToImage: false,
            imageToImage: false,
            imageToImageConfig: null,
            imageEffects: null,
            fullColor: false,
            grading: false,
            colorPosition: undefined,
            isColorPositionMixed: undefined,
            colorLibraryId: undefined,
            isColorLibraryIdMixed: undefined,
            selectedColor: undefined,
            color: '#000000',
            currentFontSize: 0,
            isCurrentFontSizeMixed: false,
            text: '',
            isTextMixed: false,
            dynamicImageVariation: undefined,
            isDynamicImageVariationMixed: false,
            imageLibraryId: undefined,
            isImageLibraryIdMixed: false,
            position: undefined,
            isPositionMixed: false,
            vectorLibraryId: undefined,
            isVectorLibraryIdMixed: false,
            fontPath: '',
            fontLibraryId: undefined,
            isFontLibraryIdMixed: false,
            fontOption: undefined,
            isFontOptionMixed: false,
            minSizePx: undefined,
            isMinSizePxMixed: false,
            maxSizePx: undefined,
            isMaxSizePxMixed: false,
            tracking: undefined,
            isTrackingMixed: false,
            lineSpacing: 1,
            isLineSpacingMixed: false,
            containsAllowUserUpload: false,
            containsDynamicImagesPath: false,
            containsMapConfig: false,
            containsStarMapConfig: false,
            allowEdit: false,
            allowSwapLibraryPosition: false,
            limitMovement: false,
            fontColorsMap: new Set(),
            containsQrConfig: false
        };
        $scope.bulkEdit = {
            enabled: false,
            type: '',
            selectedProperties: { ...$scope.bulkEditDefaultProperties },
            showImagePlaceholder: false,
            showDynamicImage: false,
            showMap: false,
            showTextBox: false,
            showPathIText: false,
            showVectorPlaceholder: false,
            showDynamicVector: false,
            showStarMap: false,
            showQr: false
        };
        $scope.resetBulkEdit = () => {
            $scope.bulkEdit.enabled = false;
            $scope.bulkEdit.type = '';
            $scope.bulkEdit.selectedProperties = { ...$scope.bulkEditDefaultProperties };
            $scope.bulkEdit.showImagePlaceholder = false;
            $scope.bulkEdit.showDynamicImage = false;
            $scope.bulkEdit.showMap = false;
            $scope.bulkEdit.showTextBox = false;
            $scope.bulkEdit.showPathIText = false;
            $scope.bulkEdit.showVectorPlaceholder = false;
            $scope.bulkEdit.showDynamicVector = false;
            $scope.bulkEdit.showStarMap = false;
            $scope.bulkEdit.showQr = false;
        };

        $scope.forProductTemplateCreation = !!$location.search().forProductTemplateCreation;
        $scope.forDesignTemplateCreation = !!$location.search().forDesignTemplateCreation;
        $scope.forDesignFromCanva = !!$location.search().forDesignFromCanva;
        $scope.isUserDesignCreation = !!$location.search().forUserDesignCreation;
        $scope.createDesignOnTemplate = !!$location.search().createDesignOnTemplate;
        $scope.forMyProductBases = !!$location.search().forMyProductBases;
        $scope.enablePageEpsForPods = !!$location.search().enablePageEpsForPods;
        $scope.templateId = $location.search().templateId;
        $scope.dimensionsModalSubmittedData = null;

        $scope.isPrintfulOrPrintify = $location.search().pod === 'Printful' || $location.search().pod === 'Printify';
        $scope.enablePageEps =
            $scope.isPrintfulOrPrintify ||
            $scope.enablePageEpsForPods ||
            $scope.forMyProductBases ||
            !(
                $scope.isUserDesignCreation ||
                $scope.createDesignOnTemplate ||
                $scope.forDesignTemplateCreation ||
                $scope.forMyDesigns
            );

        $scope.canAddAnotherFile = function () {
            return ($scope.enablePageEps || $scope.hasPODRole) && !$scope.isChildTemplateProduct;
        };

        $rootScope.showCreatePageEpsBtn = $scope.canAddAnotherFile();
        $scope.previousPageEpsSelect = null;
        $scope.currentPageEpsSelect = null;
        $scope.maxEpsId = 0;
        $scope.printAreaImageUrl = require('@/assets/images/print-area-customily.png');
        $scope.currentSizeIsLessThanMinSize = false;
        $scope.enableViewLayoutOptimization =
            $rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes('admin', 'admin-ui') ||
            $rootScope?.user?.UserImpersonatedFromId;
        $scope.showCreateTextPathDraw = $rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes(
            'admin',
            'admin-ui',
            'show-create-text-path-draw'
        );

        $scope.isModalImportErrorOpen = false;
        $scope.modalImportErrorMessage = '';
        $scope.modalImportErrorDescription = 'Something went wrong while uploading the PSD file.';

        $scope.isModalInitializeErrorOpen = false;
        $scope.modalInitializeErrorMessage = '';
        $scope.modalInitializeErrorDescription = 'Something went wrong while initializing.';

        //This is the creation of a template (not a design or a template product)
        $scope.isTemplateCreation =
            !$scope.isUserDesignCreation &&
            !$scope.createDesignOnTemplate &&
            !$scope.forDesignTemplateCreation &&
            !$scope.forMyDesigns &&
            !$scope.forProductTemplateCreation;

        $scope.provider = undefined;

        const skipSaveTestingValues = $rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes(
            'skip-save-testing-values'
        );

        $scope.isGroupSelected = function () {
            if ($scope.isUserDesignCreation && !$scope.previewMode) {
                // If user is modifying a design all element should be treated as a group
                return true;
            } else {
                return canvas.getActiveObjects().length > 1;
            }
        };

        $scope.isValidLayoutPosition = function () {
            if (!$scope.page.layoutOptimization) return true;
            const mgr = getGroupManager();
            return mgr?.areGroupsPositionsValid('eps', true) ?? true;
        };

        $scope.$watch('layersInstance', (instance) => {
            $scope.layersInstance = instance;
        });

        $scope.$watch('enableGroups', () => {
            if (canvas) {
                canvas.set('enableGroups', $rootScope.enableGroups);
            }
        });

        $scope.$watch('enablePageEps', () => {
            if (canvas) {
                canvas.set('enablePageEps', $scope.enablePageEps);
            }
        });

        $scope.layersElementLockToggle = function (data) {
            if ($rootScope.isManagedUser && !$rootScope.user.UserImpersonatedFromId) return;
            toggleElementLock(data.element, canvas);

            const object = canvas.getActiveObject();
            if (object) {
                object.fire('modified');
            }

            $timeout(() => $scope.$apply());
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersElementVisibilityToggle = function (data) {
            toggleElementVisibility(data.element, canvas);
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersElementPrintAreaToggle = function (data) {
            toggleElementPrintArea(data.element, canvas);
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersElementOverlayToggle = function (data) {
            toggleElementOverlay(data.element, canvas);
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersTitleChange = function (data) {
            if ($scope.editMode && data.element.setEditedProp) {
                data.element.setEditedProp?.('name');
            }
            focusCanvas(canvas);
        };

        $scope.layersSourceElementLinked = function (data) {
            const { element, sourceElement, valueFormat, sourceType } = data;
            if (!element || !sourceElement || !valueFormat || !sourceType) return;

            canvas.addLinkElements(sourceElement.uuid, element, sourceType, valueFormat, true);

            sourceElementUtils.setTargetFromSource(sourceElement, element, valueFormat);
        };

        $scope.layersSourceElementUnlinked = function (data) {
            const { element, removedSourceId } = data;
            if (!element || !removedSourceId) return;

            canvas.removeLinkElement(removedSourceId, element.uuid);

            if (element.type === 'bounded-text') {
                element.setText('A');
            }
        };

        $scope.layersPositionChange = function () {
            setTimeout(() => {
                $scope.$apply();
            }, 100);
        };

        if ($scope.forDesignTemplateCreation) {
            $rootScope.headerTitleRight = 'Design settings';
        }

        $rootScope.$watch('user', async (user) => {
            if (!user) return;
            $scope.apiKeys = {
                removeBg: user.RemoveBgAPIKey,
                cutoutPro: user.CutoutproAPIKey,
                openAi: user.OpenAiAPIKey
            };

            $scope.enableViewLayoutOptimization =
                $rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes('admin', 'admin-ui') ||
                $rootScope?.user?.UserImpersonatedFromId;
            $scope.hasPODRole = $rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes('external-pod');

            $scope.showCreateTextPathDraw = $rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes(
                'admin',
                'admin-ui',
                'show-create-text-path-draw'
            );

            $rootScope.showCreatePageEpsBtn = $scope.canAddAnotherFile();
        });

        const conversionMethod = {
            inch: mmToInches,
            px: mmToPixels
        };

        $scope.$watchGroup(
            ['page.pageWidthDim', 'page.pageHeightDim', 'page.productName', 'page.measureUnit'],
            function (/* newVal, oldVal */) {
                if (!$scope.previewMode) {
                    const unit = $scope.page.measureUnit || 'mm';
                    const width =
                        conversionMethod[unit]?.($scope.page.pageWidthDim, $scope.DPI) || $scope.page.pageWidthDim;
                    const height =
                        conversionMethod[unit]?.($scope.page.pageHeightDim, $scope.DPI) || $scope.page.pageHeightDim;
                    const title = `${$scope.page.productName}: ${Number(width).toFixed(2)}x${Number(height).toFixed(
                        2
                    )} ${unit}`;
                    $rootScope.headerMode = 'dual';
                    $rootScope.headerTitleLeft = title;
                }
            }
        );

        $scope.$watchGroup(
            ['exportPPI', 'page.pageWidthDim', 'page.pageHeightDim', 'page.exportFormat'],
            function (/* newValues, oldValues */) {
                // If the resulting exported PNG image would be bigger than 16000px don't allow exporting as PNG
                if ($scope.page.exportFormat === 'png' || $scope.page.exportFormat === 'jpg') {
                    const hPixels = mmToPixels($scope.page.pageWidthDim, $scope.exportPPI);
                    const vPixels = mmToPixels($scope.page.pageHeightDim, $scope.exportPPI);

                    if (hPixels > 16000 || vPixels > 16000) {
                        $scope.pngPpiError = true;
                    } else {
                        $scope.pngPpiError = false;
                    }
                } else {
                    $scope.pngPpiError = false;
                }
            }
        );

        $scope.$watchGroup(['page.layoutOptimization'], function (/* newValues, oldValues */) {
            if ($scope.isLoadingProduct) return;
            const mgr = getGroupManager();
            if ($scope.page.layoutOptimization) {
                mgr?.assignMissingPositions(true);
            }
            $scope.$applyAsync(() => {});
        });
        $scope.$watch('page.mirror', function (newVal /* , oldVal */) {
            if (!canvas) return;
            const pageEps = canvas.getFirstActivePageEps();
            canvas.updatePageEps(pageEps, {
                mirror: newVal
            });
        });

        $scope.$watch('page.mergeOutput', function (newVal /* , oldVal */) {
            if (!canvas) return;
            const pageEps = canvas.getFirstActivePageEps();
            canvas.updatePageEps(pageEps, {
                mergeOutput: newVal
            });
        });

        $scope.$watchGroup(['svgSelected', 'imageSelected', 'textSelected'], function () {
            $scope.canEditId = false;

            if ($scope.svgSelected && $scope.svgSelected.uuid) {
                $scope.canEditId = true;
            }
            if ($scope.imageSelected && $scope.imageSelected.uuid) {
                $scope.canEditId = true;
            }
            if ($scope.textSelected && $scope.textSelected.uuid) {
                $scope.canEditId = true;
            }
        });

        $scope.updateHasPrintAreaElements = function () {
            if (canvas) {
                const listEps = ProductService.getListEPS();

                if ($scope.enablePageEps) {
                    //Every file has at least one print area
                    $scope.hasPrintAreaElements = listEps.every((e) =>
                        canvas.getObjects().some((o) => o.isPrintArea && o.pageEpsId === e.id)
                    );

                    //If the product base is multi print area, we cannot add more files
                    const printAreasCount = canvas.getObjects().filter((o) => o.isPrintArea).length;
                    if (
                        $scope.forMyProductBases &&
                        !$scope.isChildTemplateProduct &&
                        $scope.getCountListPageEps() === 1
                    ) {
                        if (printAreasCount === 1) {
                            $rootScope.showCreatePageEpsBtn = $scope.canAddAnotherFile();
                        } else {
                            $rootScope.showCreatePageEpsBtn = false;
                        }
                    }
                } else {
                    $scope.hasPrintAreaElements = canvas.getObjects().some((o) => o.isPrintArea);
                }
                $scope.$applyAsync(() => {});
            }
        };

        $scope.$on('template:resize-btn-click', () => {
            $scope.resizePage();
        });

        $scope.$on('template:create-page-eps-btn-click', () => {
            $scope.openModalgPageEps();
        });

        $scope.$on('template:product-specs-btn-click', () => {
            $scope.openProductSpecModal();
        });

        $scope.showBlockUiLoader = function (active, message = 'Loading...') {
            $scope.$evalAsync(() => {
                if (!active) {
                    blockUI.stop();
                    return;
                }

                if (blockUI.state().blocking) {
                    blockUI.message(message);
                    return;
                }

                blockUI.start(message);
            });
        };

        $scope.onProductSpecModalClose = function () {
            $scope.showProductSpecsModal = false;
        };

        $scope.openProductSpecModal = function () {
            $scope.showProductSpecsModal = true;
        };

        $scope.onProductSpecSelect = function (productGuideData) {
            $scope.onProductSpecModalClose();
            const { epsDPI, epsHeight, epsWidth, imageGuide, imageGuidePath } = productGuideData;

            let newExportPPI = $scope.getMaxDefaultExportResolution(epsWidth, epsHeight, epsDPI, true);
            $scope.setExportPPI(newExportPPI);

            $scope.pageDimensionsEntered(true, false);

            let pageEps = canvas.getFirstActivePageEps();

            if (!pageEps) {
                canvas.setActiveFirstPageEps(true);
                pageEps = canvas.getFirstActivePageEps() ?? $scope.createPageEps(1000, 1000, 300);
            }

            $scope.page.pageWidthDim = pixelsToMm(epsWidth, epsDPI);
            $scope.page.pageHeightDim = pixelsToMm(epsHeight, epsDPI);
            $scope.DPI = epsDPI;
            $scope.pageDimensionsEntered(true, false);
            canvas.updatePageEps(
                pageEps,
                {
                    width: epsWidth,
                    height: epsHeight,
                    dpi: epsDPI,
                    baseEps: '',
                    baseImage: '',
                    exportPPI: $scope.exportPPI
                },
                true
            );

            CanvasUtilService.scaleCanvasElementsForPreview(canvas, canvas.getObjects(), pageEps?.id, false, false);

            const existingGuideline = canvas.getObjects().find((obj) => obj.isProductGuidelines);
            if (existingGuideline) {
                canvas.remove(existingGuideline);
            }

            if (imageGuide) {
                const productGuidelines = DynamicImageService.createDynamicImage(canvas, 1, {
                    ...imageGuide,
                    isProductGuidelines: true,
                    name: 'Product Guidelines',
                    dynamicImagesPath: imageGuidePath,
                    zIndex: 1
                });
                productGuidelines.addedOnEdit = false;

                if ($scope.editMode) {
                    productGuidelines.addedOnEdit = true;
                }

                for (const element of canvas.getObjects()) {
                    element.id++;
                    element.zIndex++;
                    canvas.moveTo(element, element.zIndex);
                }

                canvas.add(productGuidelines);
                canvas.renderAll();
                const canvasObjectsZindexes = canvas.getObjects().map((item) => item.zIndex);
                const minZindex = Math.min(...canvasObjectsZindexes);
                productGuidelines.zIndex = minZindex - 1;
                canvas.moveTo(productGuidelines, productGuidelines.zIndex);
                canvas.setActiveObject(productGuidelines, null);
                DynamicImageService.showDynamicImage(canvas, canvas.getActiveObject(), 1);
            }
        };

        $scope.getLastElementId = function () {
            if (canvas) {
                const lastElementId = _.max(canvas.getObjects(), (o) => o.id).id || 0;
                const lastPreviewId = ProductService.getLastPreviewId();

                return Math.max(lastElementId, lastPreviewId);
            }
            return 0;
        };

        $scope.getMaxDefaultExportResolution = function (mmWidth, mmHeight, exportPPI, isAlreadyInPixels = false) {
            let hPixels = mmWidth;
            let vPixels = mmHeight;

            if (!isAlreadyInPixels) {
                hPixels = mmToPixels(mmWidth, exportPPI);
                vPixels = mmToPixels(mmHeight, exportPPI);
            }

            if (hPixels > 16000 || vPixels > 16000) {
                if (exportPPI > 150) {
                    return $scope.getMaxDefaultExportResolution(mmWidth, mmHeight, 150);
                } else if (exportPPI > 72) {
                    return $scope.getMaxDefaultExportResolution(mmWidth, mmHeight, 72);
                } else {
                    return exportPPI;
                }
            }

            return exportPPI;
        };

        // Load fonts on startup
        $scope.loadFonts = async function () {
            try {
                // Init the fonts by making sure the default font will be available
                const fonts = await fontManagerService.initFonts();
                $scope.fonts = fonts;

                // Render the canvas again when fonts are loaded
                if (canvas) {
                    canvas.requestRenderAll();
                }
            } catch (error) {
                window.rumReportError(error);
                throw error;
            }
        };

        async function openDesignNameModal(initialName = 'Sample Design') {
            return $mdDialog.show({
                controller: 'DesignNameModalCtrl',
                template: require('../../../../views/pages/create-product/designNameModal.html'),
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: { initialName }
            });
        }

        async function openPageDimensionsModal(options) {
            const {
                mode = 'create',
                initialWidth,
                initialHeight,
                title = null,
                exportPPI,
                initialUnit = null
            } = options;
            return $mdDialog.show({
                controller: 'PageDimensionsModalCtrl',
                template: require('../../../../views/pages/create-product/pageDimensionsModal.html'),
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: { mode, initialWidth, initialHeight, title, exportPPI, initialUnit }
            });
        }

        async function applyPageResize(dialogPage, opts = {}) {
            if (!dialogPage) return;

            const { pageEps } = opts;
            const { pageWidthDim, pageHeightDim, pageDPI } = dialogPage;

            const desiredExportPPI = $scope.getMaxDefaultExportResolution(pageWidthDim, pageHeightDim, pageDPI);

            const dpi = $scope.isChildTemplateProduct ? $scope.DPI : pageDPI;
            const targetPxW = mmToPixels(pageWidthDim, dpi);
            const targetPxH = mmToPixels(pageHeightDim, dpi);

            $scope.setExportPPI(desiredExportPPI);

            if (pageEps) {
                canvas.setActivePageEps(pageEps, true);
                canvas.updatePageEps(
                    pageEps,
                    { width: targetPxW, height: targetPxH, exportPPI: $scope.exportPPI },
                    true
                );
            }

            $scope.manualTemplateProductResize(dialogPage);
            $scope.pageDimensionsEntered(true, false);

            const elementsToResize = canvas
                .getObjects()
                .filter(
                    (image) =>
                        (image.isPrintArea || image.isProductGuidelines) && (!pageEps || image.pageEpsId === pageEps.id)
                );

            for (const element of elementsToResize) {
                $scope.updateWidth(pageWidthDim, element);
                $scope.updateHeight(pageHeightDim, element);
                element.set({ ...canvas.getCenter() });
            }

            canvas.requestRenderAll();
        }

        async function resizeAllEpsWithModal(options = {}) {
            const { titlePrefix = 'Create' } = options;

            const epsList = ProductService.getListEPS?.() || [];
            if (!Array.isArray(epsList) || epsList.length === 0) return;

            const isMultiFile = epsList.length > 1;

            for (const eps of epsList) {
                $scope.showBlockUiLoader(false);
                let initialUnit = null;
                let initialWidth = null;
                let initialHeight = null;
                const savedTemplatesLength = $scope.childTemplateProduct?.savedTemplates?.length || 0;
                if (savedTemplatesLength) {
                    const { dimension } = $scope.childTemplateProduct.savedTemplates[savedTemplatesLength - 1];
                    initialUnit = dimension?.unit || null;
                    initialWidth = dimension?.width || null;
                    initialHeight = dimension?.height || null;
                }
                const dialogResult = await openPageDimensionsModal({
                    mode: 'create',
                    initialWidth: initialWidth || pixelsToMm(eps.width, eps.dpi),
                    initialHeight: initialHeight || pixelsToMm(eps.height, eps.dpi),
                    title: isMultiFile ? `${titlePrefix} ${eps.name}` : null,
                    exportPPI: $scope.exportPPI,
                    initialUnit
                });
                $scope.showBlockUiLoader(true, 'Resizing...');

                const pageEps = canvas.getPageEpsById(eps.id);

                await applyPageResize(dialogResult.page, { pageEps });

                eps.width = mmToPixels(dialogResult.page.pageWidthDim, dialogResult.page.pageDPI);
                eps.height = mmToPixels(dialogResult.page.pageHeightDim, dialogResult.page.pageDPI);
                eps.measureUnit = dialogResult.page.submittedData.unit;
            }

            $scope.showBlockUiLoader(false);
        }

        $scope.initializeCanvas = async function (firstLoad = false) {
            try {
                $scope.$applyAsync(() => {});
                const { fetchTemplate, getPodProvider } = useDesignStudio({
                    forProductTemplateCreation: $scope.forProductTemplateCreation,
                    forMyProductBases: $scope.forMyProductBases,
                    forDesignTemplateCreation: $scope.forDesignTemplateCreation,
                    isChildTemplateProduct: $scope.isChildTemplateProduct,
                    pod: $scope.pod,
                    previewMode: $scope.previewMode
                });

                const templateId = $location.search().templateId;
                const shouldLoadProduct = !!templateId && ProductService.getProduct()?.id !== templateId;
                if (!$scope.previewMode && $rootScope.productBuilderDesign) {
                    try {
                        ProductService.clearProduct();
                        $scope.showBlockUiLoader(true, 'Loading data...');

                        const designName = $rootScope.productBuilderDesign.title || 'New Design';
                        $scope.pageDimensionsEntered(false, false);
                        $scope.page.productName = designName;
                        $scope.page.pageWidthDim = 1000;
                        $scope.page.pageHeightDim = 1000;
                        $scope.page.MergeFiles = false;
                        $scope.designTitle = designName;
                        $rootScope.showTemplateResizeBtn = false;
                        $scope.showBaseFileReplace = false;
                        $scope.isLoadingProduct = false;

                        if ($scope.enablePageEps) {
                            $scope.createPageEps(1000, 1000, 300);
                        }
                        $scope.pageDimensionsEntered(true, false);

                        // First EPS by default (epsId omitted → backend returns the product's default EPS).
                        const productGuideData = await getGuideSpecs($rootScope.productBuilderDesign.templateId);
                        $scope.onProductSpecSelect(productGuideData);
                    } catch (error) {
                        window.rumReportError(error);
                    } finally {
                        $scope.showBlockUiLoader(false);
                    }
                } else if (!$scope.previewMode && $scope.forDesignTemplateCreation && !templateId && !$scope.designTitle) {
                    try {
                        ProductService.clearProduct();
                        let designName = 'Sample Design';
                        let openProductSpecsModal = false;
                        if (!$scope.forDesignFromCanva) {
                            const { name, openProductSpecsModal: openModal } = await openDesignNameModal(
                                'Sample Design'
                            );
                            designName = name;
                            openProductSpecsModal = openModal;
                        }

                        $scope.showBlockUiLoader(true, 'Loading data...');

                        $scope.pageDimensionsEntered(false, false);
                        $scope.page.productName = designName;
                        $scope.page.pageWidthDim = 1000;
                        $scope.page.pageHeightDim = 1000;
                        $scope.page.MergeFiles = false;
                        $scope.designTitle = designName;
                        $rootScope.showTemplateResizeBtn = true;
                        // Don't show the base file replace button
                        $scope.showBaseFileReplace = false;
                        $scope.isLoadingProduct = false;

                        if ($scope.enablePageEps) {
                            $scope.createPageEps(1000, 1000, 300);
                        }

                        $scope.pageDimensionsEntered(true, false);

                        if (openProductSpecsModal) {
                            $scope.showProductSpecsModal = true;
                        }
                    } finally {
                        $scope.showBlockUiLoader(false);
                    }
                } else if (
                    !$scope.previewMode &&
                    $scope.forMyProductBases &&
                    $scope.forProductTemplateCreation &&
                    !templateId &&
                    !$scope.fromListing
                ) {
                    try {
                        const printAreaImageUrl = require('@/assets/images/print-area-customily.png');
                        $scope.pageDimensionsEntered(false, false);
                        $scope.showBlockUiLoader(false);
                        const data = await openPageDimensionsModal({
                            mode: 'create',
                            initialWidth: $scope.page.pageWidthDim,
                            initialHeight: $scope.page.pageHeightDim,
                            title: null,
                            exportPPI: $scope.exportPPI
                        });
                        $scope.showBlockUiLoader(true, 'Loading data...');
                        const page = data.page;

                        const myProductBasesPod = await getMyProductBasesPod();
                        ProductService.setPod({
                            id: myProductBasesPod.id,
                            apiKeyReference: '',
                            isUserPod: myProductBasesPod.isUserPod
                        });

                        await applyPageResize(page);

                        $scope.page.productName = page.productName;
                        $scope.createPageEps(
                            $scope.page.pageWidthDim,
                            $scope.page.pageHeightDim,
                            $scope.DPI,
                            '',
                            '',
                            null,
                            false,
                            null,
                            false,
                            null,
                            page.submittedData.unit
                        );
                        $scope.addPrintArea(
                            canvas,
                            $scope.page.pageWidthDim,
                            $scope.page.pageHeightDim,
                            printAreaImageUrl
                        );
                    } finally {
                        $scope.showBlockUiLoader(false);
                    }
                } else if (
                    !$scope.previewMode &&
                    ($scope.forProductTemplateCreation || $scope.forMyProductBases) &&
                    $scope.childTemplateProduct &&
                    templateId &&
                    !$scope.fromListing
                ) {
                    try {
                        $scope.showBlockUiLoader(true, 'Loading data...');
                        const tp = await fetchTemplate(templateId);
                        ProductService.loadProduct(tp);
                        const pod = await getPodProvider(tp.podId);
                        if (pod) {
                            ProductService.setPod({
                                id: pod.id,
                                apiKeyReference: pod.apiKeyReference,
                                isUserPod: pod.isUserPod
                            });
                        }
                        // $scope.editMode = true;
                        await $scope.loadEPS();

                        if ($scope.enablePageEps) {
                            $scope.showBlockUiLoader(false);
                            await resizeAllEpsWithModal();
                        } else {
                            $scope.showBlockUiLoader(false);
                            const dialogResult = await openPageDimensionsModal({
                                mode: 'create',
                                initialWidth: $scope.page.pageWidthDim,
                                initialHeight: $scope.page.pageHeightDim,
                                title: null,
                                exportPPI: $scope.exportPPI
                            });
                            $scope.showBlockUiLoader(true, 'Loading data...');
                            await applyPageResize(dialogResult.page);
                        }
                    } catch (error) {
                        window.rumReportError(error);
                        console.log(error);
                        $location.path('/home');
                    } finally {
                        $scope.showBlockUiLoader(false);
                    }
                } else if (
                    !$scope.previewMode &&
                    $scope.forProductTemplateCreation &&
                    !templateId &&
                    !$scope.fromListing
                ) {
                    ProductService.clearProduct();
                    $scope.showPodProductAssignerModal = true;
                } else if (
                    !$scope.previewMode &&
                    $scope.forProductTemplateCreation &&
                    $scope.isPrintfulOrPrintify &&
                    templateId &&
                    !$scope.fromListing
                ) {
                    ProductService.clearProduct();
                    $scope.showVariantsConfiguratorModal = true;
                } else if (!$scope.previewMode && templateId && shouldLoadProduct) {
                    try {
                        $scope.showBlockUiLoader(true, `Loading template with id ${templateId} ...`);
                        const response = await fetchTemplate(templateId);
                        ProductService.loadProduct(response);
                        const pod = await getPodProvider(response.podId);
                        if (pod) {
                            ProductService.setPod({
                                id: pod.id,
                                apiKeyReference: pod.apiKeyReference,
                                isUserPod: pod.isUserPod
                            });
                        }

                        $scope.editMode = true;

                        await $scope.loadEPS();

                        await $scope.handleChildTemplateProduct();
                    } catch (error) {
                        window.rumReportError(error);
                        console.log(error);
                        $location.path('/home');
                    } finally {
                        $scope.showBlockUiLoader(false);
                    }
                }
                // Check for any data we have to load now
                else if (firstLoad) {
                    await $scope.loadEPS();
                }

                if (!$rootScope.beforeMergeProduct) {
                    const listPreview = ProductService.getListPreview();
                    canvas?.setListPreview(listPreview);
                }
            } catch (error) {
                window.rumReportError(error);
                throw error;
            }
        };

        // Load Textures (only when a text box is created)
        $scope.loadTextures = function () {
            if (!$scope.textures.length) {
                TextureService.getAllTextures().then(function (textures) {
                    console.log('Textures Loaded');
                    $scope.textures = [...textures];
                });
            }
        };

        $scope.loadCrosswordTextures = () => {
            if (!$scope.crosswordTextures.length) {
                CrosswordService.getAllTextures().then((textures) => {
                    textures.forEach((texture) => {
                        texture.Name = texture.Name.replace(/\.[^/.]+$/, '');
                        $scope.crosswordTextures.push(texture);
                    });
                });
            }
        };

        $scope.loadMap = async function () {
            try {
                await Promise.all([mapUtils.addMapDependencies(), starMapUtils.addStarMapDependencies()]);

                const isSupported = mapboxgl?.supported?.();

                if (!isSupported) {
                    console.info('Mapbox GL is not supported in this browser.');
                    return;
                }

                if (!$scope.mapElements) {
                    const modal = mapUtils.createModal();
                    const { map, geocoder } = mapUtils.createMapWrapper(modal);
                    mapUtils.createModalActions(modal);
                    $scope.mapElements = { modal, map, geocoder };
                }
            } catch (error) {
                window.rumReportError(error);
                throw error;
            }
        };

        $scope.reinitializeStarMapGeocoder = function () {
            if (!$scope.starMapGeocoder) {
                $scope.starMapGeocoder = mapUtils.createGeocoder('geocoder-hidden');
            }
            $scope.starMapGeocoder.geocoder.clear();
            $scope.starMapGeocoder.geocoder.on('result', async (e) => {
                const { result } = e;
                if ($scope.svgSelected && $scope.svgSelected.starMapConfig) {
                    let selectedLocation = $scope.svgSelected.starMapConfig.selectedLocation;
                    if (selectedLocation[0] != result.center[1] || selectedLocation[1] != result.center[0]) {
                        $scope.svgSelected.starMapConfig.selectedLocation = [result.center[1], result.center[0]];
                        await $scope.updateDisplayStarMap($scope.svgSelected.starMapConfig);
                    }
                }
            });
            starMapUtils.attachGeocoderToContainer($scope.starMapGeocoder.geocoderContainer);
        };

        $scope.currentFontSizeValidator = _.debounce(function () {
            // "Draw on Path" text auto-fits its rendered size (effectiveFontSize, computed inside
            //  drawTextAlongPath()) against the path length at render time and never writes that
            //  back onto item(0).fontSize - so getFontSize() here still reflects the raw seed
            //  value, which can legitimately sit at/under minSizePx without the rendered text
            //  actually being too small. Bail out for it the same way the old text-transform path
            //  text (isTextPath) already does.
            if ($scope.selectedTextProperties.isTextPath || $scope.textSelected?.textPath) return;
            $scope.currentSizeIsLessThanMinSize =
                $scope.selectedTextProperties.currentFontSize < $scope.selectedTextProperties.minSizePx;
            if ($scope.currentSizeIsLessThanMinSize) {
                $mdToast.show(
                    $mdToast
                        .simple()
                        .textContent(
                            `The text box is too small to fit the font size.
                        Make the text box larger, or the
                        min font size smaller to see the text.`
                        )
                        .position('top right')
                        .hideDelay(2000)
                        .toastClass('md-toast-error')
                );
            }
        }, 300);

        $scope.loadSelectedObjectGroupData = function (evt) {
            if (canvas.getActiveObject()?.isType('activeSelection')) {
                $scope.selectedObjectGroup = canvas.getActiveObject();
            } else {
                canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                canvas.off('customilyActiveSelection:modified');
                $scope.selectedObjectGroup = null;
                return;
            }

            const point = $scope.selectedObjectGroup.getPointByOrigin('center', 'center');
            const selectedObjectGroupProperties = $scope.selectedObjectGroupProperties;

            if (!evt || evt.skipCenterX === undefined || !evt.skipCenterX) {
                selectedObjectGroupProperties.centerX = pixelsToMm(point.x, $scope.DPI);
            }

            if (!evt || evt.skipCenterY === undefined || !evt.skipCenterY) {
                selectedObjectGroupProperties.centerY = pixelsToMm(point.y, $scope.DPI);
            }

            if (!evt || evt.skipRotation === undefined || !evt.skipRotation) {
                selectedObjectGroupProperties.rotation = $scope.selectedObjectGroup.angle;
            }

            if (!evt || evt.skipWidth === undefined || !evt.skipWidth) {
                selectedObjectGroupProperties.width = pixelsToMm(
                    $scope.selectedObjectGroup.getScaledWidth(),
                    $scope.DPI
                );
            }

            if (!evt || evt.skipHeight === undefined || !evt.skipHeight) {
                selectedObjectGroupProperties.height = pixelsToMm(
                    $scope.selectedObjectGroup.getScaledHeight(),
                    $scope.DPI
                );
            }

            selectedObjectGroupProperties.locked = false;
            selectedObjectGroupProperties.objectCount = $scope.selectedObjectGroup.getObjects()?.length;

            $timeout(function () {
                $scope.$apply();
            });
        };

        $scope.initFabric = function () {
            // Create the canvas with Fabric.js
            // IMPORTANT: We use CanvasEx instead of Canvas to enable some additional events
            //  like double click using the fabric.canvasex.js library
            $scope.undoManager = new UndoRedoManager();

            canvas = new fabric.CanvasEx('fabric-canvas', {
                eventContainer: !$scope.previewMode ? 'fabric-container' : '',
                altActionKey: 'ctrlKey', // So we can control skew with the mouse
                enableCopyPaste: !$scope.isUserDesignCreation,
                backgroundColor: 'rgb(255,255,255)',
                width: canvasWidth,
                height: canvasHeight,
                preserveObjectStacking: true,
                isPreviewStep: false,
                seamLessScrollbars: $scope.previewMode,
                enableZoom: !$scope.previewMode,
                artworkTitle: $scope.previewMode ? 'Production file' : '',
                enableGroups: $rootScope.enableGroups,
                enablePageEps: $scope.enablePageEps,
                undoManager: $scope.undoManager,
                editMode: $scope.editMode,
                displayGuidelines: true,
                enableContextMenu: true
            });
            window.C_DEBUGER = canvas;
            $scope.canvas = canvas;
            $scope.stepOneLayersSettingsProps.canvas = $scope.canvas;
            initGroupManager(canvas);

            canvas.lastElementIdCalculator = $scope.getLastElementId;
            fabric.DPI = $scope.DPI;
            canvas.DPI = $scope.DPI;

            const itemSelected = function (event) {
                // Disable multiple elements control when a locked element is selected
                $scope.hasLockedSelectedElement =
                    canvas.getActiveObject().locked || canvas.getActiveObject()?._objects?.some((item) => item.locked);
                // When selection multiple elements, disable the control panel
                if ($scope.isGroupSelected() && event.target.type === 'activeSelection') {
                    event.target.set('lockUniScaling', true);
                    canvas.requestRenderAll();
                    $scope.hasSelectedElement = true;

                    if ($scope.selectedObjectGroup !== event.target) {
                        $scope.selectedObjectGroup = event.target;
                    }

                    if (!$scope.selectedObjectGroup && canvas.getActiveObject()?.isType('activeSelection')) {
                        $scope.selectedObjectGroup = canvas.getActiveObject();
                    }

                    $scope.loadSelectedObjectGroupData();

                    canvas.on('object:modified', $scope.loadSelectedObjectGroupData);
                    canvas.on('customilyActiveSelection:modified', $scope.loadSelectedObjectGroupData);

                    const objects = $scope.selectedObjectGroup?._objects;
                    if (objects?.length > 0 && objects[0]) {
                        $scope.bulkEdit.enabled = $scope.areAllObjectsOfSameType(objects);
                        if ($scope.bulkEdit?.enabled) {
                            $scope.initBulkEditProperties();
                        }
                    }

                    setTimeout(function () {
                        $scope.changeDynamicEPSPosition();
                        $scope.$apply();
                    });
                } else if (!$scope.isUserDesignCreation) {
                    // Single item selection
                    $scope.hasSelectedElement = true;

                    // Terminate all opened color pickers so they can restore the current element color if it wasn't saved and
                    //  other element was now selected
                    $scope.imageColorPicker.terminate();

                    $scope.textSelected = null;
                    $scope.imageSelected = null;
                    $scope.svgSelected = null;

                    $scope.calendarTitleColorPicker.terminate();
                    $scope.calendarMarkerColorPicker.terminate();
                    $scope.calendarHighlightedColorPicker.terminate();

                    if ($scope.selectedObjectGroup) {
                        $scope.bulkEditImageColorPicker.terminate();
                        $scope.bulkEdit.enabled = false;
                        $scope.selectedObjectGroup = null;
                        canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                        canvas.off('customilyActiveSelection:modified');
                    }

                    canvas.updateCornerSize(canvas.getActiveObject());

                    const parentGroupId = canvas.getActiveObject?.()?.groupId || null;
                    if (parentGroupId) {
                        const mgr = getGroupManager();
                        const parentGroup = mgr?.getGroup(parentGroupId);
                        if (parentGroup && parentGroup.SpotifyPlayer) {
                            $scope.selectedSpotifyPlayer = parentGroup;
                        } else {
                            $scope.selectedSpotifyPlayer = null;
                        }
                    } else {
                        $scope.selectedSpotifyPlayer = null;
                    }

                    const activeObject = canvas.getActiveObject();
                    // Text selected
                    if (activeObject?.type == 'bounded-text' || activeObject?.type == 'text-transform') {
                        $scope.textSelected = activeObject;
                        $scope.loadTextures();

                        TextService.loadTextData($scope, canvas);

                        $scope.textSelected.on({
                            modified: function () {
                                TextService.loadTextData($scope, canvas);
                                setTimeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }
                    // Circular text selected
                    else if (activeObject?.type == 'path-itext') {
                        $scope.textSelected = activeObject;
                        TextService.loadCircularTextData($scope, canvas);

                        $scope.textSelected.on({
                            modified: function (eventOrElement) {
                                const element =
                                    eventOrElement.type === 'path-itext' ? eventOrElement : eventOrElement.target;
                                // If start or end angle changed mark the element as edited
                                if (
                                    element &&
                                    (element.startAngle !== $scope.selectedTextProperties.startAngle ||
                                        element.endAngle !== $scope.selectedTextProperties.endAngle)
                                ) {
                                    if ($scope.editMode) {
                                        element.setEditedProp?.('startAngle', 'endAngle');
                                    }
                                }

                                TextService.loadCircularTextData($scope, canvas);

                                setTimeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }
                    // ImagePlaceholder selected
                    else if (['image', 'image-placeholder'].includes(activeObject?.type)) {
                        $scope.imageSelected = activeObject;
                        $scope.selectedImageProperties.position = $scope.imageSelected.selectedPosition;
                        $scope.selectedImageProperties.colorPosition = $scope.imageSelected.selectedColorPosition;
                        LibrariesUtilService.updateLibraryNames($scope, $scope.imageSelected);
                        $scope.selectedImageProperties.isLimitImageToPlaceholder =
                            $scope.imageSelected.isLimitImageToPlaceholder;
                        $scope.selectedImageProperties.lockMovement = $scope.imageSelected.lockMovement;
                        $scope.selectedImageProperties.lockScaling = $scope.imageSelected.lockScaling;
                        $scope.selectedImageProperties.textToImage = $scope.imageSelected.textToImage;
                        $scope.selectedImageProperties.imageToImage = $scope.imageSelected.imageToImage;
                        $scope.selectedImageProperties.imageToImageConfig = $scope.imageSelected.imageToImageConfig;
                        $scope.selectedImageProperties.imageEffects = $scope.imageSelected.imageEffects;
                        $scope.selectedImageProperties.CustomilyRemoveBackground =
                            $scope.imageSelected.CustomilyRemoveBackground;
                        $scope.selectedImageProperties.CustomilyFaceCutOut = $scope.imageSelected.CustomilyFaceCutOut;
                        $scope.selectedImageProperties.CustomilyImageFilter = $scope.imageSelected.CustomilyImageFilter;
                        $scope.selectedImageProperties.isPencilDrawingActive =
                            $scope.imageSelected.CustomilyImageFilter === ImageFilter.PENCIL;
                        $scope.selectedImageProperties.isAquaFilterActive =
                            $scope.imageSelected.CustomilyImageFilter === ImageFilter.AQUA;
                        if ($scope.imageSelected.CrosswordConfig) {
                            $scope.selectedImageProperties.crosswordTexture = $scope.imageSelected.CrosswordConfig.path;
                        } else {
                            $scope.selectedImageProperties.crosswordTexture = null;
                        }
                        $scope.selectedImageProperties.fontPath = undefined;
                        $scope.selectedImageProperties.calendarConfig = $scope.imageSelected.calendarConfig;

                        if ($scope.imageSelected.calendar) {
                            if ($scope.imageSelected.calendarConfig) {
                                const font = $scope.fonts.find((font) => {
                                    const parsedFont = font.Path.replace('Content/', '');
                                    return $scope.imageSelected.calendarConfig?.yearMonthFontPath?.includes(parsedFont);
                                });
                                if (font) {
                                    $scope.setCustomilyCalendarFont(font);
                                    const fontName = `${font.Name} (${font.Style})`;
                                    $scope.searchFont = {
                                        selectedText: fontName,
                                        previousSelectedText: fontName,
                                        previousSelectedValue: font.fontPath,
                                        searchText: ''
                                    };
                                    $scope.selectedImageProperties.fontPath = font.Path;
                                }
                                $scope.customilyCalendar.sundayFirst = $scope.imageSelected.calendarConfig.sundayFirst;
                                $scope.customilyCalendar.markerType = $scope.imageSelected.calendarConfig.markerType;
                                $scope.customilyCalendar.markFill = $scope.imageSelected.calendarConfig.markFill;
                                $scope.customilyCalendar.showHorizontalLine =
                                    $scope.imageSelected.calendarConfig.showHorizontalLine;
                                $scope.customilyCalendar.monthNames = $scope.imageSelected.calendarConfig.monthNames;
                                $scope.customilyCalendar.dayLetters = $scope.imageSelected.calendarConfig.dayLetters;
                                $scope.loadCalendarColors($scope.imageSelected);
                            }
                        }
                        $scope.imageSelected.textTyped = $scope.defaultCrosswordText;
                        $scope.selectedImageProperties.outlineWidth = $scope.imageSelected.outlineWidth;
                        $scope.selectedImageProperties.outlineColor = $scope.imageSelected.outlineColor;

                        function loadImageData() {
                            if (!$scope.imageSelected) {
                                return;
                            }

                            // Load data
                            $scope.selectedImageProperties.centerX = pixelsToMm($scope.imageSelected.left, $scope.DPI);
                            $scope.selectedImageProperties.centerY = pixelsToMm($scope.imageSelected.top, $scope.DPI);
                            $scope.selectedImageProperties.rotation = $scope.imageSelected.angle;
                            $scope.selectedImageProperties.width = pixelsToMm(
                                $scope.imageSelected.getWidth(),
                                $scope.DPI
                            );

                            $scope.selectedImageProperties.height = pixelsToMm(
                                $scope.imageSelected.getHeight(),
                                $scope.DPI
                            );

                            $scope.selectedImageProperties.id = $scope.imageSelected.id;
                            $scope.selectedImageProperties.fullColor = $scope.imageSelected.fullColor;
                            $scope.selectedImageProperties.grading = $scope.imageSelected.grading;
                            $scope.selectedImageProperties.hasStaticImage = $scope.imageSelected.hasStaticImage;
                            $scope.selectedImageProperties.dynamicImagesPath = $scope.imageSelected.dynamicImagesPath;
                            $scope.selectedImageProperties.dynamicImageVariation =
                                $scope.imageSelected.dynamicImageVariation || 1;
                            $scope.selectedImageProperties.hasMask = $scope.imageSelected.hasMask;
                            $scope.selectedImageProperties.coverMaskArea = $scope.imageSelected.coverMaskArea;
                            $scope.selectedImageProperties.rotationLock =
                                $scope.imageSelected.rotationStep === 90 ? true : false;
                            $scope.selectedImageProperties.removeWhiteBackground =
                                $scope.imageSelected.removeWhiteBackground;
                            $scope.selectedImageProperties.RemoveBackground = $scope.imageSelected.RemoveBackground;
                            $scope.selectedImageProperties.CutoutFace = $scope.imageSelected.CutoutFace;
                            $scope.selectedImageProperties.removeBackgroundCOP =
                                $scope.imageSelected.removeBackgroundCOP;
                            $scope.selectedImageProperties.CustomilyRemoveBackground =
                                $scope.imageSelected.CustomilyRemoveBackground;
                            $scope.selectedImageProperties.CustomilyFaceCutOut =
                                $scope.imageSelected.CustomilyFaceCutOut;
                            $scope.selectedImageProperties.CustomilyImageFilter =
                                $scope.imageSelected.CustomilyImageFilter;
                            $scope.selectedImageProperties.isPencilDrawingActive =
                                $scope.imageSelected.CustomilyImageFilter === ImageFilter.PENCIL;
                            $scope.selectedImageProperties.isAquaFilterActive =
                                $scope.imageSelected.CustomilyImageFilter === ImageFilter.AQUA;
                            $scope.selectedImageProperties.locked = $scope.imageSelected.locked;
                            $scope.selectedImageProperties.isPrintArea = $scope.imageSelected.isPrintArea;
                            $scope.selectedImageProperties.isGuide = $scope.imageSelected.isGuide;
                            $scope.selectedImageProperties.isProductGuidelines =
                                $scope.imageSelected.isProductGuidelines;
                            $scope.selectedImageProperties.allowEdit = $scope.imageSelected.allowEdit;
                            $scope.selectedImageProperties.allowSwapLibraryPosition =
                                $scope.imageSelected.allowSwapLibraryPosition;
                            $scope.selectedImageProperties.limitMovement = $scope.imageSelected.limitMovement;
                            $scope.selectedImageProperties.CrosswordConfig = $scope.imageSelected.CrosswordConfig;
                            $scope.selectedImageProperties.calendarConfig = $scope.imageSelected.calendarConfig;
                            $scope.selectedImageProperties.imageToImage = $scope.imageSelected.imageToImage;
                            $scope.selectedImageProperties.imageToImageConfig = $scope.imageSelected.imageToImageConfig;
                            $scope.selectedImageProperties.imageEffects = $scope.imageSelected.imageEffects
                                ? [...$scope.imageSelected.imageEffects]
                                : [];
                            $scope.selectedImageProperties.isLimitImageToPlaceholder =
                                $scope.imageSelected.isLimitImageToPlaceholder;
                            $scope.selectedImageProperties.lockMovement = $scope.imageSelected.lockMovement;
                            $scope.selectedImageProperties.lockScaling = $scope.imageSelected.lockScaling;
                            // Set image mode for the dropdown
                            if (!$scope.imageSelected.fullColor && !$scope.imageSelected.grading) {
                                $scope.selectedImageProperties.imageType = 'single color';
                            } else if (!$scope.imageSelected.fullColor && $scope.imageSelected.grading) {
                                $scope.selectedImageProperties.imageType = 'grading';
                            } else {
                                $scope.selectedImageProperties.imageType = 'full color';
                            }
                            const flip = $scope.imageSelected.getFlip();
                            $scope.selectedImageProperties.flipX = flip.flipX || false;
                            $scope.selectedImageProperties.flipY = flip.flipY || false;

                            $scope.selectedImageProperties.initWidth = $scope.imageSelected.initWidth;
                            $scope.selectedImageProperties.initHeight = $scope.imageSelected.initHeight;
                            $scope.selectedImageProperties.initCenterX = $scope.imageSelected.initCenterX;
                            $scope.selectedImageProperties.initCenterY = $scope.imageSelected.initCenterY;
                            $scope.selectedImageProperties.initRotation = $scope.imageSelected.initRotation;
                            $scope.selectedImageProperties.hasSvgMask = !!$scope.imageSelected.originalMaskSvg;
                            $scope.selectedImageProperties.hasTextMask = $scope.imageSelected.hasTextMask;

                            $scope.imageColorPicker.setColor($scope.imageSelected.getColor());
                            if ($scope.imageSelected.outlineColor) {
                                $scope.imageOutlineColorPicker.setColor($scope.imageSelected.outlineColor);
                            }

                            // load map configuration
                            const mapConfig =
                                typeof $scope.imageSelected?.mapConfig == 'string'
                                    ? JSON.parse($scope.imageSelected.mapConfig)
                                    : $scope.imageSelected.mapConfig;
                            if (mapConfig) {
                                $scope.imageSelected.mapConfig = mapConfig;
                                $scope.selectedMapProps.defaultStyle = mapConfig.defaultStyle;
                                $scope.selectedMapProps.hasPin = mapConfig.hasPin;
                                $scope.selectedMapProps.coordinates = `${mapConfig.latitude}, ${mapConfig.longitude}`;
                                $scope.selectedMapProps.latitude = Number(mapConfig.latitude);
                                $scope.selectedMapProps.longitude = Number(mapConfig.longitude);
                                MAP_STYLE_PRESETS.forEach((style) => {
                                    $scope.selectedMapProps[style.value] = mapConfig.availableStyles.some(
                                        (as) => as == style.value
                                    );
                                });
                            }

                            $scope.imageSelected.wordCloudConfig =
                                typeof $scope.imageSelected?.wordCloudConfig == 'string'
                                    ? JSON.parse($scope.imageSelected.wordCloudConfig)
                                    : $scope.imageSelected.wordCloudConfig;

                            $scope.imageSelected.wordSearchConfig =
                                typeof $scope.imageSelected?.wordSearchConfig == 'string'
                                    ? JSON.parse($scope.imageSelected.wordSearchConfig)
                                    : $scope.imageSelected.wordSearchConfig;

                        }
                        loadImageData();
                        $scope.imageSelected.on({
                            modified: function () {
                                loadImageData();
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });

                        if ($scope.beforeMergeProduct) {
                            const selectedDesign = canvas.getActiveObject();
                            const deselected = canvas
                                .getObjects()
                                .filter(
                                    (obj) =>
                                        obj.name?.toLocaleLowerCase() == 'print area' &&
                                        obj?.uuid != selectedDesign.uuid
                                );
                            if (deselected?.length) {
                                for (const element of deselected) {
                                    element.set('_forcedEditMode', false);
                                    element.set('locked', false);
                                    element.disableEditMode();
                                }
                            }

                            if (selectedDesign.uuid == __imageDesign?.uuid) return;

                            $scope.reinitializeDesignPreviewSelection(selectedDesign);
                            __imageDesign.enableEditMode();
                            return;
                        }
                    }
                    // Vector placeholder or dynamic vector selected
                    else if (activeObject?.type == 'vector-placeholder') {
                        $scope.svgSelected = activeObject;
                        $scope.selectedSVGProperties.position = $scope.svgSelected.selectedPosition;
                        $scope.selectedSVGProperties.colorPosition = $scope.svgSelected.selectedColorPosition;
                        LibrariesUtilService.updateLibraryNames($scope, $scope.svgSelected);

                        function loadSVGGroupData() {
                            if (!$scope.svgSelected) {
                                return;
                            }

                            $scope.selectedSVGProperties.centerX = pixelsToMm($scope.svgSelected.left, $scope.DPI);
                            $scope.selectedSVGProperties.centerY = pixelsToMm($scope.svgSelected.top, $scope.DPI);
                            $scope.selectedSVGProperties.rotation = $scope.svgSelected.angle;
                            $scope.selectedSVGProperties.width = pixelsToMm(
                                $scope.svgSelected.width * $scope.svgSelected.scaleX,
                                $scope.DPI
                            );
                            $scope.selectedSVGProperties.height = pixelsToMm(
                                $scope.svgSelected.height * $scope.svgSelected.scaleY,
                                $scope.DPI
                            );
                            $scope.selectedSVGProperties.id = $scope.svgSelected.id;
                            $scope.selectedSVGProperties.allowUserUpload = $scope.svgSelected.allowUserUpload;
                            $scope.selectedSVGProperties.applyColoring = $scope.svgSelected.applyColoring;
                            $scope.selectedSVGProperties.isSolidBackground = $scope.svgSelected.isSolidBackground;
                            $scope.selectedSVGProperties.coverMaskArea = $scope.svgSelected.coverMaskArea;
                            $scope.selectedSVGProperties.rotationLock = $scope.svgSelected.rotationStep === 90;
                            $scope.selectedSVGProperties.locked = $scope.svgSelected.locked;
                            const flip = $scope.svgSelected.getFlip();
                            $scope.selectedSVGProperties.flipX = flip.flipX || false;
                            $scope.selectedSVGProperties.flipY = flip.flipY || false;
                            $scope.selectedSVGProperties.allowEdit = $scope.svgSelected.allowEdit;
                            $scope.selectedSVGProperties.allowSwapLibraryPosition =
                                $scope.svgSelected.allowSwapLibraryPosition;
                            $scope.selectedSVGProperties.limitMovement = $scope.svgSelected.limitMovement;
                            $scope.selectedSVGProperties.initWidth = $scope.svgSelected.initWidth;
                            $scope.selectedSVGProperties.initHeight = $scope.svgSelected.initHeight;
                            $scope.selectedSVGProperties.initCenterX = $scope.svgSelected.initCenterX;
                            $scope.selectedSVGProperties.initCenterY = $scope.svgSelected.initCenterY;
                            $scope.selectedSVGProperties.initRotation = $scope.svgSelected.initRotation;
                            $scope.selectedSVGProperties.starMapConfig = undefined;
                            $scope.selectedSVGProperties.qrConfig = undefined;

                            // load map configuration
                            const starMapConfig =
                                typeof $scope.svgSelected.starMapConfig == 'string'
                                    ? JSON.parse($scope.svgSelected.starMapConfig)
                                    : $scope.svgSelected.starMapConfig;

                            if (starMapConfig) {
                                const { availableStyles, selectedDate } = starMapConfig;
                                $scope.selectedSVGProperties.starMapConfig = {
                                    ...starMapConfig,
                                    selectedDate: new Date(selectedDate)
                                };
                                $scope.svgSelected.starMapConfig = {
                                    ...starMapConfig,
                                    selectedDate: new Date(selectedDate)
                                };
                                starMapUtils.STAR_MAP_STYLES.forEach((style) => {
                                    $scope.selectedStarMapProps[style.label] = availableStyles.some(
                                        (as) => as.label == style.label
                                    );
                                });

                                if (!$scope.previewMode) {
                                    $timeout(() => {
                                        $scope.reinitializeStarMapGeocoder();
                                    }, 300);
                                }
                            }

                            // load qr
                            const qrConfig =
                                typeof $scope.svgSelected.qrConfig == 'string'
                                    ? JSON.parse($scope.svgSelected.qrConfig)
                                    : $scope.svgSelected.qrConfig;

                            if (qrConfig) {
                                $scope.selectedSVGProperties.qrConfig = { ...qrConfig };
                                $scope.svgSelected.qrConfig = { ...qrConfig };

                                if (!$scope.previewMode) {
                                    $timeout(() => {
                                        $scope.displayQrWithConfig(qrConfig, $scope.svgSelected);
                                    }, 300);
                                }
                            }
                        }
                        loadSVGGroupData();

                        $scope.svgSelected.on({
                            modified: function () {
                                loadSVGGroupData();
                                setTimeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }

                    setTimeout(function () {
                        $scope.changeDynamicEPSPosition();
                        $scope.$apply();
                    });
                }

                // Focus the canvas container to be able to use keys right away
                if (canvas.eventContainer) {
                    $('#' + canvas.eventContainer)[0].focus({
                        preventScroll: true
                    });
                }
            };

            canvas.on({
                'selection:created': (data) => {
                    itemSelected(data);
                },
                'selection:updated': (data) => {
                    itemSelected(data);
                },
                'layers:selection:changed': function () {
                    $scope.$applyAsync();
                },
                'object:added': function (event) {
                    if (!$scope.beforeMergeProduct) {
                        if ($scope.isUserDesignCreation && !$scope.previewMode) {
                            // If it is a design then select all elements, no matter if it is just one.
                            selectCanvasElements(canvas.getObjects(), canvas, true);
                        } else {
                            // Discard any selection when adding new objects
                            canvas.discardActiveObject();
                        }
                        if (event.target && event.target.type !== 'rect') {
                            ProductService.recoverFromPreview(event.target);
                        }
                    }
                    if (event.target && event.target.texture) {
                        TextureService.changeFontTexture(event.target.texture, event.target, 1).then(() => {
                            canvas.renderAll();
                        });
                    }
                    // Update the layers view when adding elements
                    $scope.updateHasPrintAreaElements();
                },
                'object:removed': function (event) {
                    if (event.target && event.target.type !== 'rect') {
                        ProductService.removeFromPreview(event.target);
                    }

                    if (event.target && event.target.type === 'bounded-text' && event.target.pattern) {
                        for (const replica of TextService.getPatternReplicaObjects(canvas, event.target.uuid)) {
                            canvas.remove(replica);
                        }
                        ProductService.removePatternElementsLinks(event.target.uuid);
                    }

                    try {
                        const removedElement = event.target;
                        if (removedElement) {
                            // Checks if the removed element is the source of another element
                            const targets = canvas.getTargetElements(removedElement.uuid);
                            if (targets && targets.length > 0) {
                                targets.forEach((target) => {
                                    const targetElement = target.targetElement;
                                    if (!targetElement) {
                                        return;
                                    }
                                    // Removes the source from the target element
                                    targetElement.sourceElement = null;
                                    // For now, targets can only be texts
                                    if (targetElement.type === 'bounded-text') {
                                        targetElement.setText('A');
                                    }
                                });
                                // Removes the deleted element from the list of sources
                                canvas.removeSourceElement(removedElement.uuid);
                            }

                            // Checks if the removed element is the target of another element
                            const sourceElement = removedElement.sourceElement;
                            if (sourceElement && sourceElement.sourceId) {
                                canvas.removeLinkElement(sourceElement.sourceId, removedElement.uuid);
                            }
                        }
                    } catch (error) {
                        window.rumReportError(error);
                        console.error('Error while removing linked element', error);
                    }

                    // Update the layers view when removing elements
                    $scope.updateHasPrintAreaElements();
                    TextureService.checkIfAnyTextElementHasATexture(canvas, $scope);
                    $scope.checkIfAnyTextHasAShadow();
                },
                /*'object:selected': function () {
                    if ($scope.isUserDesignCreation && !$scope.previewMode) {
                        selectCanvasElements(canvas.getObjects(), canvas, true);
                    }
                },*/
                'object:modified': function (event) {
                    if ($scope.editMode) {
                        if (event.action) {
                            event.target.setEditedProp?.(event.action);
                        }
                    }
                    // Selection group was modified? Remove the selection and update each element scale so
                    //  elements like BoundedText or ImagePlaceholder can recompute their text or images sizes
                    //  accordingly, then, create the selection again.
                    const selection = canvas.getActiveObjects();
                    if ($scope.isGroupSelected() && event && event.target && event.target.type === 'activeSelection') {
                        canvas.temporaryDiscardActiveObject(() => {
                            // Update elements sizes according to the current scaled that was applied
                            //  in the group selection
                            for (const object of selection) {
                                object.updateFromGroupScaling();
                            }
                        });
                        canvas.requestRenderAll();
                    }

                    $scope.updateHasPrintAreaElements();

                    // apply text mask
                    canvas.fire('object:handle:textmask', { target: event.target });
                },
                'object:pasted': async function (event) {
                    let elements = event.cloned;
                    if (!event.isGroup) {
                        elements = [event.cloned];
                    }

                    // Mark elements as added in edit mode
                    if ($scope.editMode) {
                        for (const element of elements) {
                            element.addedOnEdit = true;
                        }
                    }

                    // Enable ligatures support for cloned BoundedText elements
                    for (const element of elements.filter(
                        (e) => e.type === 'bounded-text' || e.type === 'text-transform'
                    )) {
                        if (!element.ligatures) {
                            element.set('ligatures', true);
                        }
                    }

                    //If the element is a starmap, we need to load the SVG
                    for (const element of elements) {
                        if (element.starMapConfig) {
                            const config =
                                typeof element.starMapConfig == 'string'
                                    ? JSON.parse(element.starMapConfig)
                                    : element.starMapConfig;

                            var mutex = ProductService.getStarMapMutex();
                            const starmapSVG = await starMapUtils.updatedDisplayStarMap(
                                starMapUtils.updatedConfig(config),
                                mutex
                            );
                            await DynamicVectorService.loadSVGStringOnPlaceholder(starmapSVG, element, canvas);
                        }
                        if (element.texture) {
                            TextureService.changeFontTexture(element.texture, element, 1).then(() => {
                                canvas.renderAll();
                            });
                        }
                    }
                },
                'object:placeholder:maskModified': function (event) {
                    const { object } = event;
                    $scope.reinitializeDesignPreviewSelection(object);
                },
                'group:added': function (event) {
                    const mgr = getGroupManager();
                    mgr?.refresh();

                    if ($scope.editMode) {
                        event.group.addedOnEdit = true;
                    }
                    ProductService.recoverFromPreview(event.group);
                },
                'group:removed': function (event) {
                    const mgr = getGroupManager();
                    mgr?.refresh();

                    ProductService.removeFromPreview(event.group);
                },
                'group:selected': function () {
                    $scope.groupsSelected = canvas.getActiveGroups();
                    if ($scope.groupsSelected.length == 1 && $scope.groupsSelected[0].SpotifyPlayer) {
                        $scope.selectedSpotifyPlayer = $scope.groupsSelected[0];
                    }
                },
                'group:deselected': function (event) {
                    const index = $scope.groupsSelected.indexOf(event.target);
                    if (index > -1) {
                        $scope.groupsSelected.splice(index, 1);
                    }
                },
                'pageeps:deselected': function () {
                    $scope.currentPageEpsSelect = null;
                },
                'pageeps:selected': function (event) {
                    let pageEps = event.target;
                    if ($scope.currentPageEpsSelect === pageEps.id) {
                        return;
                    }
                    $scope.previousPageEpsSelect = $scope.currentPageEpsSelect;
                    $scope.currentPageEpsSelect = pageEps.id;

                    $scope.DPI = pageEps.dpi;

                    canvasWidth = pageEps.width;
                    canvasHeight = pageEps.height;
                    canvas.DPI = pageEps.dpi;

                    $scope.page.pageWidthDim = pixelsToMm(pageEps.width, pageEps.dpi);
                    $scope.page.pageHeightDim = pixelsToMm(pageEps.height, pageEps.dpi);
                    $scope.page.measureUnit = pageEps.measureUnit;

                    baseImagePath = pageEps.baseImage || '';
                    baseEPSPath = pageEps.baseEps || '';

                    $scope.page.mirror = pageEps.mirror;
                    $scope.page.mergeOutput = pageEps.mergeOutput;
                    $scope.exportPPI = pageEps.exportPPI;

                    $scope.isBackgroundEPS = false;
                    if (baseImagePath || baseEPSPath) {
                        $rootScope.showTemplateResizeBtn = false;
                        $scope.showBaseFileReplace = true;
                        $scope.changeBgImagen(baseImagePath);
                        if (baseEPSPath) {
                            $scope.isBackgroundEPS = true;
                        }
                    } else {
                        $rootScope.showTemplateResizeBtn = true;
                        $scope.showBaseFileReplace = false;
                        $scope.changeBgImagen(
                            'data:image/jpge;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
                        );
                    }

                    if (!$scope.previewMode) canvas.artworkTitle = $scope.getCountListPageEps() > 1 ? pageEps.name : '';

                    CanvasUtilService.applyCanvasScaling(
                        canvas,
                        canvasWidth,
                        canvasHeight,
                        maxCanvasSize,
                        minCanvasSize
                    );
                    $scope.$applyAsync(() => {});
                    canvas.requestRenderAll();

                    console.log(
                        'Canvas set to: ' +
                            parseInt(canvasWidth) +
                            'x' +
                            parseInt(canvasHeight) +
                            '. DPI: ' +
                            $scope.DPI
                    );
                    console.log('Page size is: ' + $scope.page.pageWidthDim + 'x' + $scope.page.pageHeightDim + 'mm');

                    setTimeout(function () {
                        $scope.$apply();
                    });

                    $scope.pageDimensionsEntered(true, true);
                    canvas.setEffectiveZoom(0.9);
                    canvas.requestRenderAll();
                },
                'pageeps:removed': function (event) {
                    $scope.previousPageEpsSelect = null;
                    $scope.currentPageEpsSelect = null;
                    if (event.target) {
                        ProductService.deleteEPS(event.target.id);
                        deletePageDimensions(event.target.id);
                    }
                    $timeout(function () {
                        canvas.discardActivePageEps();
                        canvas.setActiveFirstPageEps();
                        canvas.discardActiveObject();
                    }, 100);
                },
                'object:scaling': function (event) {
                    if (event.target) {
                        if ($scope.editMode) {
                            event.target.editedSize = true;
                        }
                        if (event.target.pattern) $scope.repositionPattern(event.target, true);
                    }
                },
                'object:moving': function (event) {
                    if (event.target && event.target.pattern) $scope.repositionPattern(event.target, false);
                },
                'object:rotating': function (event) {
                    if (event.target && event.target.pattern) $scope.repositionPattern(event.target, false);
                },
                'selection:cleared': function () {
                    $scope.resetBulkEdit();
                    $scope.imageColorPicker.terminate();

                    $scope.textSelected = null;
                    $scope.imageSelected = null;
                    $scope.svgSelected = null;
                    $scope.groupsSelected = [];
                    $scope.hasSelectedElement = false;
                    $scope.hasLockedSelectedElement = false;
                    $scope.selectedSpotifyPlayer = null;

                    $scope.calendarTitleColorPicker.terminate();
                    $scope.calendarMarkerColorPicker.terminate();
                    $scope.calendarHighlightedColorPicker.terminate();

                    if ($scope.selectedObjectGroup) {
                        canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                        canvas.off('customilyActiveSelection:modified');
                        const bulkEditSelectedProperties = $scope.bulkEdit.selectedProperties;
                        if (
                            bulkEditSelectedProperties.colorLibraryId ||
                            bulkEditSelectedProperties.isColorLibraryIdMixed
                        ) {
                            $scope.selectedObjectGroup = null;
                            $scope.bulkEdit.enabled = false;
                            $scope.bulkEditImageColorPicker.terminate();
                        } else {
                            $scope.bulkEditImageColorPicker.terminate();
                            $scope.selectedObjectGroup = null;
                            $scope.bulkEdit.enabled = false;
                        }
                    }

                    setTimeout(function () {
                        $scope.$apply();
                    });
                },
                'mouse:up': function () {
                    if (
                        $scope.isUserDesignCreation &&
                        canvas.getActiveObject() &&
                        canvas.getObjects() &&
                        canvas.getActiveObject().length !== 0 &&
                        canvas.getActiveObject().length !== canvas.getObjects().length &&
                        !$scope.previewMode
                    ) {
                        selectCanvasElements(canvas.getObjects(), canvas, true);
                    }
                },
                'mouse:down': function (event) {
                    if ($scope.colorSamplerActive) {
                        ColorSamplerService.processColorSelection(event.e, function (colorPicker, type, object) {
                            let color = '#' + colorPicker.getColor('HEX');
                            if (type === 'fill') {
                                // Re-select the elements and set the colors
                                if (
                                    object.type === 'bounded-text' ||
                                    object.type === 'path-itext' ||
                                    object.type === 'text-transform'
                                ) {
                                    if (object.setColor) {
                                        object.setColor(color);
                                    } else {
                                        object.set('fill', color);
                                    }
                                    MultipleFontService.saveFontColorToOption(
                                        colorPicker.getColors(),
                                        object,
                                        $scope.editMode
                                    );
                                    canvas.setActiveObject(object);
                                } else if (object.type === 'image-placeholder') {
                                    cancelNextImageColorChangeDebounced = true;
                                    $scope.imageColorSave(colorPicker.getColors(), object);
                                } else if (object.type === 'activeSelection') {
                                    const targetObjects = object._objects;
                                    cancelNextImageColorChangeDebounced = true;
                                    for (const targetObject of targetObjects) {
                                        $scope.imageColorSave(colorPicker.getColors(), targetObject);
                                    }
                                }
                            } else if (type === 'outline') {
                                if (object.type === 'bounded-text' || object.type === 'path-itext') {
                                    // Save the outline color
                                    if (object.type === 'bounded-text') {
                                        let color = colorPicker.getColor();
                                        object.outlineColor = MultipleFontService.createColorObj({
                                            hex: '#' + color.HEX,
                                            cmyk: `${color.cmyk.c},${color.cmyk.m},${color.cmyk.y},${color.cmyk.k}`
                                        });
                                    }

                                    if (object.setOutlineColor) {
                                        object.setOutlineColor(color);
                                    } else {
                                        object.set('stroke', color);
                                    }
                                    canvas.setActiveObject(object);
                                }
                            }
                            $scope.colorSamplerActive = false;
                        });
                    }
                },
                'object:handle:textmask': async function (event) {
                    if (!event?.target) return;
                    const activeObject = event.target;
                    const objects =
                        activeObject.type === 'activeSelection' ? activeObject.getObjects?.() || [] : [activeObject];
                    const links = ProductService.getElementsLinks();
                    for (const object of objects) {
                        if (object.type === 'bounded-text') {
                            if (object.pattern) $scope.repositionPattern(object, true);
                            else if (object.useAsMask) await $scope.applyTextMask(object.uuid);
                            else if (object.useAsCutout) await $scope.applyTextCutout(object.uuid);
                        } else if (object.type === 'image-placeholder') {
                            const link = links.find(
                                (l) =>
                                    l.targetId === object.uuid &&
                                    (l.valueFormat === ValueFormat.TextAsMask ||
                                        l.valueFormat === ValueFormat.TextAsCutout)
                            );
                            if (link) {
                                if (link.valueFormat === ValueFormat.TextAsMask)
                                    await $scope.applyTextMask(link.sourceId);
                                else await $scope.applyTextCutout(link.sourceId);
                            }
                        }
                    }
                },
                'files:pasted': async function (event) {
                    const { images, vectors } = event;
                    const object = canvas.getActiveObject();
                    const type = object ? $scope.getObjectType(object) : null;

                    if (vectors.length) {
                        if (type == 'vector-placeholder') {
                            await $scope.displaySVGOnPlaceholder(vectors);
                        } else {
                            if (!type?.length || type != 'dynamic-vector') {
                                $scope.addDynamicEPSPlaceholder();
                            }
                            const vectorEl = canvas.getActiveObject();
                            $timeout(() => {
                                canvas.fire('vectors:pasted', { vectors, element: vectorEl });
                            });
                        }
                    }

                    if (images.length) {
                        if (type == 'image-placeholder') {
                            await $scope.uploadImagesOnPlaceholder({ files: images });
                        } else {
                            if (type == 'dynamic-image') {
                                canvas.setActiveObject(object);
                            } else if (!type?.length || type != 'dynamic-image') {
                                $scope.addDynamicImage();
                            }
                            $scope.imageSelected = canvas.getActiveObject();
                            $timeout(() => {
                                canvas.fire('images:pasted', images);
                            });
                        }
                    }
                }
            });

            if ($scope.previewMode) {
                // Disabled group selection on preview mode
                canvas.selection = false;

                // Listen for events to update text elements
                $scope.$on('updateText:stepOne', function (event, data) {
                    // Look for the text with the same ID and set the same text
                    const objects = canvas
                        .getObjects()
                        .filter(
                            (o) =>
                                o.id === data.id &&
                                (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                        );
                    for (const object of objects) {
                        $scope.updateText(data.text, object);
                    }
                });

                // Listen for events to update text font
                $scope.$on('updateTextFont:stepOne', function (event, data) {
                    // Look for the text with the same ID and set the same font
                    const objects = canvas
                        .getObjects()
                        .filter(
                            (o) =>
                                o.id === data.id &&
                                (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                        );
                    for (const object of objects) {
                        MultipleFontService.changeFontOption(object, data.fontOption, canvas);
                    }
                });

                // Listen for events to update text font color
                $scope.$on('updateTextFontColor:stepOne', function (event, data) {
                    // Look for the text with the same ID and set the same font color
                    const objects = canvas
                        .getObjects()
                        .filter(
                            (o) =>
                                o.id === data.id &&
                                (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                        );
                    for (const object of objects) {
                        MultipleFontService.changeFontColorOption(null, object, data.fontColorOption, canvas);
                    }
                });

                // Listen for events to update dynamic image/vector position
                $scope.$on('updateDynamicElementOption:stepOne', function (event, data) {
                    const objects = canvas
                        .getObjects()
                        .filter(
                            (o) =>
                                o.id === data.id &&
                                ((o.type === 'image-placeholder' && o.dynamicImagesPath) ||
                                    (o.type === 'vector-placeholder' && !o.allowUserUpload))
                        );
                    for (const object of objects) {
                        if (object.type === 'image-placeholder') {
                            DynamicImageService.showDynamicImage(canvas, object, data.option);
                        } else {
                            DynamicVectorService.changeDynamicEPSPosition(object, data.option, canvas);
                        }
                    }
                });

                // Listen for events to upload images to image placeholders
                $scope.$on('uploadImagePlaceholder:stepOne', async (_, data) => {
                    const image = data.file;
                    if (!image) return;

                    if (
                        !$scope.selectedImageProperties.RemoveBackground &&
                        !$scope.selectedImageProperties.CutoutFace &&
                        !$scope.selectedImageProperties.removeBackgroundCOP &&
                        !$scope.selectedImageProperties.CustomilyRemoveBackground &&
                        !$scope.selectedImageProperties.CustomilyFaceCutOut &&
                        !$scope.selectedImageProperties.CustomilyImageFilter &&
                        !$scope.selectedImageProperties.imageToImage &&
                        !$scope.selectedImageProperties.imageEffects?.length
                    ) {
                        TestImageService.previewImageOnPlaceholder(image, canvas, data.id);
                        return;
                    }

                    $scope.imageSelected.imageFile = image;

                    // Face Cutout (CutoutPro)
                    if ($scope.selectedImageProperties.CutoutFace && $scope.apiKeys.cutoutPro)
                        await CutoutProUtilService.faceCutout($scope, canvas, true, true, object);

                    // Remove background (CutoutPro)
                    if ($scope.selectedImageProperties.removeBackgroundCOP && $scope.apiKeys.cutoutPro)
                        await CutoutProUtilService.faceCutout($scope, canvas, false, true, object);

                    // Remove background (remove.bg)
                    if ($scope.selectedImageProperties.RemoveBackground && $scope.apiKeys.removeBg)
                        await RemoveBgService.applyFilter($scope.imageSelected, $scope, canvas);

                    // Remove background (customily)
                    if ($scope.selectedImageProperties.CustomilyRemoveBackground)
                        await CustomilyRmbgService.applyFilter($scope.imageSelected, $scope, canvas);

                    // Face Cut (customily)
                    if ($scope.selectedImageProperties.CustomilyFaceCutOut)
                        await CustomilyFaceCutOutService.applyFilter($scope.imageSelected, $scope, canvas);

                    // Image Filter (customily)
                    if ($scope.selectedImageProperties.CustomilyImageFilter)
                        await CustomilyImageFilterService.applyFilter(
                            $scope.imageSelected,
                            $scope.selectedImageProperties.CustomilyImageFilter,
                            $scope,
                            canvas
                        );

                    // Image to Image (OpenAI)
                    if ($scope.imageSelected.imageToImage) {
                        if (!$scope.imageSelected.imageToImageConfig?.prompt) {
                            throw new Error('First fill the prompt');
                        }

                        await OpenAIService.imageToImage(
                            $scope,
                            canvas,
                            $rootScope.user.Username,
                            $scope.imageSelected.imageFile
                        );
                    }

                    // Image Effects
                    if ($scope.imageSelected?.imageEffects?.length) {
                        try {
                            $scope.showBlockUiLoader(true, 'Transforming your image 📝✨🎨');
                            const sameIdObjects = canvas
                                .getObjects()
                                .filter((o) => o.type === 'image-placeholder' && o.id === $scope.imageSelected.id);
                            await ImageEffectsService.processImageEffects({
                                objects: sameIdObjects.length ? sameIdObjects : [$scope.imageSelected],
                                canvas,
                                username: $rootScope.user.Username,
                                file: $scope.imageSelected.imageFile
                            });
                        } catch (error) {
                            $mdDialog.show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('We received an error:')
                                    .htmlContent(error.message)
                                    .ok('OK!')
                            );
                        } finally {
                            $scope.showBlockUiLoader(false);
                            $timeout(() => $scope.$apply());
                        }
                    }
                });

                // Listen for events to update image placeholder color
                $scope.$on('updateImageColorOption:stepOne', function (event, data) {
                    const objects = canvas
                        .getObjects()
                        .filter(
                            (o) =>
                                o.id === data.id &&
                                o.type === 'image-placeholder' &&
                                !o.dynamicImagesPath &&
                                !o.fullColor &&
                                !o.grading
                        );

                    for (const object of objects) {
                        DynamicImageService.changeDynamicImageColorPosition(object, data.colorOption, null, canvas);
                    }
                });

                // Listen for events to update dynamic vector color
                $scope.$on('updateVectorColorOption:stepOne', function (event, data) {
                    const objects = canvas
                        .getObjects()
                        .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.applyColoring);

                    for (const object of objects) {
                        DynamicVectorService.changeDynamicEPSColorPosition(object, data.colorOption, null, canvas);
                    }
                });

                $scope.$on('canvas:select:stepOne', (event, data) => {
                    if (data.uuids) {
                        const objects = canvas
                            .getObjects()
                            .filter((e) => data.uuids.includes(e.uuid) || data.uuids.includes(e.zIndex));
                        if (objects) {
                            // Select canvas elements and allow selecting single elements even if they are locked
                            selectCanvasElements(objects, canvas, true);
                        }
                    }
                });

                // Listen for events to upload vectors to vector placeholders
                $scope.$on('uploadVectorPlaceholder:stepOne', async function (event, data) {
                    if (data.file) {
                        const objects = canvas
                            .getObjects()
                            .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.allowUserUpload);
                        for (const object of objects) {
                            await DynamicVectorService.loadFileOnPlaceholder(data.file, object, canvas);
                        }
                    }
                });

                $scope.$on('resetImageTestValue:stepOne', async () => {
                    const targetObject = canvas.getActiveObject();
                    const object = canvas.getObjects().find((o) => o.uuid === targetObject.uuid);
                    targetObject.testingUrl = '';
                    TestImageService.showStaticImage(canvas, object, {
                        imageUrl: require('@/assets/images/photo-example.png')
                    });
                    if (!skipSaveTestingValues) {
                        $scope.IndexDbService.findAndEditValue(object.uuid, '');
                    }
                });

                $scope.$on('resetSvgTestValue:stepOne', async () => {
                    const { selectedSVGProperties } = $scope;
                    const targetObject = canvas.getActiveObject();
                    const object = canvas
                        .getObjects()
                        .find((o) => o.uuid === targetObject.uuid && o.type === 'vector-placeholder');
                    TestImageService.showStaticImageSvg(canvas, object, {
                        imageUrl: require('@/assets/images/vector-example.svg')
                    });
                    selectedSVGProperties.svgString = '';
                    if (!skipSaveTestingValues) {
                        $scope.IndexDbService.findAndEditValue(object.uuid, '');
                    }
                });

                $scope.$on('uploadCustomilyCalendar', function (event, date) {
                    $scope.customilyCalendar.date = date;
                    $scope.onCalendarDateChange();
                });

                $scope.$on('canvas:callback', function (_event, data) {
                    const { callback } = data;
                    if (callback) {
                        callback({
                            canvas,
                            fromStepOne: true
                        });
                    }
                });

                $scope.$on('canvas:update-layers-order', function () {
                    setTimeout(() => {
                        updateElementsOrderFromZIndex(canvas);
                    });
                });

                // Listen for events to update Qr Codes
                $scope.$on('updateQrText:stepOne', async function (event, data) {
                    if (data.qrText) {
                        const objects = canvas
                            .getObjects()
                            .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.qrConfig);
                        for (const object of objects) {
                            const qrConfig =
                                typeof object.qrConfig == 'string' ? JSON.parse(object.qrConfig) : object.qrConfig;

                            $scope.displayQrWithConfig(setQrData(qrConfig, data.qrText), object);
                        }
                    }
                });

                $scope.$on('setActiveElement:stepOne', function (event, data) {
                    const object = canvas.getObjects().find((o) => o.id === data.id);
                    canvas.setActiveObject(object);
                });
            }

            $timeout(() => $scope.$apply());
        };

        $scope.getCurrentElementTitle = function () {
            const object = canvas?.getActiveObject();
            return object ? getCanvasElementTitle(object) : '';
        };

        $scope.deleteSelectedElements = async function () {
            const deleted = await canvas.removeSelection();
            await cleanupDeletedTextEffects(canvas, deleted, ProductService, TEXT_EFFECT, removeTextEffect);
            $scope.cleanupDeletedPatterns(deleted);
        };

        $scope.cloneSelectedElements = async function () {
            await canvas._cloneSelection();
        };

        $scope.onElementSelectedAlign = function (align) {
            const object = canvas.elementsSelectedAlign(align, $scope.elementAlignType, $scope.editMode);
            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.onElementAlignTypeChanged = function (alignType) {
            $scope.elementAlignType = alignType;
        };

        $scope.startImageOrEPSReplace = function (inputId) {
            const backgroundType = $scope.isBackgroundEPS ? 'EPS' : 'image';
            const w = $scope.page.pageWidthDim;
            const h = $scope.page.pageHeightDim;
            const ppiMessage = backgroundType === 'image' ? '(at ' + $scope.DPI + ' PPI)' : '';

            $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(document.body)
                    .clickOutsideToClose(false)
                    .title('Base File Replace')
                    .htmlContent(
                        'The base ' +
                            backgroundType +
                            ' should be replaced with another of a similar size. Using a very different size can result in elements going outside of the canvas. If this is case, we recommend creating a new template.' +
                            '<br /><br />The current ' +
                            backgroundType +
                            ' size is <b>' +
                            parseFloat(Math.round(w * 100) / 100).toFixed(2) +
                            'x' +
                            parseFloat(Math.round(h * 100) / 100).toFixed(2) +
                            '</b> mm ' +
                            ppiMessage
                    )
                    .ok('I understand')
            );

            // To trigger the input file dialog the action must come from the user input. So this dirty hacks attaches a click
            //  event to the OK button in the dialog created above and launches the input file dialog. It's dirty but it's the
            //  only way as it is a browser security limitation.
            const ref = $interval(function () {
                if ($('md-dialog button').length) {
                    $('md-dialog button').on('click', function () {
                        $(this).off('click');
                        angular.element(document.querySelector('#' + inputId)).trigger('click');
                    });
                    $interval.cancel(ref);
                }
            }, 50);
        };

        $scope.replaceBaseFile = function (files) {
            if (files && files[0]) {
                // Replace base file with an EPS
                if (files[0].name.split('.').pop() == 'eps') {
                    blockUI.start('Uploading EPS');
                    $timeout(function () {
                        $scope.$apply();
                    });

                    VectorUtilService.uploadVectorToS3(files[0], 'base', true, false, function (type, progress) {
                        if (type === 'upload') {
                            blockUI.message(`Uploading EPS ${parseInt(progress)}%`);
                            $timeout(() => {
                                $scope.$apply();
                            });
                        } else {
                            blockUI.message('Processing');
                        }
                    })
                        .then((data) => {
                            baseEPSPath = data.EPS;
                            baseImagePath = data.SVG;
                            baseImageToUpload = null;

                            $scope.page.pageWidthDim = data.Width;
                            $scope.page.pageHeightDim = data.Height;
                            $scope.isBackgroundEPS = true;
                            $scope.pageDimensionsEntered(true, false);

                            if ($scope.enablePageEps) {
                                const pageEps = canvas.getFirstActivePageEps();
                                canvas.updatePageEps(
                                    pageEps,
                                    {
                                        width: mmToPixels(data.Width, $scope.DPI),
                                        height: mmToPixels(data.Height, $scope.DPI),
                                        baseEps: baseEPSPath,
                                        baseImage: baseImagePath,
                                        exportPPI: $scope.exportPPI
                                    },
                                    true
                                );
                                baseImageToUploadEPS[pageEps.id] = null;
                            }

                            $timeout(function () {
                                $scope.$apply();
                                blockUI.reset();
                                $('#inputFileReplaceBase')[0].value = null;
                            });
                        })
                        .catch((err) => {
                            window.rumReportError(err);
                            blockUI.reset();
                            $scope.isBackgroundEPS = false;

                            if ($('#inputFileReplaceBase')[0]) {
                                $('#inputFileReplaceBase')[0].value = null;
                            }
                            MdDialogService.showCommonError(
                                err,
                                `${err.data.error || err.data.Message || err.data}`,
                                'Error uploading EPS'
                            );

                            $timeout(function () {
                                $scope.$apply();
                            });
                        });
                } else {
                    // Load the image file and read the EXIF metadata
                    blockUI.start('Processing Image');
                    const imageFormat = inferFormatFromImage(files[0]);

                    loadImageBlueimp(
                        files[0],
                        function (img, data) {
                            const loadImageIntoCanvas = function (img) {
                                ImageUtilService.imageToBase64(img, imageFormat).then(function (base64) {
                                    // If we are uploading an image we need to set the EPS path to null (this goes for the case when we replace an EPS for an image)
                                    baseEPSPath = '';
                                    baseImagePath = base64;
                                    baseImageToUpload = files[0];
                                    $scope.reloadedNonEPSBaseImage = true;

                                    $scope.page.pageWidthDim = pixelsToMm(img.width, $scope.DPI);
                                    $scope.page.pageHeightDim = pixelsToMm(img.height, $scope.DPI);

                                    $scope.pageDimensionsEntered(true, true);

                                    if ($scope.enablePageEps) {
                                        const pageEps = canvas.getFirstActivePageEps();
                                        canvas.updatePageEps(
                                            pageEps,
                                            {
                                                width: img.width,
                                                height: img.height,
                                                baseEps: baseEPSPath,
                                                baseImage: baseImagePath,
                                                dpi: $scope.DPI,
                                                exportPPI: $scope.exportPPI
                                            },
                                            true
                                        );
                                        baseImageToUploadEPS[pageEps.id] = baseImageToUpload;
                                    }

                                    $timeout(function () {
                                        $scope.$apply();
                                        blockUI.stop();
                                        $scope.isBackgroundEPS = false;
                                        $('#inputFileReplaceBase')[0].value = null;
                                    });
                                });
                            };

                            // Check if we have the resolution metadata, if not, ask the user for the desired one
                            if (data.exif && data.exif.get('XResolution')) {
                                // Assume X and Y resolution are the same
                                $scope.DPI = data.exif.get('XResolution');
                                loadImageIntoCanvas(img);
                            } else {
                                blockUI.stop();
                                $mdDialog
                                    .show({
                                        controller: function ($scope, $mdDialog) {
                                            $scope.resolution = 72;
                                            $scope.setResolution = function () {
                                                $mdDialog.hide($scope.resolution);
                                            };
                                        },
                                        template: require('../../../../views/imageResolutionDialog.html'),
                                        parent: angular.element(document.body),
                                        clickOutsideToClose: false
                                    })
                                    .then(
                                        function (resolution) {
                                            $scope.DPI = resolution;
                                            loadImageIntoCanvas(img);
                                        },
                                        function () {
                                            console.error('Dialog should never be canceled!');
                                        }
                                    );
                            }
                        },
                        { orientation: true, meta: true }
                    );
                }
            }
        };

        $scope.removeMask = function (imageElement) {
            const { editMode, selectedImageProperties, bulkEdit } = $scope;
            const { enabled: bulkEditEnabled, selectedProperties: bulkEditSelectedProperties } = bulkEdit;

            if (imageElement) {
                imageElement.maskChanged = true;
                if (editMode) {
                    imageElement.setEditedProp?.('mask');
                }
                const hadMask = imageElement.hasMask;
                imageElement.setMask(null);
                if (hadMask && imageElement.item(0)?.clipPath?.absolutePositioned) {
                    imageElement.item(0).set('clipPath', null);
                }
                imageElement.originalMaskSvg = null;
                if (bulkEditEnabled) {
                    bulkEditSelectedProperties.hasMask = imageElement.hasMask;
                } else {
                    selectedImageProperties.hasMask = imageElement.hasMask;
                    selectedImageProperties.hasSvgMask = !!imageElement.originalMaskSvg;
                }
                canvas.renderAll();
            }
        };

        $scope.uploadMaskImage = function (files) {
            const blackModeMaskImage = function (imgElement) {
                let hiddenCanvas = document.createElement('canvas');
                let hiddenContext = hiddenCanvas.getContext('2d');

                hiddenCanvas.width = imgElement.naturalWidth;
                hiddenCanvas.height = imgElement.naturalHeight;

                hiddenContext.drawImage(imgElement, 0, 0);

                const imageData = hiddenContext.getImageData(0, 0, hiddenCanvas.width, hiddenCanvas.height);
                const data = imageData.data;

                // Apply a threshold to convert the image to black and white
                const threshold = 128;
                for (let i = 0; i < data.length; i += 4) {
                    const brightness = data[i] * 0.3 + data[i + 1] * 0.59 + data[i + 2] * 0.11;

                    // If brightness is greater than threshold, make pixel white; otherwise, make it black
                    if (brightness > threshold) {
                        data[i] = data[i + 1] = data[i + 2] = 255;
                    } else {
                        data[i] = data[i + 1] = data[i + 2] = 0;
                    }
                }
                hiddenContext.putImageData(imageData, 0, 0);
                const base64 = hiddenCanvas.toDataURL();
                hiddenContext = null;
                hiddenCanvas = null;
                return base64;
            };

            if (files && files[0]) {
                const file = files[0];
                const isSvg = file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');

                // Initial position is only supported with raster masks for now.
                const targets = $scope.bulkEdit.enabled
                    ? ($scope.selectedObjectGroup?._objects || []).filter((o) => o.type === 'image-placeholder')
                    : [$scope.imageSelected].filter(Boolean);
                if (isSvg && targets.some((o) => o.hasInitValues?.())) {
                    $('#maskFileUpload')[0].value = null;
                    $mdToast.show(
                        $mdToast
                            .simple()
                            .textContent('SVG masks cannot be combined with an initial image position. Reset the position first, or use a PNG/JPG mask.')
                            .position('top right')
                            .hideDelay(4000)
                    );
                    return;
                }

                let fr = new FileReader();

                if (isSvg) {
                    fr.onload = async function () {
                        try {
                            const sanitizedSvgString = sanitizeSvgString(fr.result);
                            const svgMaskShape = await parseSvgMaskShape(sanitizedSvgString);
                            const {
                                selectedObjectGroup,
                                editMode,
                                imageSelected,
                                selectedImageProperties,
                                bulkEdit
                            } = $scope;
                            const {
                                enabled: bulkEditEnabled,
                                selectedProperties: bulkEditSelectedProperties
                            } = bulkEdit;

                            const applyMask = async function (object) {
                                if (editMode) {
                                    object.setEditedProp?.('mask');
                                }
                                object.maskChanged = true;
                                object.originalMaskSvg = sanitizedSvgString;
                                await applySvgMaskClipPath(object, svgMaskShape);
                            };

                            if (bulkEditEnabled) {
                                const objects = selectedObjectGroup._objects;
                                if (objects.length > 0) {
                                    for (const object of objects) {
                                        if (object.type === 'image-placeholder') {
                                            await applyMask(object);
                                            bulkEditSelectedProperties.hasMask = true;
                                        }
                                    }
                                }
                            } else {
                                await applyMask(imageSelected);
                                selectedImageProperties.hasMask = true;
                                selectedImageProperties.hasSvgMask = true;
                            }

                            canvas.renderAll();

                            $timeout(function () {
                                // Tip for the user after applying mask!
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent('Double click images to enter edit mode!')
                                        .position('top right')
                                        .hideDelay(2000)
                                );

                                $scope.$apply();
                                blockUI.stop();
                            });
                        } catch (error) {
                            console.error('Error applying SVG mask', error);
                            $timeout(function () {
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent('Could not apply this SVG as a mask.')
                                        .position('top right')
                                        .hideDelay(3000)
                                );
                                $scope.$apply();
                                blockUI.stop();
                            });
                        } finally {
                            $('#maskFileUpload')[0].value = null;
                        }
                    };
                    fr.readAsText(file);
                } else {
                    fr.onload = function () {
                        // Load the image
                        const img = new Image();
                        img.onload = function () {
                            // Convert the uploaded image to a black mode mask image
                            const blackModeMaskImageUrl = blackModeMaskImage(img);
                            const blackModeMaskImageElement = new Image();
                            blackModeMaskImageElement.src = blackModeMaskImageUrl;
                            blackModeMaskImageElement.crossOrigin = 'Anonymous';
                            blackModeMaskImageElement.onload = function () {
                                const {
                                    selectedObjectGroup,
                                    editMode,
                                    imageSelected,
                                    selectedImageProperties,
                                    bulkEdit
                                } = $scope;
                                const {
                                    enabled: bulkEditEnabled,
                                    selectedProperties: bulkEditSelectedProperties
                                } = bulkEdit;

                                if (bulkEditEnabled) {
                                    const objects = selectedObjectGroup._objects;
                                    if (objects.length > 0) {
                                        for (const object of objects) {
                                            if (object.type === 'image-placeholder') {
                                                if (editMode) {
                                                    object.setEditedProp?.('mask');
                                                }
                                                object.maskChanged = true;
                                                if (object.hasMask && object.item(0)?.clipPath?.absolutePositioned) {
                                                    object.item(0).set('clipPath', null);
                                                }
                                                object.originalMaskSvg = null;
                                                object.setMask(blackModeMaskImageElement);
                                                bulkEditSelectedProperties.hasMask = object.hasMask;
                                            }
                                        }
                                    }
                                } else {
                                    if (editMode) {
                                        imageSelected.setEditedProp?.('mask');
                                    }
                                    imageSelected.maskChanged = true;
                                    if (imageSelected.hasMask && imageSelected.item(0)?.clipPath?.absolutePositioned) {
                                        imageSelected.item(0).set('clipPath', null);
                                    }
                                    imageSelected.originalMaskSvg = null;
                                    imageSelected.setMask(blackModeMaskImageElement);
                                    selectedImageProperties.hasMask = imageSelected.hasMask;
                                    selectedImageProperties.hasSvgMask = false;
                                }

                                canvas.renderAll();

                                $timeout(function () {
                                    // Tip for the user after applying mask!
                                    $mdToast.show(
                                        $mdToast
                                            .simple()
                                            .textContent('Double click images to enter edit mode!')
                                            .position('top right')
                                            .hideDelay(2000)
                                    );

                                    $scope.$apply();
                                    blockUI.stop();
                                });

                                $('#maskFileUpload')[0].value = null;
                            };
                        };
                        img.crossOrigin = 'Anonymous';
                        img.src = fr.result;
                    };
                    fr.readAsDataURL(file);
                }

                blockUI.start('Uploading Image');
            }
        };

        $scope.handleChildTemplateProduct = async function () {
            if ($scope.previewMode) return;
            const pod = ProductService.getPod();
            if (!(pod && !['printful', 'printify'].includes(pod.apiKeyReference))) return;
            const childTemplateProduct = ProductService.getChildTemplateProduct();
            const dimension = {
                width: $scope.dimensionsModalSubmittedData?.width || $scope.page.pageWidthDim,
                height: $scope.dimensionsModalSubmittedData?.height || $scope.page.pageHeightDim,
                unit: $scope.dimensionsModalSubmittedData?.unit || 'mm'
            };
            const { width, height, unit } = dimension;
            const defaultPrintSizeValue = `${Number(width).toFixed(2)} x ${Number(height).toFixed(2)} ${unit}`;

            const defaultTemplateProduct = childTemplateProduct
                ? {
                      ...childTemplateProduct,
                      currentTemplate: {
                          oldVariant: defaultPrintSizeValue,
                          newVariant: defaultPrintSizeValue,
                          dimension: dimension
                      }
                  }
                : {
                      currentTemplate: {
                          dimension: dimension
                      }
                  };

            ProductService.setChildTemplateProduct(
                childTemplateProduct && childTemplateProduct.currentTemplate
                    ? {
                          ...angular.copy(childTemplateProduct),
                          currentTemplate: {
                              ...childTemplateProduct.currentTemplate,
                              ...defaultTemplateProduct.currentTemplate
                          }
                      }
                    : defaultTemplateProduct
            );

            if ($scope.childTemplateProductParentId) {
                const templateProduct = ProductService.getProduct();
                const variants = await getTemplateProductVariantOptions($scope.childTemplateProductParentId);
                ProductService.loadProduct({
                    ...templateProduct,
                    templateProductVariants: variants
                });
                ProductService.setPod(pod);
                ProductService.setChildTemplateProduct({
                    ...ProductService.getChildTemplateProduct(),
                    isChildTemplateProductEdition: true
                });
            }
        };

        /**
         * Calculate the canvas size and DPI if needed and apply any scaling to improve performance.
         * @param skipCanvasInit if true, canvas won't be initialized, only the new dimensions will be computed
         * @param isImage this must be true if this is called from a base image upload
         */
        $scope.pageDimensionsEntered = function (skipCanvasInit, isImage) {
            var mmPerInch = 25.4;

            $scope.handleChildTemplateProduct().then(() =>
                $timeout(() => {
                    $scope.$apply();
                })
            );
            // If coming from an image take the DPI and dimensions as uploaded, don't alter it.
            // If skipCanvasInit is true then we don't need to compute a new DPI value, use the current one because we are
            //  just replacing the background into a same size canvas.
            if (!isImage && !skipCanvasInit) {
                // If we get here we are coming from a base EPS file, take 300 DPI as default to size our canvas
                $scope.DPI = 300;
                canvasWidth = mmToPixels($scope.page.pageWidthDim, $scope.DPI);
                canvasHeight = mmToPixels($scope.page.pageHeightDim, $scope.DPI);

                // Make sure the canvas is not too small as it will look bad, alter the DPI to ensure at least
                //  'minCanvasSize' pixels
                if (canvasWidth < minCanvasSize || canvasHeight < minCanvasSize) {
                    var ratio = 1;

                    if (canvasHeight < canvasWidth) {
                        ratio = canvasHeight / minCanvasSize;
                    } else if (canvasWidth < canvasHeight) {
                        ratio = canvasWidth / minCanvasSize;
                    } else {
                        // Width and height are the same
                        ratio = canvasWidth / minCanvasSize;
                    }

                    // New canvas size
                    canvasHeight /= ratio;
                    canvasWidth /= ratio;

                    // New DPI
                    $scope.DPI = canvasWidth / ($scope.page.pageWidthDim * (1 / mmPerInch));
                }
            } else {
                // Calculate canvas size with the DPI
                canvasWidth = mmToPixels($scope.page.pageWidthDim, $scope.DPI);
                canvasHeight = mmToPixels($scope.page.pageHeightDim, $scope.DPI);
            }

            if (!skipCanvasInit) {
                $scope.initFabric();
            }
            canvas.DPI = $scope.DPI;

            CanvasUtilService.applyCanvasScaling(canvas, canvasWidth, canvasHeight, maxCanvasSize, minCanvasSize);
            $scope.$applyAsync(() => {});
            canvas.requestRenderAll();

            console.log(
                'Canvas set to: ' + parseInt(canvasWidth) + 'x' + parseInt(canvasHeight) + '. DPI: ' + $scope.DPI
            );
            console.log('Page size is: ' + $scope.page.pageWidthDim + 'x' + $scope.page.pageHeightDim + 'mm');
            canvas.setEffectiveZoom(0.9);
            canvas.requestRenderAll();

            // Set the background image if needed
            if (baseImagePath) {
                $scope.changeBgImagen(baseImagePath);
            }

            if (canvas.getFirstActivePageEps()) {
                updatePageDimensions(canvas.getFirstActivePageEps().id, canvasWidth, canvasHeight);
            }
        };

        $scope.IndexDbService = new IndexDbService();

        $scope.isCreatedAfterCutoff = false;

        // Load data from the ProductService if available
        $scope.loadEPS = async function () {
            // If the product has an id and name, consider it as a valid one
            if (ProductService.getProduct().id && ProductService.getProduct().name) {
                const CUTOFF_DATE = new Date('2026-01-09');
                $scope.isCreatedAfterCutoff =
                    new Date(ProductService.getProduct().CreatedDate) > CUTOFF_DATE &&
                    !ProductService.haveOldImgBehaviour();
                blockUI.start('Loading Data...');
                $scope.isLoadingProduct = false;

                const firstEps = ProductService.getEps();

                // Initialize the canvas with dummy size
                $scope.DPI = firstEps?.dpi || 300;
                canvasHeight = canvasWidth = 1;
                $scope.initFabric();

                if ($scope.enablePageEps) {
                    let listEps = ProductService.getProduct().listEPS;
                    $scope.pageDimensions = listEps.map(({ width, height }) => ({ width, height }));
                    for (const index in listEps) {
                        const eps = listEps[index];
                        let pageEps = {
                            ...eps,
                            uuid: uuidv4(),
                            locked: false,
                            visible: true,
                            name: eps.name || `File ${eps.id}`,
                            type: 'eps',
                            zIndex: eps.zIndexEps,
                            mergeOutput: eps.mergeOutput,
                            podPlaceholder: eps.podPlaceholder,
                            textsEps: [],
                            circularTextsEps: [],
                            imagePlaceHoldersEps: [],
                            vectorEPSEps: []
                        };
                        canvas.addPageEps(pageEps, true, false);
                    }
                    $scope.maxEpsId = canvas.getMaxIdPageEps();
                }

                // Set the proper canvas size now
                canvasWidth = firstEps.width;
                canvasHeight = firstEps.height;
                CanvasUtilService.applyCanvasScaling(canvas, canvasWidth, canvasHeight, maxCanvasSize, minCanvasSize);
                $scope.$applyAsync(() => {});
                canvas.requestRenderAll();

                baseImagePath = firstEps.baseImage;
                baseEPSPath = firstEps.baseEps;

                // Don't show the resize option if we have a base image or EPS
                if (baseImagePath || baseEPSPath) {
                    $rootScope.showTemplateResizeBtn = false;
                    $scope.showBaseFileReplace = true;
                }

                // Check format and set default if not available (old product)
                $scope.page.exportFormat = ProductService.getProduct().format;
                if (!$scope.page.exportFormat) {
                    $scope.page.exportFormat = 'eps';
                }

                $scope.page.mirror = firstEps.mirror;
                $scope.page.mergeOutput = firstEps.mergeOutput;
                $scope.page.productName = ProductService.getProduct().name;
                $scope.page.referenceId = ProductService.getProduct().referenceId;
                $scope.page.MergeFiles = ProductService.getProduct().MergeFiles;

                if ($scope.page.referenceId) {
                    $scope.updateMelcoDesignId($scope.page.referenceId);
                }

                // console.log('Canvas set to: ' + canvasWidth + 'x' + canvasHeight + '. DPI: ' + $scope.DPI);
                const hasStarMap = $scope.step1HasStarMaps();
                if (hasStarMap) {
                    await starMapUtils.showCelestialContainer();
                }

                const epsTestValues = await $scope.IndexDbService.getEpsValues(
                    ProductService.getProduct().id,
                    skipSaveTestingValues
                );

                if (epsTestValues) {
                    await ProductService.setTestingValues(epsTestValues);
                }

                $scope.$applyAsync(() => {});
                await loadDataFromProduct();
                $scope.$applyAsync(() => {});

                if ($scope.layersInstance && !$scope.enablePageEps) {
                    $scope.layersInstance.$children[0].singleGroupSelection();
                }
                $scope.deselectAll();
                if ($scope.undoManager) $scope.undoManager.clear();
                if ($scope.enablePageEps && !$scope.previewMode) {
                    $timeout(function () {
                        const pageEps = canvas.getPageEpsById(firstEps.id);
                        canvas.discardActivePageEps();
                        canvas.setActivePageEps(pageEps, true);
                        TextureService.checkIfAnyTextElementHasATexture(canvas, $scope);
                        $scope.checkIfAnyTextHasAShadow();
                    }, 100);
                }

                if (epsTestValues) {
                    await ProductService.setImagesTestingValues(epsTestValues, canvas);
                }

                $scope.$applyAsync(() => {});
                if ($scope.layersInstance) {
                    $scope.layersInstance.$children[0].initGroupSelectionFromPageEps();
                }

                $rootScope.$broadcast('canvas:loaded:stepThree');
                $scope.showBlockUiLoader(false);
                $scope.$applyAsync(() => {});
            } else if (!$scope.previewMode && !$rootScope.beforeMergeProduct && !$rootScope.productBuilderDesign) {
                // If we get here, the template is being created for the first time, first, initialize the canvas with default dimensions
                $scope.pageDimensionsEntered(false, false);

                $scope.showBlockUiLoader(false);
                // Now ask for page dimensions
                const response = await $mdDialog.show({
                    controller: 'PageDimensionsModalCtrl',
                    template: require('../../../../views/pages/create-product/pageDimensionsModal.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    locals: {
                        mode: 'create',
                        initialWidth: $scope.page.pageWidthDim,
                        initialHeight: $scope.page.pageHeightDim,
                        title: null,
                        exportPPI: $scope.exportPPI,
                        initialUnit: $scope.page.measureUnit
                    }
                });

                const page = response.page;

                let newExportPPI = $scope.getMaxDefaultExportResolution(
                    page.pageWidthDim,
                    page.pageHeightDim,
                    page.pageDPI
                );
                $scope.setExportPPI(newExportPPI);

                $scope.page.pageWidthDim = page.pageWidthDim;
                $scope.page.pageHeightDim = page.pageHeightDim;
                $scope.page.productName = page.productName;
                $scope.page.referenceId = page.referenceId;
                $scope.page.MergeFiles = page.MergeFiles;

                if ($scope.page.referenceId) {
                    $scope.updateMelcoDesignId($scope.page.referenceId);
                }

                if (response.eps) {
                    $scope.isBackgroundEPS = true;
                    baseEPSPath = response.eps.baseEpsPath;
                    baseImagePath = response.eps.baseImagePath;
                    baseImageToUpload = null;
                    $scope.pageDimensionsEntered(true, false);
                } else if (response.image) {
                    $scope.reloadedNonEPSBaseImage = true;
                    $scope.isBackgroundEPS = false;
                    baseEPSPath = '';
                    $scope.DPI = response.image.DPI;
                    baseImagePath = response.image.baseImagePath;
                    baseImageToUpload = response.image.baseImageToUpload;
                    $scope.pageDimensionsEntered(true, true);
                } else {
                    $scope.pageDimensionsEntered(true, false);
                }
                $scope.isLoadingProduct = false;

                // Don't show the resize option if we have a base image or EPS
                if (baseImagePath || baseEPSPath) {
                    $rootScope.showTemplateResizeBtn = false;
                    $scope.showBaseFileReplace = true;
                }
                blockUI.reset();
                blockUI.start('Creating Page');
                $scope.createPageEps(
                    page.pageWidthDim,
                    page.pageHeightDim,
                    $scope.DPI,
                    baseImagePath,
                    baseEPSPath,
                    baseImageToUpload,
                    true, //focus
                    null, //placeholder
                    false, //incrementZIndex
                    page.productName,
                    page.submittedData.unit
                );

                $timeout(() => {
                    blockUI.stop();
                    if ($scope.layersInstance) {
                        $scope.layersInstance.$children[0].initGroupSelectionFromPageEps();
                    }
                    $rootScope.$broadcast('canvas:loaded:stepThree');
                }, 500);
            } else if ($rootScope.beforeMergeProduct) {
                ProductService.clearProduct();
                const {
                    templateProductId,
                    productModel,
                    productBuilderInfo,
                    placeholderId,
                    isPodManual,
                    beforeMergePayload
                } = $rootScope.beforeMergeProduct;

                $rootScope.showTemplateResizeBtn = false;
                $scope.showBaseFileReplace = true;
                blockUI.reset();
                $scope.initFabric();

                //Bridge between the canvas preview-tab UI and the beforeMerge canvas rendering:
                //when the user switches previews, capture deltas from the default preview's edit and
                //re-render the canvas for the target preview (default = editable, nonDefaults = read-only).
                canvas.on('preview:selected', (selected) => {
                    if (!$rootScope.beforeMergeProduct) return;
                    const newId = selected?.PreviewId;
                    if (newId == null || newId === $scope.beforeMergeActivePreviewId) return;

                    const targetPreview = $scope.beforeMergePreviews.find((p) => p.previewId === newId);
                    if (!targetPreview) return;

                    if ($scope.beforeMergeIsDefaultActive) {
                        $scope.beforeMergeAdjustedDeltas = $scope.captureDefaultPreviewDeltas();
                    }

                    const tpData =
                        $scope.beforeMergeProduct.templateProductsData[
                            $scope.beforeMergeProduct.currentTemplateProductIndex
                        ];
                    const goingToDefault = newId === $scope.beforeMergeDefaultPreviewId;
                    $scope.beforeMergeActivePreviewId = newId;
                    $scope.beforeMergeIsDefaultActive = goingToDefault;

                    if (goingToDefault) {
                        $scope.renderBeforeMergePreview(tpData, targetPreview, placeholderId, true, false);
                    } else {
                        const adjustedPrintArea = $scope.getAdjustedPrintAreaForPreview(
                            newId,
                            $scope.beforeMergeAdjustedDeltas
                        );
                        const adjustedPreview = {
                            ...targetPreview,
                            printAreaPreviews: adjustedPrintArea ? [adjustedPrintArea] : []
                        };
                        $scope.renderBeforeMergePreview(tpData, adjustedPreview, placeholderId, false, false);
                    }
                });

                if (!(productBuilderInfo.isMultiFile && isPodManual) && !productModel.variants.length) {
                    getBeforeMergeDataWithoutVariants(templateProductId).then((response) => {
                        $scope.beforeMergeProduct.templateProductsData = response;
                        $scope.beforeMergeProduct.currentTemplateProductIndex = 0;
                        $scope.beforeMergeProduct.printAreaDimensions = [];
                        $scope.initializeCurrentBeforeMergeIteration(
                            $scope.beforeMergeProduct.currentTemplateProductIndex
                        );
                    });
                    return;
                }

                //Tell the backend which print area the merchant is editing so it can pre-filter
                //each response entry's `previews` to those where that print area is visible.
                beforeMergePayload.editingPrintAreaIndex = $scope.beforeMergeProduct.productModel?.lastPrintSectorIndex;

                getBeforeMergeData(beforeMergePayload).then((response) => {
                    $scope.beforeMergeProduct.templateProductsData = response;
                    $scope.beforeMergeProduct.currentTemplateProductIndex = 0;
                    $scope.beforeMergeProduct.printAreaDimensions = [];
                    const beforeMergeTemplateIds = response.map((x) => x.templateProductId);
                    if ($rootScope.beforeMergeProduct?.productBuilderInfo?.isMultiFile) {
                        const sector = productModel.printAreaSectors.find((x) =>
                            x.placeholderId ? x.placeholderId == placeholderId : x.fileName == placeholderId
                        );
                        sector.beforeMergeTemplateIds = beforeMergeTemplateIds;
                    } else {
                        const lastClickedPrintSectorIndex =
                            $scope.beforeMergeProduct.productModel?.lastPrintSectorIndex;
                        productModel.printAreaSectors[
                            lastClickedPrintSectorIndex
                        ].beforeMergeTemplateIds = beforeMergeTemplateIds;
                    }

                    $scope.initializeCurrentBeforeMergeIteration(
                        $scope.beforeMergeProduct.currentTemplateProductIndex,
                        placeholderId
                    );
                });
            }
        };

        $scope.initializeCurrentBeforeMergeIteration = function (index, placeholderId) {
            //templateProductsData.length = N-sizes, after next variant btn is clicked, we iterate over the template products for refreshing the canvas and add new images
            const templateProductData = $scope.beforeMergeProduct.templateProductsData[index];
            const { previews, printAreaPreviewAndEps, epsDPI } = templateProductData;
            const lastClickedPrintSectorIndex = $scope.beforeMergeProduct.productModel?.lastPrintSectorIndex;
            $scope.DPI = epsDPI;
            const previewList = previews || [];

            //The backend already filtered `previews` to those where the edited print area is visible
            $scope.beforeMergePreviews = previewList;
            if ($scope.beforeMergePreviews.length === 0) {
                console.error('beforeMerge: backend returned zero visible previews for the edited print area', {
                    templateProductData,
                    lastClickedPrintSectorIndex
                });
                return;
            }

            const printAreaChosenByMerchant = printAreaPreviewAndEps[lastClickedPrintSectorIndex];
            const visiblePreviewIdsSet = new Set($scope.beforeMergePreviews.map((p) => p.previewId));
            $scope.beforeMergeOriginalPrintAreas = {};
            for (const previewPrintArea of printAreaChosenByMerchant?.previewPrintAreasPerEpsPrintArea || []) {
                if (!visiblePreviewIdsSet.has(previewPrintArea.previewId)) continue;
                $scope.beforeMergeOriginalPrintAreas[previewPrintArea.previewId] = [{ ...previewPrintArea }];
            }

            //"Default" here is the first preview where the edited print area is
            //visible. NOT the isDefault column.
            //If the merchant clicked a print area only visible on a non-DB-default preview, that preview
            //becomes the editable one.
            const defaultPreview = $scope.beforeMergePreviews[0];
            $scope.beforeMergeDefaultPreviewId = defaultPreview.previewId;
            $scope.beforeMergeActivePreviewId = defaultPreview.previewId;
            $scope.beforeMergeIsDefaultActive = true;
            $scope.beforeMergeAdjustedDeltas = null;

            $scope.beforeMergeEditingPrintAreaId = printAreaChosenByMerchant?.printAreaEps?.printAreaId || null;

            if ($scope.beforeMergePreviews.length > 1) {
                canvas.setListPreview(
                    $scope.beforeMergePreviews.map((p) => ({
                        PreviewId: p.previewId,
                        name: p.name,
                        zIndex: p.zIndex
                    }))
                );
                canvas.selectPreview(defaultPreview.previewId, true);
            } else {
                canvas.setListPreview([]);
            }

            $scope.renderBeforeMergePreview(templateProductData, defaultPreview, placeholderId, true, true);
        };

        //Renders one preview default or non-default onto the canvas. For the default preview the
        //user can drag/resize the design within the print area; for non-default previews the design
        //is shown read-only at the adjusted print-area position for that preview.
        $scope.renderBeforeMergePreview = function (
            templateProductData,
            previewData,
            placeholderId,
            isDefault,
            saveDesignForProcessingDimensions
        ) {
            const { printAreaPreviewAndEps, templateProductName } = templateProductData;
            const { productModel, productBuilderInfo } = $rootScope.beforeMergeProduct;
            const { productImage, productMaskImage, productMaskDimensions } = previewData;

            $scope.page.pageWidthDim = pixelsToMm(previewData.width, $scope.DPI);
            $scope.page.pageHeightDim = pixelsToMm(previewData.height, $scope.DPI);
            $scope.page.productName = `${templateProductName} - ${productModel.printAreaSectors[0].designName}`;

            const { page } = $scope;
            blockUI.start('Loading preview');

            $scope.deletePageEpsSelected();
            canvas._objects = [];
            $scope.createPageEps(
                page.pageWidthDim,
                page.pageHeightDim,
                $scope.DPI,
                baseImagePath,
                baseEPSPath,
                baseImageToUpload,
                true,
                null,
                false,
                page.productName
            );
            $scope.isLoadingProduct = false;
            $scope.setExportPPI($scope.DPI);
            const podAssignmentPods = ['printful', 'printify'];
            const isPrintifyOrPrintful = podAssignmentPods.includes(
                productBuilderInfo.provider.apiKeyReference.toLocaleLowerCase()
            );
            let productImagePosition = 1;

            if (productModel.colorSelected?.length) {
                productImagePosition = productModel.colorSelected[0].position;
            } else if (!isPrintifyOrPrintful && productModel.variants?.[0]?.image) {
                const imageObj = JSON.parse(productModel.variants[0].image);
                productImagePosition = imageObj.position || 1;
            }
            let dynamicImage = JSON.parse(productImage.path).find(
                (tuple) => Number(tuple[0]) == productImagePosition
            )?.[1];
            if (!dynamicImage) {
                dynamicImage = JSON.parse(productImage.path)[0][1];
            }
            $scope.addAndOverrideImagePlaceholder(
                typeof dynamicImage == 'string' ? dynamicImage : dynamicImage.path || '',
                {
                    width: productImage.width,
                    height: productImage.height,
                    left: productImage.centerX,
                    top: productImage.centerY,
                    strokeWidth: 0,
                    stroke: 'rgba(0, 0, 0, 0)'
                }
            );

            const lastClickedPrintSectorIndex = $scope.beforeMergeProduct.productModel?.lastPrintSectorIndex;

            const finishMaskAndReadOnly = (printAreaPreview) => {
                let showEditModeStroke = true;
                if (productMaskImage?.length) {
                    const parsed = JSON.parse(productMaskImage);
                    if (parsed.length) {
                        let maskImage = parsed.find((tuple) => Number(tuple[0]) == productImagePosition)?.[1];
                        if (!maskImage) {
                            maskImage = parsed[0][1];
                        }
                        $scope.addAndOverrideImagePlaceholder(
                            typeof maskImage == 'string' ? maskImage : maskImage.path || '',
                            {
                                ...productMaskDimensions,
                                strokeWidth: 0,
                                stroke: 'rgba(0, 0, 0, 0)'
                            }
                        );
                        const { width, height, rotation: angle, centerX: left, centerY: top } = printAreaPreview;

                        const fakeRedRectangle = new fabric.Rect({
                            strokeDashArray: canvas.getDashedArray(),
                            originX: 'center',
                            originY: 'center',
                            width,
                            height,
                            angle,
                            left,
                            top,
                            stroke: 'red',
                            strokeWidth: 1,
                            id: $scope.getLastElementId() + 1,
                            fill: 'rgba(0, 0, 0, 0)'
                        });

                        canvas.add(fakeRedRectangle);
                        fakeRedRectangle.set('evented', false);
                        fakeRedRectangle.set('selectable', false);
                        showEditModeStroke = false;
                    }
                }
                return showEditModeStroke;
            };

            if (isDefault) {
                let designOnCanvas = null;

                //The print area's preview-side dimensions for the default preview come from the
                //snapshot we just built in initializeCurrentBeforeMergeIteration. The new DTO doesn't
                //carry a per-EPS `printAreaPreview` field anymore — each preview's record lives inside
                //`previewPrintAreasPerEpsPrintArea` and we already keyed it by previewId in the snapshot.
                const defaultPreviewPrintArea =
                    $scope.beforeMergeOriginalPrintAreas[$scope.beforeMergeDefaultPreviewId]?.[0];

                if ($rootScope.beforeMergeProduct?.productBuilderInfo?.isMultiFile) {
                    let placeholderPrintArea;
                    if (printAreaPreviewAndEps.length == 1) {
                        placeholderPrintArea = printAreaPreviewAndEps[0];
                    } else {
                        placeholderPrintArea = printAreaPreviewAndEps.find((o) =>
                            o.printAreaEps.placeholderId
                                ? o.printAreaEps.placeholderId == placeholderId
                                : o.printAreaEps.fileName == placeholderId
                        );
                    }
                    designOnCanvas = {
                        index: lastClickedPrintSectorIndex,
                        printAreaPreview: defaultPreviewPrintArea,
                        printAreaEps: placeholderPrintArea.printAreaEps,
                        printAreaId: placeholderPrintArea.printAreaEps.printAreaId,
                        placeholderId: placeholderId
                    };
                } else {
                    for (const [idx, { printAreaEps }] of printAreaPreviewAndEps.entries()) {
                        if (idx !== lastClickedPrintSectorIndex) continue;
                        designOnCanvas = {
                            index: idx,
                            printAreaPreview: defaultPreviewPrintArea,
                            printAreaEps,
                            placeholderId: placeholderId
                        };
                    }
                }

                if (saveDesignForProcessingDimensions) {
                    $scope.beforeMergeDesignsToBeProcessed.push(designOnCanvas);
                }

                return $scope
                    .processImagesInLoop($scope.beforeMergeProduct.designPrintAreas)
                    .then((printAreaPreview) => {
                        const showEditModeStroke = finishMaskAndReadOnly(printAreaPreview);
                        blockUI.stop();
                        const designs = canvas
                            .getObjects()
                            .filter((element) => element.name?.toLocaleLowerCase() == 'print area');
                        $scope.reinitializeDesignPreviewSelection(designs[0]);
                        canvas.setActiveObject(__imageDesign);
                        __imageDesign.enableEditMode(showEditModeStroke);
                        const sector =
                            $scope.beforeMergeProduct.productModel?.printAreaSectors[lastClickedPrintSectorIndex];

                        return new Promise((resolve) => {
                            $timeout(() => {
                                $scope.$apply();
                                //Restore the user's adjustment when re-rendering the default preview.
                                const adjustedFromDeltas = $scope.beforeMergeAdjustedDeltas
                                    ? $scope.getAdjustedPrintAreaForPreview(
                                          $scope.beforeMergeDefaultPreviewId,
                                          $scope.beforeMergeAdjustedDeltas
                                      )
                                    : null;
                                if (adjustedFromDeltas) {
                                    $scope.updateMaskBoundsRectangleWidth(
                                        pixelsToMm(adjustedFromDeltas.width, $scope.DPI),
                                        true
                                    );
                                    $scope.updateMaskBoundsRectangleCenterX(
                                        pixelsToMm(adjustedFromDeltas.centerX, $scope.DPI)
                                    );
                                    $scope.updateMaskBoundsRectangleCenterY(
                                        pixelsToMm(adjustedFromDeltas.centerY, $scope.DPI)
                                    );
                                } else if (
                                    sector.printAreaDimensions?.length &&
                                    sector.printAreaDimensions[$scope.beforeMergeProduct.currentTemplateProductIndex]
                                ) {
                                    const {
                                        width: boundingBoxWidth,
                                        centerX: boundingBoxCenterX,
                                        centerY: boundingBoxCenterY
                                    } = sector.printAreaDimensions[
                                        $scope.beforeMergeProduct.currentTemplateProductIndex
                                    ].preview;
                                    $scope.updateMaskBoundsRectangleWidth(
                                        pixelsToMm(boundingBoxWidth, $scope.DPI),
                                        true
                                    );
                                    $scope.updateMaskBoundsRectangleCenterX(pixelsToMm(boundingBoxCenterX, $scope.DPI));
                                    $scope.updateMaskBoundsRectangleCenterY(pixelsToMm(boundingBoxCenterY, $scope.DPI));
                                }
                                resolve();
                            }, 200);
                        });
                    });
            } else {
                const readOnlyPrintArea = previewData.printAreaPreviews?.[0];
                const designSnapshot =
                    $scope.beforeMergeProduct.designPrintAreas?.[lastClickedPrintSectorIndex]?.designSnapshotUrl;

                if (!readOnlyPrintArea || !designSnapshot) {
                    finishMaskAndReadOnly(
                        readOnlyPrintArea || { width: 0, height: 0, centerX: 0, centerY: 0, rotation: 0 }
                    );
                    blockUI.stop();
                    return Promise.resolve();
                }

                return $scope.addDesignRepresentation(readOnlyPrintArea, designSnapshot).then(() => {
                    finishMaskAndReadOnly(readOnlyPrintArea);
                    if (__imageDesign) {
                        __imageDesign.set({ evented: false, selectable: false, locked: true });
                        if (__imageDesign._maskBoundsRectangle) {
                            __imageDesign._maskBoundsRectangle.set({
                                evented: false,
                                selectable: false,
                                locked: true
                            });
                        }
                    }
                    canvas.discardActiveObject();
                    canvas.renderAll();
                    blockUI.stop();
                    return new Promise((resolve) =>
                        $timeout(() => {
                            $scope.$apply();
                            resolve();
                        })
                    );
                });
            }
        };

        $scope.createProductBtnTitle = function () {
            if (!$scope.beforeMergeProduct?.templateProductsData) return '';
            const { beforeMergeProduct } = $scope;
            return beforeMergeProduct.templateProductsData.length == beforeMergeProduct.currentTemplateProductIndex + 1
                ? 'Confirm'
                : 'Next variant';
        };

        $scope.step1HasStarMaps = function () {
            const vectorEPSEps = ProductService.getListEPS()
                .filter((eps) => eps.vectorEPSEps)
                .flatMap((eps) => eps.vectorEPSEps);

            const hasStarMapConfigVector = vectorEPSEps.some((vector) => vector.starMapConfig);
            return hasStarMapConfigVector;
        };

        $scope.resizePage = function () {
            // Now ask for page dimensions
            $mdDialog
                .show({
                    controller: 'PageDimensionsModalCtrl',
                    template: require('../../../../views/pages/create-product/pageDimensionsModal.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    locals: {
                        mode: 'edit',
                        initialWidth: $scope.page.pageWidthDim,
                        initialHeight: $scope.page.pageHeightDim,
                        title: null,
                        exportPPI: $scope.exportPPI,
                        initialUnit: $scope.page.measureUnit
                    }
                })
                .then(
                    function (data) {
                        const page = data.page;

                        let newExportPPI = $scope.getMaxDefaultExportResolution(
                            page.pageWidthDim,
                            page.pageHeightDim,
                            page.pageDPI
                        );
                        $scope.setExportPPI(newExportPPI);

                        $scope.page.pageWidthDim = page.pageWidthDim;
                        $scope.page.pageHeightDim = page.pageHeightDim;
                        $scope.page.measureUnit = page.submittedData.unit;
                        $scope.page.referenceId = page.referenceId;

                        if (data.eps) {
                            $scope.isBackgroundEPS = true;
                            baseEPSPath = data.eps.baseEpsPath;
                            baseImagePath = data.eps.baseImagePath;
                            baseImageToUpload = null;
                            $scope.pageDimensionsEntered(true, false);
                        } else if (data.image) {
                            $scope.reloadedNonEPSBaseImage = true;
                            $scope.isBackgroundEPS = false;
                            baseEPSPath = '';
                            $scope.DPI = data.image.DPI;
                            baseImagePath = data.image.baseImagePath;
                            baseImageToUpload = data.image.baseImageToUpload;
                            $scope.pageDimensionsEntered(true, true);
                        } else {
                            $scope.pageDimensionsEntered(true, false);
                        }

                        if ($scope.enablePageEps) {
                            const pageEps = canvas.getFirstActivePageEps();
                            canvas.updatePageEps(
                                pageEps,
                                {
                                    width: mmToPixels(page.pageWidthDim, $scope.DPI),
                                    height: mmToPixels(page.pageHeightDim, $scope.DPI),
                                    dpi: $scope.DPI,
                                    baseEps: baseEPSPath,
                                    baseImage: baseImagePath,
                                    exportPPI: $scope.exportPPI,
                                    measureUnit: $scope.page.measureUnit
                                },
                                true
                            );
                            baseImageToUploadEPS[pageEps.id] = baseImageToUpload;
                        }

                        // adjust solid background
                        const objectSolidBg = canvas._objects.find(
                            (o) =>
                                o.type === 'vector-placeholder' &&
                                o.isSolidBackground &&
                                o.pageEpsId === canvas.getFirstActivePageEpsId()
                        );
                        if (objectSolidBg) {
                            $scope.adjustSolidBackground(objectSolidBg);
                        }
                    },
                    function () {}
                );
        };

        $scope.handleWarningOpen = function (accepted) {
            if (accepted) {
                window.localStorage.setItem('multiEpsAlert', true);
            }

            $scope.showMultiEpsAlertWarning = false;

            $scope.openCreateModalPageEps();
        };

        $scope.handleWarningClose = function () {
            $scope.showMultiEpsAlertWarning = false;
            $scope.openCreateModalPageEps();
        };

        $scope.openModalgPageEps = function () {
            const showMultiEpsAlert = JSON.parse(window.localStorage.getItem('multiEpsAlert'));

            if (showMultiEpsAlert || $scope.hasPODRole) {
                $scope.openCreateModalPageEps();
                return;
            }

            $scope.showMultiEpsAlertWarning = true;
        };

        $scope.openCreateModalPageEps = function () {
            if ($scope.forDesignTemplateCreation && $scope.forMyDesigns) {
                $scope.createPageEps(1000, 1000, 300);
                return;
            }

            $mdDialog
                .show({
                    controller: 'PageDimensionsModalCtrl',
                    template: require('../../../../views/pages/create-product/pageDimensionsModal.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    locals: {
                        mode: 'create-page-eps',
                        initialWidth: $scope.page.pageWidthDim,
                        initialHeight: $scope.page.pageHeightDim,
                        title: null,
                        exportPPI: $scope.exportPPI,
                        initialUnit: null
                    }
                })
                .then(
                    function (data) {
                        const page = data.page;
                        if (canvas) {
                            let baseImagen = '';
                            baseImageToUpload = null;
                            if (data.eps) {
                                baseImagen = data.eps.baseImagePath;
                                baseImageToUpload = null;
                            } else if (data.image) {
                                baseImagen = data.image.baseImagePath;
                                baseImageToUpload = data.image.baseImageToUpload;
                            }

                            $scope.createPageEps(
                                page.pageWidthDim,
                                page.pageHeightDim,
                                data.image ? data.image.DPI : 300,
                                baseImagen,
                                data.eps ? data.eps.baseEpsPath : '',
                                baseImageToUpload,
                                true,
                                null,
                                false,
                                null,
                                page.submittedData.unit
                            );

                            let newExportPPI = $scope.getMaxDefaultExportResolution(
                                page.pageWidthDim,
                                page.pageHeightDim,
                                page.pageDPI
                            );
                            $scope.setExportPPI(newExportPPI);

                            if ($scope.forProductTemplateCreation) {
                                const printAreaImageUrl = require('@/assets/images/print-area-customily.png');
                                $scope.addPrintArea(canvas, page.pageWidthDim, page.pageHeightDim, printAreaImageUrl);
                            }
                        }
                    },
                    function () {}
                );
        };

        /**
         * Creates a createPageEps
         * @property {number} width - The width of the page in pixels
         * @property {number} height - The height of the page in pixels
         * @property {number} dpi - The DPI of the page. Default is 72.
         * @property {string} baseImage - The base image to use for the page. Default is an empty string.
         * @property {string} baseEpsPath - The base EPS path to use for the page. Default is an empty string.
         * @property {string} baseImageToUpload - The base image to upload for the page. Default is null.
         * @property {boolean} focus - Whether to focus the page. Default is false.
         * @property {string} placeholder - The placeholder image to use for the page. Default is null.
         * @property {void}
         */
        $scope.createPageEps = function (
            width,
            height,
            dpi,
            baseImagen = '',
            baseEpsPath = '',
            baseImageToUpload = null,
            focus = false,
            placeholder = null,
            incrementZIndex = false,
            productName = null,
            measureUnit = 'mm'
        ) {
            let zIndex = 0;
            if (incrementZIndex) {
                zIndex = $scope.getCountListPageEps() > 0 ? canvas.getMaxZindexPageEps() + 1 : 0;
            } else {
                zIndex = $scope.getCountListPageEps() > 0 ? canvas.getMinZindexPageEps() - 1 : 0;
            }

            const epsId = ++$scope.maxEpsId;
            const eps = {
                id: epsId,
                uuid: uuidv4(),
                locked: false,
                visible: true,
                name: placeholder ?? productName ?? `File ${epsId}`,
                type: 'eps',
                zIndex,
                zIndexPreview: null,
                width: mmToPixels(width, dpi),
                height: mmToPixels(height, dpi),
                measureUnit,
                dpi,
                exportPPI: $scope.exportPPI || 72,
                baseImage: baseImagen,
                baseEps: baseEpsPath,
                podPlaceholder: placeholder,
                textsEps: [],
                circularTextsEps: [],
                imagePlaceHoldersEps: [],
                vectorEPSEps: []
            };
            if ($scope.enablePageEps) {
                canvas.addPageEps(eps, false, $scope.getCountListPageEps() !== 0);
                canvas.setActivePageEps(eps);
                baseImageToUploadEPS[eps.id] = baseImageToUpload;
            }
            ProductService.addNewEPS({ ...eps, measureUnit });
            if (focus) {
                $scope.focusPageEps(epsId);
            }
        };

        $scope.focusPageEps = function (epsId) {
            $timeout(function () {
                var elementPageEps = document.querySelector(`.layers-container [page-data-id="${epsId}"]`);
                if (!elementPageEps) return;
                elementPageEps.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 500);
        };

        $scope.getCountListPageEps = function () {
            if (canvas) {
                return canvas.getElementsPageEps().length;
            }
            return 0;
        };

        $scope.deletePageEpsSelected = function () {
            if (!canvas) return;
            const pageEps = canvas.getFirstActivePageEps();
            canvas.removePageEps(pageEps);
            ProductService.deleteEPS(pageEps);
        };

        /**
         * Preview types configuration for element migration
         */
        const PREVIEW_TYPES = {
            textsPreview: 'textsPreview',
            imagePlaceHoldersPreview: 'imagePlaceHoldersPreview',
            circularTextsPreview: 'circularTextsPreview',
            vectorEPSPreview: 'vectorEPSPreview'
        };

        /**
         * Migrates old elements without uuid to new ones with uuid.
         * This function ensures backward compatibility by adding UUID to elements
         * that were created before the UUID system was implemented.
         *
         * @param {Object} element - The element to migrate
         */
        function migrateOldElement(element, types) {
            try {
                // Validate input parameters
                if (!element) {
                    console.warn('migrateOldElement: No element provided');
                    return false;
                }

                if (!element.id) {
                    console.warn('migrateOldElement: Element missing required id property', element);
                    return false;
                }

                // Skip if element already has a uuid
                if (element.uuid) {
                    return;
                }

                // Generate and assign new UUID
                const newUuid = uuidv4();
                element.uuid = newUuid;

                // Update corresponding preview elements
                updatePreviewElements(element.id, newUuid, types);
            } catch (error) {
                console.error('migrateOldElement: Error migrating element', error);
            }
        }

        /**
         * Updates preview elements with the new UUID for a given element ID
         *
         * @param {string|number} elementId - The ID of the element to update
         * @param {string} newUuid - The UUID to assign to matching preview elements
         */
        function updatePreviewElements(elementId, newUuid, types) {
            try {
                const listPreviews = ProductService.getListPreview();

                if (!listPreviews) {
                    return;
                }

                for (const preview of listPreviews) {
                    if (!preview) {
                        continue;
                    }

                    // Process each preview type
                    for (const property of types) {
                        const previewArray = preview[property];

                        if (!Array.isArray(previewArray)) {
                            continue;
                        }

                        const previewElement = previewArray.find((item) => item?.id === elementId && !item?.uuid);
                        if (previewElement) {
                            previewElement.uuid = newUuid;
                            return;
                        }
                    }
                }
            } catch (error) {
                console.error('updatePreviewElements: Error updating preview elements', error);
            }
        }

        async function loadText(textProperties, pageEpsId) {
            migrateOldElement(textProperties, [PREVIEW_TYPES.textsPreview]);
            /*Backward compatibility with texts that have allowEdit enabled but no bounding box (old version):
            The allowEdit property is set to false to prevent the new logic from being executed.
            In the previous version, allowEdit didn’t introduce any changes in DS*/
            if (!textProperties.oldAllowEdit) {
                //Coming from step 3, oldAllowEdit is already set up
                textProperties.oldAllowEdit =
                    textProperties.allowEdit &&
                    (textProperties.initCenterX === null || textProperties.initCenterX === undefined);
                textProperties.allowEdit = textProperties.oldAllowEdit ? false : textProperties.allowEdit;
            }

            let aFontFamily = fontManagerService.findFontByPath(textProperties.fontPath);

            let objectCenterX = textProperties.centerX;
            let objectCenterY = textProperties.centerY;

            $scope.boundingRectWidth = textProperties.width;
            $scope.boundingRectHeight = textProperties.height;

            let fontsMap = new Map();
            let fontColorsMap = new Map();
            MultipleFontService.initializeFontsMap(fontsMap, aFontFamily.Path, textProperties);
            MultipleFontService.initializeFontColorsMap(fontColorsMap, textProperties);
            const color = MultipleFontService.parseColorFromProperty(textProperties.color);
            const outlineColor = MultipleFontService.parseColorFromProperty(textProperties.outlineColor);
            const outlineColorsMap = MultipleFontService.parseColorsMap(textProperties.outlineColorsMap);

            const strokeColorsMap = new Map();
            MultipleFontService.initializeStrokeColor(strokeColorsMap, textProperties);
            const strokeColor = MultipleFontService.parseColorFromProperty(textProperties.strokeColor);

            const shadowColorsMap = MultipleFontService.getShadowColorsMap(textProperties);
            const shadowColor = MultipleFontService.parseColorFromProperty(
                textProperties.shadowColor ?? shadowColorsMap.get(1)
            );

            const transformOptions =
                textProperties.transformOptions && typeof textProperties.transformOptions === 'string'
                    ? JSON.parse(textProperties.transformOptions)
                    : textProperties.transformOptions || {};
            const dateFormat =
                textProperties.dateFormat && typeof textProperties.dateFormat === 'string'
                    ? JSON.parse(textProperties.dateFormat)
                    : textProperties.dateFormat || {};

            const parsedMetadata = tryParseJson(textProperties.metadata);
            const innerTextMetadata = parsedMetadata && typeof parsedMetadata === 'object' ? parsedMetadata : {};
            const obj = {
                canvasWidth,
                canvasHeight,
                version: textProperties.Version,
                width: $scope.boundingRectWidth,
                height: $scope.boundingRectHeight,
                originX: 'center',
                originY: 'center',
                left: objectCenterX,
                top: objectCenterY,
                strokeDashArray: canvas.getDashedArray(),
                angle: textProperties.rotation,
                centeredRotation: true,
                textAlign: textProperties.textAlign,
                textVerticalAlign: textProperties.textVerticalAlign,
                skewX: textProperties.skewX,
                skewY: textProperties.skewY,
                lockScalingFlip: true,

                originalMinSizePx: textProperties.minSizePx,
                originalMaxSizePx: textProperties.maxSizePx,
                originalWidth: textProperties.width,
                originalHeight: textProperties.height,

                minSizePx: textProperties.minSizePx,
                maxSizePx: textProperties.maxSizePx,
                multiline: textProperties.multiline,
                verticalText: textProperties.verticalText,
                caps: textProperties.caps,
                fontPath: aFontFamily.Path,
                fontName: aFontFamily.Name + '_' + aFontFamily.Style,

                color: color,
                outlineColor: outlineColor,
                fontLibraryId: textProperties.fontLibraryId,
                colorLibraryId: textProperties.colorLibraryId,
                outlineColorLibraryId: textProperties.outlineColorLibraryId,

                id: textProperties.id,
                uuid: textProperties.uuid,
                zIndex: typeof textProperties.zIndex === 'undefined' ? 0 : textProperties.zIndex,
                fontsMap: fontsMap,
                fontColorsMap: fontColorsMap,
                outlineColorsMap,
                Itext: textProperties.Itext,
                textures: textProperties.textures,

                tracking: textProperties.tracking,
                lineSpacing: textProperties.lineSpacing,

                locked: textProperties.locked,
                visible: textProperties.visible,
                name: textProperties.name,
                prefix: textProperties.prefix,
                suffix: textProperties.suffix,
                betweenCharacters: innerTextMetadata.betweenCharacters || '',
                betweenWords: innerTextMetadata.betweenWords || '',
                referenceId: textProperties.referenceId,
                ligatures: textProperties.ligatures,
                isPrintArea: textProperties.isPrintArea,
                isOverlay: textProperties.isOverlay,
                groupId: textProperties.groupId,
                pageEpsId,
                allowEdit: textProperties.allowEdit,
                patternConfig: parsePatternConfig(textProperties.patternConfig),
                useAsMask: textProperties.useAsMask,
                useAsCutout: textProperties.useAsCutout,
                oldAllowEdit: textProperties.oldAllowEdit,
                /*If the text uses the previous version of allowEdit (without a bounding box), these properties are left as null.
                Once they have a value, the new version is considered active.*/
                initCenterX: textProperties.oldAllowEdit ? null : textProperties.initCenterX,
                initCenterY: textProperties.oldAllowEdit ? null : textProperties.initCenterY,
                initRotation: textProperties.oldAllowEdit ? null : textProperties.initRotation,
                initFontSize: textProperties.oldAllowEdit ? null : textProperties.initFontSize,
                originalInitCenterX: textProperties.oldAllowEdit ? null : textProperties.initCenterX,
                originalInitCenterY: textProperties.oldAllowEdit ? null : textProperties.initCenterY,
                originalInitFontSize: textProperties.oldAllowEdit ? null : textProperties.initFontSize,
                /* --- */
                isTextPath: textProperties.isTextPath || false,
                textPath: textProperties.textPath || null,
                textPathAutoFit: textProperties.textPathAutoFit !== false,
                fontFamily: aFontFamily.Name + '_' + aFontFamily.Style,
                transformOptions: transformOptions,
                text: textProperties.text || '',
                isPersonalizableText: textProperties.isPersonalizableText !== false,
                defaultValue: textProperties.defaultValue || '',
                preventEditMode: $scope.previewMode,
                editMode: $scope.editMode || false,
                autofillSource: textProperties.autofillSource,
                dateFormat: dateFormat,
                /* stroke */
                strokeColor: strokeColor,
                strokeWidth: textProperties.strokeWidth || 0,
                strokeColorsMap: strokeColorsMap,
                strokeColorLibraryId: textProperties.strokeColorLibraryId,
                /* shadow */
                shadowType: textProperties.shadowType,
                shadowOffset: textProperties.shadowOffset,
                shadowAngle: textProperties.shadowAngle,
                shadowBlur: textProperties.shadowBlur,
                shadowColor: shadowColor,
                shadowColorsMap: shadowColorsMap,
                shadowColorLibraryId: textProperties.shadowColorLibraryId
            };
            if (textProperties.isTextPath) {
                obj.editMode = $scope.editMode || false;
                obj.fontSize = textProperties.minSizePx ?? textProperties.maxSizePx;
                await MultipleFontService.changeFontOption(obj, 1, canvas);
            }
            const text = new (textProperties.isTextPath ? fabric.TextTransform : fabric.BoundedText)(obj);

            if ($scope.editMode && textProperties.oldAllowEdit) {
                text.setEditedProp?.('allowEdit');
                text.setEditedProp?.('oldAllowEdit');
            }

            text.setFontSize(textProperties.minSizePx);
            text.setColor(ElementsColorService.colorToWeb(color));
            text.setFontFamily(aFontFamily.Name + '_' + aFontFamily.Style);
            text.set('caps', textProperties.caps);
            text.setOutlineColor(ElementsColorService.colorToWeb(outlineColor));
            text.setOutlineWidth(textProperties.outlineWidth);
            if (textProperties.isTextPath) {
                text.setStrokeColor(ElementsColorService.colorToWeb(strokeColor));
                text.setStrokeWidth(textProperties.strokeWidth || 0);
            } else {
                text.setStrokeWidth(canvas.getVisibleStrokeWidth());
                text.setShadowColor(ElementsColorService.colorToWeb(shadowColor));
            }

            if (textProperties.text && textProperties.text.length && textProperties.text !== text.getText()) {
                $scope.updateText(textProperties.text, text);
            } else {
                text.setText(text.getText());
            }

            if (textProperties.isPersonalizableText === false && textProperties.defaultValue) {
                text.setText(textProperties.defaultValue);
            } else if (textProperties.testingText) {
                text.setText(textProperties.testingText);
            }
            if ($scope.previewMode) {
                text.lockMovementY = true;
                text.lockMovementX = true;
                text.lockScalingX = true;
                text.lockScalingY = true;
                text.lockRotation = true;
                if (!textProperties.isTextPath) {
                    text.setStrokeWidth(0);
                }
            }
            text.setFlip(textProperties.flipX || false, textProperties.flipY || false);

            // Set the first position for color and font
            $scope.selectedTextProperties.fontColorOption = 1;
            $scope.selectedTextProperties.outlineColorOption = 1;
            $scope.selectedTextProperties.strokeColorOption = 1;
            $scope.selectedTextProperties.shadowColorOption = 1;
            await Promise.all([
                MultipleFontService.changeFontOption(text, 1, canvas),
                MultipleFontService.changeFontColorOption(undefined, text, 1, canvas),
                MultipleFontService.changeOutlineColorOption(text, 1, canvas)
            ]);
            if (text.textures && text.textures.length) {
                await TextureService.changeFontTexture(text.textures[0].texturePath, text, 1);
                await TextureService.changeScaleTexture(text, 1, text.textures[0].textureScale);
                if (text.shadowType != null) {
                    text.set?.('shadowType', null);
                    text.shadowType = null;
                }
            }
            if (text.useAsMask) {
                await $scope.updateTextUseAsMask(true, text);
            }
            if (text.useAsCutout) {
                await $scope.updateTextUseAsCutout(true, text);
            }
            if (textProperties.isTextPath) {
                await MultipleFontService.changeStrokeColorOption(text, 1, canvas);
            } else {
                MultipleFontService.changeShadowColorOption(text, 1, canvas);
            }

            if (textProperties.metadata) {
                text.metadata = textProperties.metadata;
            }

            return text;
        }

        async function loadCircularText(textProperties, pageEpsId) {
            migrateOldElement(textProperties, [PREVIEW_TYPES.circularTextsPreview]);
            let aFontFamily = fontManagerService.findFontByPath(textProperties.fontPath);

            // initialize fonts and font colors map for circularTexts
            let fontsMap = new Map();
            let fontColorsMap = new Map();
            MultipleFontService.initializeFontsMap(fontsMap, aFontFamily.Path, textProperties);
            MultipleFontService.initializeFontColorsMap(fontColorsMap, textProperties);
            const color = MultipleFontService.parseColorFromProperty(textProperties.color);
            const outlineColor = MultipleFontService.parseColorFromProperty(textProperties.outlineColor);
            const outlineColorsMap = MultipleFontService.parseColorsMap(textProperties.outlineColorsMap);

            const minSizePx = textProperties.minSizePx ?? textProperties.fontSize;
            const maxSizePx = textProperties.maxSizePx ?? textProperties.fontSize;
            const text = new fabric.PathIText('A', {
                pathWidth: canvas.getVisibleStrokeWidth(),
                originX: 'center',
                originY: 'center',
                left: textProperties.centerX,
                top: textProperties.centerY,
                angle: textProperties.rotation,
                centeredRotation: true,
                textAlign: textProperties.textAlign,
                skewX: textProperties.skewX,
                skewY: textProperties.skewY,
                lockSkewingX: true,
                lockSkewingY: true,
                lockScalingFlip: true,

                startAngle: textProperties.startAngle,
                endAngle: textProperties.endAngle,

                originalFontSize: textProperties.fontSize,
                originalMinSizePx: minSizePx,
                originalMaxSizePx: maxSizePx,
                originalHorizontalDiameter: textProperties.horizontalDiameter,

                minSizePx: minSizePx,
                maxSizePx: maxSizePx,
                horizontalDiameter: textProperties.horizontalDiameter,
                verticalDiameter: textProperties.verticalDiameter,
                convex: textProperties.convex,
                tracking: textProperties.tracking,

                caps: textProperties.caps,
                fontPath: aFontFamily.Path,
                fontName: aFontFamily.Name + '_' + aFontFamily.Style,
                fontFamily: aFontFamily.Name + '_' + aFontFamily.Style,

                fill: ElementsColorService.colorToWeb(color), // RGB color used as fill
                color: color, // Color object
                fontLibraryId: textProperties.fontLibraryId,
                colorLibraryId: textProperties.colorLibraryId,

                stroke: textProperties.outlineColor,
                strokeWidth: textProperties.outlineWidth,
                outlineColorsMap,
                outlineColorLibraryId: textProperties.outlineColorLibraryId,
                id: textProperties.id,
                uuid: textProperties.uuid,
                // add fonts map to circular text object
                fontsMap: fontsMap,
                // add font colors map to circular text object
                fontColorsMap: fontColorsMap,
                zIndex: typeof textProperties.zIndex === 'undefined' ? 0 : textProperties.zIndex,

                locked: textProperties.locked,
                visible: textProperties.visible,
                name: textProperties.name,
                prefix: textProperties.prefix,
                suffix: textProperties.suffix,
                betweenCharacters: textProperties.betweenCharacters,
                betweenWords: textProperties.betweenWords,
                referenceId: textProperties.referenceId,
                isPrintArea: textProperties.isPrintArea,
                isOverlay: textProperties.isOverlay,
                groupId: textProperties.groupId,
                pageEpsId
            });

            text.set('fontSize', maxSizePx ?? textProperties.fontSize);
            text.setOutlineColor(ElementsColorService.colorToWeb(outlineColor || textProperties.stroke));

            if (textProperties.testingText) text.text = textProperties.testingText;
            if ($scope.previewMode) {
                text.lockMovementY = true;
                text.lockMovementX = true;
                text.lockScalingX = true;
                text.lockScalingY = true;
                text.lockRotation = true;
            }

            // Set the first position for color and font
            $scope.selectedTextProperties.fontColorOption = 1;
            $scope.selectedTextProperties.outlineColorOption = 1;
            await Promise.all([
                MultipleFontService.changeFontOption(text, 1, canvas),
                MultipleFontService.changeFontColorOption(undefined, text, 1, canvas),
                MultipleFontService.changeOutlineColorOption(text, 1, canvas)
            ]);

            return text;
        }

        async function loadImage(imageProperties, pageEpsId) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                migrateOldElement(imageProperties, [PREVIEW_TYPES.imagePlaceHoldersPreview]);
                DynamicImageService.initializeDynamicImagesMap(imageProperties);
                let objectCenterX = imageProperties.centerX;
                let objectCenterY = imageProperties.centerY;

                let imageWidth = imageProperties.width;
                let imageHeight = imageProperties.height;

                // Parse image color. This deals with old and new color formats.
                let color = MultipleFontService.parseColorFromProperty(imageProperties.color);

                if (imageProperties.calendar) {
                    const config =
                        typeof imageProperties.calendarConfig == 'string'
                            ? JSON.parse(imageProperties.calendarConfig)
                            : imageProperties.calendarConfig;
                    imageProperties.calendarConfig = config;
                }

                if (imageProperties.imageToImage) {
                    const config =
                        typeof imageProperties.imageToImageConfig == 'string'
                            ? JSON.parse(imageProperties.imageToImageConfig)
                            : imageProperties.imageToImageConfig;
                    imageProperties.imageToImageConfig = config;
                }

                if (imageProperties.imageEffects) {
                    const config =
                        typeof imageProperties.imageEffects == 'string'
                            ? JSON.parse(imageProperties.imageEffects)
                            : imageProperties.imageEffects;
                    imageProperties.imageEffects = config;
                }

                let img = new fabric.ImagePlaceholder(null, {
                    width: imageWidth,
                    height: imageHeight,
                    left: objectCenterX,
                    top: objectCenterY,
                    originX: 'center',
                    originY: 'center',
                    angle: imageProperties.rotation,
                    id: imageProperties.id,
                    uuid: imageProperties.uuid,
                    strokeWidth: canvas.getVisibleStrokeWidth(),
                    strokeDashArray: canvas.getDashedArray(),
                    stroke: 'black',
                    type: 'image-placeholder',
                    centeredRotation: true,
                    skewX: imageProperties.skewX,
                    skewY: imageProperties.skewY,
                    lockSkewingX: true,
                    lockSkewingY: true,
                    lockScalingFlip: true,
                    coverMaskArea: imageProperties.coverMaskArea,
                    RemoveBackground: imageProperties.RemoveBackground,
                    CutoutFace: imageProperties.CutoutFace,
                    removeBackgroundCOP: imageProperties.removeBackgroundCOP,
                    CustomilyRemoveBackground: imageProperties.CustomilyRemoveBackground,
                    CustomilyFaceCutOut: imageProperties.CustomilyFaceCutOut,
                    CustomilyImageFilter: imageProperties.CustomilyImageFilter,
                    isPencilDrawingActive: imageProperties.CustomilyImageFilter === ImageFilter.PENCIL,
                    isAquaFilterActive: imageProperties.CustomilyImageFilter === ImageFilter.AQUA,
                    textToImage: imageProperties.textToImage,
                    imageToImage: imageProperties.imageToImage,
                    imageToImageConfig: imageProperties.imageToImageConfig,
                    imageEffects: imageProperties.imageEffects,

                    fullColor: imageProperties.fullColor,
                    grading: imageProperties.grading,
                    zIndex: typeof imageProperties.zIndex === 'undefined' ? 0 : imageProperties.zIndex,
                    color: color,

                    hasStaticImage: imageProperties.hasStaticImage,
                    maskPath: imageProperties.maskPath,
                    dynamicImagesPath: imageProperties.dynamicImagesPath,
                    imageLibraryId: imageProperties.imageLibraryId,

                    colorLibraryId: imageProperties.colorLibraryId,
                    colors: imageProperties.colors || [],
                    selectedColorPosition: 1,
                    rotationStep: imageProperties.rotationStep,
                    removeWhiteBackground: imageProperties.removeWhiteBackground,

                    locked: imageProperties.locked,
                    visible: imageProperties.visible,
                    name: imageProperties.name,
                    preventEditMode:
                        $scope.previewMode || (imageProperties.dynamicImagesPath && !imageProperties.allowEdit),
                    isPrintArea: imageProperties.isPrintArea,
                    isOverlay: imageProperties.isOverlay,
                    isColorOptions: imageProperties.isColorOptions,
                    podProductImagesMetadata: imageProperties.podProductImagesMetadata,
                    groupId: imageProperties.groupId,
                    mapConfig: imageProperties.mapConfig,
                    wordCloudConfig: imageProperties.wordCloudConfig,
                    wordSearchConfig: imageProperties.wordSearchConfig,
                    pageEpsId,
                    isLimitImageToPlaceholder: imageProperties.isLimitImageToPlaceholder,
                    lockMovement: imageProperties.lockMovement,
                    lockScaling: imageProperties.lockScaling,
                    isGuide: imageProperties.isGuide,
                    allowEdit: imageProperties.allowEdit,
                    crossword: imageProperties.crossword,
                    CrosswordConfig: imageProperties.CrosswordConfig,
                    calendar: imageProperties.calendar,
                    calendarConfig: imageProperties.calendarConfig,
                    isProductGuidelines: imageProperties.isProductGuidelines,
                    testingUrl: imageProperties.testingUrl,
                    isMoonPhase: imageProperties.isMoonPhase,
                    hasTextMask: imageProperties.hasTextMask || false,
                    initWidth: imageProperties.initWidth,
                    initHeight: imageProperties.initHeight,
                    initCenterX: imageProperties.initCenterX,
                    initCenterY: imageProperties.initCenterY,
                    initRotation: imageProperties.initRotation,
                    allowSwapLibraryPosition: imageProperties.allowSwapLibraryPosition,
                    limitMovement: imageProperties.limitMovement
                });

                if (img.crossword) {
                    $scope.loadCrosswordTextures();
                }

                if (img.CrosswordConfig) {
                    CrosswordService.changeTexture(img.CrosswordConfig.path, img);
                }

                // For dynamic images disable edit mode
                if (img.dynamicImagesPath && !img.allowEdit) {
                    img.preventEditMode = true;
                }
                // Set image mode
                if (!img.fullColor && !img.grading) {
                    img.setMode(fabric.IMAGE_MODE_SINGLE_COLOR);
                } else if (!img.fullColor && img.grading) {
                    img.setMode(fabric.IMAGE_MODE_GRADING);
                } else {
                    img.setMode(fabric.IMAGE_MODE_FULL_COLOR);
                }
                // Set image color
                img.set('imageColor', ElementsColorService.colorToWeb(color));

                img.set('imageOutlineWidth', imageProperties.outlineWidth);
                img.set('imageOutlineColor', imageProperties.outlineColor);

                if ($scope.previewMode) {
                    img.lockMovementY = true;
                    img.lockMovementX = true;
                    img.lockScalingX = true;
                    img.lockScalingY = true;
                    img.lockRotation = true;
                }
                img.setFlip(imageProperties.flipX, imageProperties.flipY);

                // If it's static or its imported from PSD -> load image content
                if (imageProperties.hasStaticImage || imageProperties.psdImported) {
                    TestImageService.showStaticImage(canvas, img, imageProperties);
                } else if (imageProperties.mapConfig) {
                    const config =
                        typeof imageProperties.mapConfig == 'string'
                            ? JSON.parse(imageProperties.mapConfig)
                            : imageProperties.mapConfig;
                    const image = await mapUtils.getStaticMapImage(config);
                    TestImageService.showStaticImage(canvas, img, { imageUrl: image });
                } else if (imageProperties.dynamicImagesPath) {
                    // When loading the page we should show the image on position 1 on the dynamic placeholder
                    await DynamicImageService.showDynamicImage(canvas, img, 1);
                } else if (imageProperties.crossword) {
                    TestImageService.showStaticImage(canvas, img, {
                        imageUrl: imageProperties.testingUrl?.length
                            ? imageProperties.testingUrl
                            : require('@/assets/images/crossword-example.png')
                    });
                } else if (imageProperties.wordCloudConfig) {
                    TestImageService.showStaticImage(canvas, img, {
                        imageUrl: imageProperties.testingUrl?.length
                            ? imageProperties.testingUrl
                            : require('@/assets/images/wordcloud-example.png')
                    });
                } else if (imageProperties.wordSearchConfig) {
                    TestImageService.showStaticImage(canvas, img, {
                        imageUrl: imageProperties.testingUrl?.length
                            ? imageProperties.testingUrl
                            : require('@/assets/images/wordsearch-example.png')
                    });
                } else if (img.calendar) {
                    await $scope._generateCustomilyCalendar(img);
                } else {
                    TestImageService.showStaticImage(canvas, img, {
                        imageUrl: imageProperties.testingUrl?.length
                            ? imageProperties.testingUrl
                            : require('@/assets/images/photo-example.png')
                    });
                }

                // Set image color
                await DynamicImageService.changeDynamicImageColorPosition(img, 1, $scope.imageColorPicker, canvas);

                // Apply mask if any
                if (img.maskPath && getExtension(img.maskPath).toLowerCase() === 'svg') {
                    try {
                        const svgResponse = await fetch(buildCloudFrontUrl(img.maskPath));
                        if (!svgResponse.ok) {
                            throw new Error(`Failed to fetch SVG mask (status ${svgResponse.status}): ${img.maskPath}`);
                        }
                        const svgText = await svgResponse.text();
                        const sanitizedSvgString = sanitizeSvgString(svgText);
                        img.originalMaskSvg = sanitizedSvgString;
                        const svgMaskShape = await parseSvgMaskShape(sanitizedSvgString);
                        await applySvgMaskClipPath(img, svgMaskShape);
                        resolve(img);
                    } catch (error) {
                        reject(error);
                    }
                } else if (img.maskPath) {
                    const maskImage = new Image();
                    maskImage.onload = async function () {
                        // If the mask is just a full black image don't set it, we don't need it now
                        //  with the new image placeholder we don't use a fake mask anymore
                        if (await ImageUtilService.isFullMask(maskImage)) {
                            img.maskPath = null;
                        } else {
                            img.setMask(this);
                        }
                        resolve(img);
                    };
                    maskImage.onerror = function (_errorMsg, _url, _lineNumber, _column, error) {
                        reject(error);
                    };
                    maskImage.crossOrigin = 'Anonymous';
                    maskImage.src = buildCloudFrontUrl(img.maskPath);
                } else {
                    resolve(img);
                }
            });
        }

        async function loadVector(properties, pageEpsId) {
            migrateOldElement(properties, [PREVIEW_TYPES.vectorEPSPreview, PREVIEW_TYPES.imagePlaceHoldersPreview]);
            const dynamicVector = await DynamicVectorService.setVectorPlaceholderProperties(
                properties,
                canvas,
                $scope.previewMode,
                false,
                pageEpsId
            );

            if (properties.starMapConfig) {
                const config =
                    typeof properties.starMapConfig == 'string'
                        ? JSON.parse(properties.starMapConfig)
                        : properties.starMapConfig;

                var mutex = ProductService.getStarMapMutex();
                const starmapSVG = await starMapUtils.updatedDisplayStarMap(starMapUtils.updatedConfig(config), mutex);
                await DynamicVectorService.loadSVGStringOnPlaceholder(starmapSVG, dynamicVector, canvas);
            } else if (properties.qrConfig) {
                const qrConfig =
                    typeof properties.qrConfig == 'string' ? JSON.parse(properties.qrConfig) : properties.qrConfig;

                await $scope.displayQrWithConfig(qrConfig, dynamicVector);
            } else if (properties.allowUserUpload) {
                if (properties.contentIsPdf) {
                    dynamicVector.set('pdf', properties.pdf);
                    await dynamicVector._contentLoadPromise;
                } else if (properties.svgString) {
                    await DynamicVectorService.loadSVGStringOnPlaceholder(properties.svgString, dynamicVector, canvas);
                } else {
                    TestImageService.showStaticImageSvg(canvas, dynamicVector, {
                        imageUrl: require('@/assets/images/vector-example.svg')
                    });
                }
            } else if (properties.vectors && properties.vectors.length == 0 && !properties.vectorLibraryId) {
                TestImageService.showStaticImageSvg(canvas, dynamicVector, {
                    imageUrl: require('@/assets/images/dynamic-vector.svg')
                });
            }

            return dynamicVector;
        }

        $scope.showPlaceholderImgForSelectedVector = function (dynamicVector = null) {
            const vector = dynamicVector || canvas.getActiveObject();
            TestImageService.showStaticImageSvg(canvas, vector, {
                imageUrl: require('@/assets/images/dynamic-vector.svg')
            });
        };

        $scope.showPlaceholderImgForSelectedImage = function (dynamicImage = null) {
            const image = dynamicImage || canvas.getActiveObject();
            DynamicImageService.showSampleDynamicImage(canvas, image);
        };

        $scope.updateProductColorMetadata = function (imageFiles) {
            if (ProductService.getPod()) {
                ProductService.setIsProductColorModified(true);
            }
            ProductService.setProductColorsFilenames(imageFiles);
            // process text mask
            TextService.processTextMask(canvas, $scope, [$scope.imageSelected]);
        };

        function loadDataFromProduct() {
            return new $q(function (resolve) {
                // Load fonts
                if (ProductService) {
                    Sentry.setContext('product', {
                        id: ProductService.getProduct().id,
                        editing: true
                    });

                    // C20-4065: Detectar si el template ya tiene Meta Filtered Images
                    const product = ProductService.getProduct();
                    $scope.hasMetaFilteredImages =
                        product?.listEPS?.some(
                            (eps) =>
                                eps.imagePlaceHoldersEps?.some((ip) => ip.imageToImage) ||
                                eps.imagePlaceHoldersPreview?.some((ip) => ip.imageToImage)
                        ) ?? false;

                    // C20-4182: Detectar si el template ya usa Text to Image (Open AI / DALL-E)
                    $scope.hasTextToImage =
                        product?.listEPS?.some(
                            (eps) =>
                                eps.imagePlaceHoldersEps?.some((ip) => ip.textToImage) ||
                                eps.imagePlaceHoldersPreview?.some((ip) => ip.textToImage)
                        ) ?? false;

                    fontManagerService.getAllFonts().then(async function (fonts) {
                        const firstEps = ProductService.getEps();
                        Sentry.addBreadcrumb({
                            type: 'info',
                            category: 'template.step1',
                            message: 'Loading elements on step 1',
                            level: 'info',
                            data: {
                                hasText: !!firstEps.textsEps?.length,
                                hasCircularText: !!firstEps.circularTextsEps?.length,
                                hasImagePlaceholders: (firstEps.imagePlaceHoldersEps || []).some(
                                    (o) => !o.dynamicImagesPath
                                ),
                                hasDynamicImages: (firstEps.imagePlaceHoldersEps || []).some(
                                    (o) => o.dynamicImagesPath
                                ),
                                hasVectorPlaceholder: (firstEps.vectorEPSEps || []).some((o) => o.allowUserUpload),
                                hasDynamicVector: (firstEps.vectorEPSEps || []).some((o) => !o.allowUserUpload)
                            }
                        });

                        $scope.fonts = fonts;
                        let listEps = ProductService.getProduct().listEPS;

                        $scope.page.pageWidthDim = pixelsToMm(canvasWidth, firstEps.dpi);
                        $scope.page.pageHeightDim = pixelsToMm(canvasHeight, firstEps.dpi);

                        $scope.page.productName = ProductService.getProduct().name;
                        $scope.page.referenceId = ProductService.getProduct().referenceId;
                        $scope.page.exportColorMode = ProductService.getProduct().colorMode;
                        $scope.page.MergeFiles = ProductService.getProduct().MergeFiles;
                        $scope.exportPPI = firstEps.exportPPI;

                        console.debug('Loading EPS', listEps);
                        const groups = ProductService.getGroups().filter((g) => g.type === 'eps');
                        const groupsPositionValidation = groups.filter((g) => !g.position);
                        $scope.page.layoutOptimization = !$scope.editMode
                            ? true
                            : groups.length > 0
                            ? groupsPositionValidation.length === 0
                            : true;

                        const tasks = [];

                        try {
                            const payload = LibrariesAPIService.getLibraryPositionsFromListEps(listEps);
                            await LibrariesAPIService.getLibrariesElementAtPosition(payload);
                        } catch (error) {
                            console.log('Error getting library at position', error);
                        }

                        for (const indexEps in listEps) {
                            const eps = listEps[indexEps];
                            const pageEpsId = $scope.enablePageEps ? eps.id : null;

                            // Load texts
                            if (eps.textsEps) {
                                for (const element of eps.textsEps) {
                                    tasks.push(async () => await loadText(element, pageEpsId));
                                }
                            }

                            // Load circular texts
                            if (eps.circularTextsEps) {
                                for (const element of eps.circularTextsEps) {
                                    tasks.push(async () => await loadCircularText(element, pageEpsId));
                                }
                            }

                            // Load placeholder images
                            if (eps.imagePlaceHoldersEps) {
                                for (const element of eps.imagePlaceHoldersEps) {
                                    tasks.push(async () => await loadImage(element, pageEpsId));
                                }
                            }

                            // Load Dynamic EPS
                            if (eps.vectorEPSEps) {
                                for (const element of eps.vectorEPSEps) {
                                    tasks.push(async () => await loadVector(element, pageEpsId));
                                }
                            }
                        }

                        const elements = await ExecutionService.runTasksInChunks(tasks);

                        LibrariesAPIService.clearCachedLibraries();

                        // Sort elements by zIndex in ascending order
                        const orderedElements = elements.sort((a, b) => {
                            return a.zIndex - b.zIndex;
                        });

                        for (const canvasElement of orderedElements) {
                            if (canvasElement) {
                                canvas.add(canvasElement, true, false);
                            }
                        }

                        const groupsEps = ProductService.getGroups().filter((g) => g.type === 'eps');
                        const mgr = getGroupManager();
                        mgr?.assignResolvedPageEpsIdToGroupsList(groupsEps);

                        for (const group of groupsEps.sort((a, b) => {
                            if (a.parentId && !b.parentId) {
                                return -1;
                            }
                            if (!a.parentId && b.parentId) {
                                return 1;
                            }
                            return 0;
                        })) {
                            canvas.addGroup(group, true);
                        }

                        // Check if we have a background EPS or image
                        $scope.isBackgroundEPS = !!firstEps.baseEps;

                        // update texts effects
                        await $scope.updateTextEffects();

                        const elementsLinks = ProductService.getElementsLinks() || [];
                        sourceElementUtils.populateElementsLinks(elementsLinks, canvas, TextService);

                        // Load EPS base image if any
                        if (firstEps.baseImage) {
                            fabric.Image.fromURL(
                                buildCloudFrontUrl(firstEps.baseImage),
                                function (img) {
                                    img.set({
                                        originX: 'left',
                                        originY: 'top'
                                    });
                                    img.scaleToWidth(canvasWidth);

                                    canvas.setBackgroundImage(img, () => {
                                        canvas.requestRenderAll();
                                    });
                                    resolve();
                                },
                                {
                                    crossOrigin: 'Anonymous'
                                }
                            );
                        } else {
                            resolve();
                        }
                        setTimeout(() => {
                            canvas.fire('canvas:loaded');
                        }, 0);
                    });
                }
            });
        }

        /**
         * Change color mode for the product. Here we will update every old color format to the new color object
         *  so we can use CMYK colors if needed.
         */
        $scope.changeColorMode = function () {
            let objects = canvas._objects;

            const canvasObjectsTypes = {
                'bounded-text': { useFontMapForEach: true, outlineColor: true, shadowColor: true },
                'text-transform': { useFontMapForEach: true, strokeColor: true },
                'path-itext': { useFontMapForEach: true },
                'image-placeholder': { useFontMapForEach: false }
            };
            for (var i = 0; i < objects.length; i++) {
                var element = objects[i];

                if (Object.keys(canvasObjectsTypes).includes(element.type)) {
                    const obj = canvasObjectsTypes[element.type];
                    if (obj.useFontMapForEach) {
                        element.fontColorsMap.forEach(function (value, key, map) {
                            map.set(key, MultipleFontService.upgradeOldColor(value));
                        });
                    }
                    if (obj.outlineColor) {
                        element.outlineColor = MultipleFontService.upgradeOldColor(element.outlineColor);
                    }
                    if (obj.strokeColor) {
                        element.strokeColor = MultipleFontService.upgradeOldColor(element.strokeColor);
                    }
                    if (obj.shadowColor) {
                        element.shadowColor = MultipleFontService.upgradeOldColor(element.shadowColor);
                    }
                    element.color = MultipleFontService.upgradeOldColor(element.color);
                }
            }
            colorModeChanged = true;
        };

        $scope.changeFontTexture = function (texturePath, textSelected) {
            const object = textSelected || canvas.getActiveObject();
            if (!texturePath) {
                $scope.selectedTextProperties.texture = false;
                object.texture = null;
                object.textures = null;
            } else if (object.shadowType != null) {
                object.set?.('shadowType', null);
                object.shadowType = null;
            }
            // dirty way to make vue detect the change on text selected variable
            $scope.textSelected = { ...object };
            TextureService.changeFontTexture(texturePath, object, 1).then(() => {
                if ($scope.editMode) {
                    object.setEditedProp?.('texture');
                    object.setEditedProp?.('textures');
                }
                $scope.$apply(() => {
                    $scope.textSelected = object;
                });
                if (object?.pattern) {
                    for (const replica of TextService.getPatternReplicaObjects(canvas, object.uuid)) {
                        replica.texture = object.texture;
                        replica.textures = object.textures;
                        TextureService.changeFontTexture(texturePath, replica, 1);
                    }
                }
                canvas.requestRenderAll();
            });
            TextureService.checkIfAnyTextElementHasATexture(canvas, $scope);
        };

        $scope.addText = function (Itext, event, override = {}, isTextPath = false) {
            const defaultFont = fontManagerService.defaultFont;
            // Create a new BoundedText, the default font is always Arial
            const parameters = {
                canvasWidth,
                canvasHeight,
                strokeDashArray: canvas.getDashedArray(),
                id: $scope.getLastElementId() + 1,
                zIndex: canvas.getHighestZIndex() + 1,
                pageEpsId: canvas.getFirstActivePageEpsId(),
                Itext,
                name: '',
                flipX: false,
                flipY: false,
                isTextPath
            };

            let t = TextService.generateBoundedText(parameters, override);

            t.setFontFamily(defaultFont.Name + '_' + defaultFont.Style);
            t.setColor('#000000');
            if (isTextPath) {
                t.setStrokeColor('transparent');
                t.setStrokeWidth(0);
            } else {
                t.setStrokeWidth(canvas.getVisibleStrokeWidth());
                t.setShadowColor('#7258E0');
            }

            // Calculate min and max font sizes proportionally to the canvas size
            const canvasMin = Math.min(canvasWidth, canvasHeight);
            let maxSize = Math.ceil((canvasMin * (7 / 500) + 100 / 3) / 10) * 10;
            let minSize = 0;

            if (canvasMin < 1000) {
                maxSize = Math.ceil(canvasMin / 24);
            }

            t.setMaxSizePx(fabric.util.parseUnit(maxSize + 'pt'));
            t.setMinSizePx(fabric.util.parseUnit(minSize + 'pt'));

            t.name = getCanvasElementTitle(t);
            t.Itext = Itext;

            t.addedOnEdit = false;
            if ($scope.editMode) {
                t.addedOnEdit = true;
            }
            canvas.add(t);
            canvas.setActiveObject(t, event);

            MultipleFontService.changeFontOption(t, 1, canvas);
            return t;
        };

        $scope.addTextAlong = function (Itext, event, override = {}) {
            override = {
                ...override,
                maxFontSize: 400,
                minFontSize: 100,
                width: 600,
                height: 600
            };
            const text = $scope.addText(Itext, event, override, false);
            text.setTextPath?.('M -150,80 L 150,-80', true, true, {
                margin: 0.8
            });
            text.setText?.('TEXT');
        };

        $scope.addTextPath = function (Itext, event, override = {}) {
            override = {
                ...override,
                top: undefined,
                left: undefined,
                fontSize: 200,
                strokeWidth: 0,
                minSizePx: 200,
                maxSizePx: 200
            };
            const canvasMin = Math.min(canvasWidth, canvasHeight);
            override.fontSize = Math.ceil((canvasMin * (28 / 100)) / 10) * 10;
            override.minSizePx = override.fontSize;
            override.maxSizePx = override.fontSize;
            const text = $scope.addText(Itext, event, override, true);
            text.set({
                top: canvasHeight / 2 - text.height / 2,
                left: canvasWidth / 2 - text.width / 2
            });
            const newTransform = {
                ...text.transformOptions,
                points: [],
                type: 'warpForm'
            };
            text.setTransform(newTransform);
        };

        $scope.editWarpShape = function (activeObject) {
            activeObject.toggleEdit();
        };

        $scope.addCircularText = function (event) {
            // Create a new PathIText, the default font is always Arial
            const parameters = {
                canvasWidth,
                canvasHeight,
                id: $scope.getLastElementId() + 1,
                zIndex: canvas.getHighestZIndex() + 1,
                pathWidth: canvas.getVisibleStrokeWidth(),
                pageEpsId: canvas.getFirstActivePageEpsId(),
                flipX: false,
                flipY: false
            };
            const text = TextService.generatePathIText(parameters);

            text.addedOnEdit = false;
            text.name = getCanvasElementTitle(text);

            // Calculate font size proportionally to the canvas size
            const canvasMin = Math.min(canvasWidth, canvasHeight);
            let maxSize = Math.ceil(canvasMin / 1200) * 10;
            let minSize = 0;

            if (canvasMin < 1000) {
                maxSize = Math.ceil(canvasMin / 120);
            }

            text.set('minSizePx', fabric.util.parseUnit(minSize + 'pt'));
            text.set('maxSizePx', fabric.util.parseUnit(maxSize + 'pt'));
            text.set('fontSize', fabric.util.parseUnit(maxSize + 'pt'));

            if ($scope.editMode) {
                text.addedOnEdit = true;
            }

            canvas.add(text);
            canvas.setActiveObject(text, event);

            MultipleFontService.changeFontOption(text, 1, canvas);
        };

        $scope.uploadImagesOnPlaceholder = async function (view) {
            $scope.$apply(async function () {
                try {
                    const { bulkEdit, imageSelected, selectedObjectGroup, selectedImageProperties } = $scope;
                    const targetObjects = bulkEdit?.enabled ? selectedObjectGroup?._objects : [imageSelected];
                    const targetProperties = bulkEdit?.enabled ? bulkEdit?.selectedProperties : selectedImageProperties;

                    blockUI.start('Uploading images');
                    $timeout(() => $scope.$apply());

                    const position = targetProperties.dynamicImageVariation;

                    for (const object of targetObjects) {
                        $scope.initializeFilterObject(object, view.files[0]);
                        targetProperties.dynamicImageVariation = position;

                        await MultipleFileUploadService.uploadMultipleImages($scope, canvas, view.files, object);
                        if ($scope.hasFiltersToApply(targetProperties, object)) {
                            await $scope.processImageProperties(object, targetProperties);
                        }
                    }

                    $timeout(() => $scope.$apply());

                    view.value = null;

                    // process text mask
                    TextService.processTextMask(canvas, $scope, targetObjects);
                } finally {
                    $scope.$apply(function () {
                        blockUI.stop();
                    });
                }
            });
        };

        $scope.trustedTestSvg = '';

        $scope.resetSvgTestValue = async function () {
            const { bulkEdit, selectedObjectGroup, selectedSVGProperties } = $scope;
            const targetProperties = bulkEdit?.enabled ? bulkEdit?.selectedProperties : [selectedSVGProperties];
            const targetObjects = bulkEdit?.enabled ? selectedObjectGroup?._objects : [canvas.getActiveObject()];
            for (const targetObject of targetObjects) {
                const object = canvas
                    .getObjects()
                    .find((o) => o.uuid === targetObject.uuid && o.type === 'vector-placeholder');
                TestImageService.showStaticImageSvg(canvas, object, {
                    imageUrl: require('@/assets/images/vector-example.svg')
                });
                for (const prop of targetProperties) {
                    prop.svgString = '';
                    $scope.trustedTestSvg = '';
                }
                if (!skipSaveTestingValues) {
                    $scope.IndexDbService.findAndEditValue(object.uuid, '');
                }
            }
        };

        $scope.$watch('svgSelected.svgString', function (newVal) {
            if (newVal && !/^<!--\s*default customily vector\s*-->/.test(newVal.trim())) {
                $scope.trustedTestSvg = $sce.trustAsResourceUrl(
                    'data:image/svg+xml;utf8,' + encodeURIComponent(newVal)
                );
            } else {
                $scope.trustedTestSvg = '';
            }
        });

        $scope.isTextToImagePromptActive = false;
        $scope.isTextToImagePromptActiveBulk = false;
        $scope.setIsTextToImagePromptActive = function (value) {
            $scope.isTextToImagePromptActive = value;
        };
        $scope.setIsTextToImagePromptActiveBulk = function (value) {
            $scope.isTextToImagePromptActiveBulk = value;
        };

        $scope.generateTextToImageTest = function (promptText) {
            if (!promptText) return;

            const { bulkEdit, imageSelected, selectedObjectGroup } = $scope;
            const targetObjects = bulkEdit?.enabled ? selectedObjectGroup?._objects || [] : [imageSelected];
            const ids = targetObjects.filter(Boolean).map((object) => object.id);

            if (!ids.length) return;

            const data = { ids, prompt: promptText };

            $rootScope.$broadcast('generateTextToImageTest:stepOne', data);
            $rootScope.$broadcast('generateTextToImageTest:stepTwo', data);
        };

        $scope.$on('generateTextToImageTest:stepOne', async (_, data) => {
            if (!data?.ids?.length || !data?.prompt) return;

            const sameIdObjects = canvas
                .getObjects()
                .filter((o) => o.type === 'image-placeholder' && data.ids.includes(o.id));

            if (!sameIdObjects.length) return;

            try {
                $scope.showBlockUiLoader(true, 'Generating your image 📝✨🎨');
                await ImageEffectsService.processImageEffectsFromPrompt({
                    objects: sameIdObjects,
                    canvas,
                    username: $rootScope.user.Username,
                    prompt: data.prompt
                });
            } catch (error) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('We received an error:')
                        .htmlContent(error.message)
                        .ok('OK!')
                );
            } finally {
                $scope.showBlockUiLoader(false);
                $timeout(() => $scope.$apply());
            }
        });

        $scope.resetImageTestValue = async function () {
            const { bulkEdit, selectedObjectGroup } = $scope;

            const targetObjects = bulkEdit?.enabled ? selectedObjectGroup?._objects : [canvas.getActiveObject()];
            for (const targetObject of targetObjects) {
                const object = canvas.getObjects().find((o) => o.uuid === targetObject.uuid);
                targetObject.testingUrl = '';
                TestImageService.showStaticImage(canvas, object, {
                    imageUrl: require('@/assets/images/photo-example.png')
                });
                if (!skipSaveTestingValues) {
                    $scope.IndexDbService.findAndEditValue(object.uuid, '');
                }
            }
        };

        $scope.initializeFilterObject = (object, file) => {
            object.imageFile = file;
            object.oldImageFile = null;
            object.oldFCCustImageFile = null;
            object.oldRBCustImageFile = null;
            object.oldCustomilyImageFilterFile = null;
            object.oldImageToImageFile = null;
        };

        $scope.processImageProperties = async (object, targetProperties) => {
            if (targetProperties.RemoveBackground || object.RemoveBackground) {
                await $scope.handleApiProcess(
                    async () => await RemoveBgService.applyFilter(object, $scope, canvas),
                    $scope.apiKeys.removeBg,
                    'removeBg'
                );
            }
            if (targetProperties.CutoutFace || object.CutoutFace) {
                await $scope.handleApiProcess(
                    async () => await CutoutProUtilService.faceCutout($scope, canvas, true, true, object),
                    $scope.apiKeys.cutoutPro,
                    'cutoutPro'
                );
            }
            if (targetProperties.removeBackgroundCOP || object.removeBackgroundCOP) {
                await $scope.handleApiProcess(
                    async () => await CutoutProUtilService.faceCutout($scope, canvas, false, true, object),
                    $scope.apiKeys.cutoutPro,
                    'cutoutPro'
                );
            }
            if (targetProperties.CustomilyRemoveBackground || object.CustomilyRemoveBackground) {
                await $scope.handleApiProcess(
                    async () => await CustomilyRmbgService.applyFilter(object, $scope, canvas),
                    undefined,
                    'customilyRemoveBg'
                );
            }
            if (targetProperties.CustomilyFaceCutOut || object.CustomilyFaceCutOut) {
                await $scope.handleApiProcess(
                    async () => await CustomilyFaceCutOutService.applyFilter(object, $scope, canvas),
                    undefined,
                    'customilyFaceCutOut'
                );
            }
            if (targetProperties.CustomilyImageFilter || object.CustomilyImageFilter) {
                const filter = targetProperties.CustomilyImageFilter ?? object.CustomilyImageFilter;
                await $scope.handleApiProcess(
                    async () => await CustomilyImageFilterService.applyFilter(object, filter, $scope, canvas),
                    undefined,
                    'customilyImageFilter'
                );
            }
            if (object.imageToImage && object.imageToImageConfig?.prompt) {
                const imageToImageConfig = object.imageToImageConfig;
                if (imageToImageConfig) {
                    await OpenAIService.imageToImage(
                        $scope,
                        canvas,
                        $rootScope.user.Username,
                        $scope.imageSelected.imageFile
                    );
                }
            }

            if (object.imageEffects?.length) {
                try {
                    $scope.showBlockUiLoader(true, 'Transforming your image 📝✨🎨');
                    const sameIdObjects = canvas
                        .getObjects()
                        .filter((o) => o.type === 'image-placeholder' && o.id === object.id);
                    await ImageEffectsService.processImageEffects({
                        objects: sameIdObjects.length ? sameIdObjects : [object],
                        canvas,
                        username: $rootScope.user.Username,
                        file: $scope.imageSelected.imageFile
                    });
                } catch (error) {
                    const content = error.message?.includes('Invalid API key')
                        ? `
                      <span>
                        Oops! You applied an Image Effect but are missing the API Keys for this service provider. Please create an account with the service provider and connect it on our <a href="https://app.customily.com/account/integrations" target="_blank">Account Integrations</a> page. For more information, visit our <a href="https://help.customily.com/hc/en-us/articles/42103759321627-Adding-AI-Filters-and-Effects-to-User-Uploaded-Images#h_01K7HXR46DY4V1NS8BEQCAS7NT" target="_blank">help center</a>.
                      </span>
                    `
                        : error.message;
                    const title = error.message?.includes('Invalid API key')
                        ? 'Missing API Keys'
                        : 'We received an error:';
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title(title)
                            .htmlContent(content)
                            .ok('OK!')
                    );
                } finally {
                    $scope.showBlockUiLoader(false);
                }
            }
        };

        $scope.handleApiProcess = async (processFunction, apiKey, apiKeyName) => {
            if (apiKey !== null) {
                await processFunction();
            } else {
                $scope.showApiKeyInput[apiKeyName] = true;
            }
        };

        $scope.hasFiltersToApply = (targetProperties, object) => {
            return (
                (targetProperties.RemoveBackground && object.RemoveBackground) ||
                (targetProperties.CutoutFace && object.CutoutFace) ||
                (targetProperties.removeBackgroundCOP && object.removeBackgroundCOP) ||
                (targetProperties.CustomilyRemoveBackground && object.CustomilyRemoveBackground) ||
                (targetProperties.CustomilyFaceCutOut && object.CustomilyFaceCutOut) ||
                (targetProperties.CustomilyImageFilter && object.CustomilyImageFilter) ||
                (targetProperties.imageToImage && object.imageToImage) ||
                object.imageEffects
            );
        };

        $scope.addGuideImageElement = function (event) {
            const addElement = () => {
                const guideImage = $scope.addDynamicImage(event, false);
                guideImage.set('isGuide', true);
                guideImage.set('name', 'Guide Image');
                const btn = document.getElementById('uploadDynamicImages');
                setTimeout(() => btn.click(), 10);
            };
            const guideImages = canvas.getObjects().find((o) => o.isGuide);
            if (guideImages) {
                $mdDialog
                    .show(
                        $mdDialog
                            .confirm()
                            .title('Alert')
                            .textContent(
                                'This product already has guide image, creating a new guide image will replace the existing one. Do you wish tio continue?'
                            )
                            .ok('Yes, Replace guide')
                            .cancel('Cancel')
                    )
                    .then(() => {
                        canvas.remove(guideImages);
                        addElement();
                    });
                return;
            }

            addElement();
        };

        $scope.addProductGuidelines = function (event) {
            const addElement = () => {
                const productGuidelines = $scope.addDynamicImage(event, false);
                productGuidelines.isProductGuidelines = true;
                productGuidelines.name = 'Product Guidelines';
                const printAreaZindexes = canvas
                    .getObjects()
                    .filter((o) => o.isPrintArea)
                    .map((item) => item.zIndex);
                const printAreaZindexMin = Math.min(...printAreaZindexes);
                productGuidelines.zIndex = printAreaZindexMin - 1;
                canvas.moveTo(productGuidelines, productGuidelines.zIndex);
                canvas.setActiveObject(productGuidelines, event);

                if ($scope.page.pageWidthDim && $scope.page.pageHeightDim) {
                    $scope.updateWidth($scope.page.pageWidthDim, productGuidelines);
                    $scope.updateHeight($scope.page.pageHeightDim, productGuidelines);
                }
                const btn = document.getElementById('uploadDynamicImages');
                setTimeout(() => btn.click(), 10);
            };

            let hasProductGuidelines = false;
            if ($scope.currentPageEpsSelect) {
                hasProductGuidelines = canvas
                    .getObjects()
                    .find((o) => o.isProductGuidelines && o.pageEpsId == $scope.currentPageEpsSelect);
            } else {
                hasProductGuidelines = canvas.getObjects().find((o) => o.isProductGuidelines);
            }

            if (hasProductGuidelines) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .clickOutsideToClose(false)
                        .title('Product Guidelines')
                        .textContent('There can only be one Product Guidelines per page.')
                        .ok('Ok')
                );
            } else {
                addElement();
            }
        };

        $scope.buildImagePlaceholderProperties = function () {
            return {
                originX: 'center',
                originY: 'center',
                centeredRotation: true,
                left: canvasWidth / 2,
                top: canvasHeight / 2,
                stroke: 'black',
                strokeWidth: canvas.getVisibleStrokeWidth(),
                strokeDashArray: canvas.getDashedArray(),
                id: $scope.getLastElementId() + 1,
                uuid: uuidv4(),
                fullColor: true,
                grading: false,
                lockSkewingX: true,
                lockSkewingY: true,
                lockScalingFlip: false,
                width: 0.3 * canvasWidth,
                height: 0.3 * canvasWidth,
                zIndex: canvas.getHighestZIndex() + 1,
                hasStaticImage: false,
                color: MultipleFontService.createColorObj({
                    hex: '#000000',
                    cmyk: '0,0,0,1'
                }),
                selectedColorPosition: 1,
                RemoveBackground: false,
                CutoutFace: false,
                removeBackgroundCOP: false,
                CustomilyRemoveBackground: false,
                CustomilyFaceCutOut: false,
                CustomilyImageFilter: 0,
                isPencilDrawingActive: false,
                isAquaFilterActive: false,
                textToImage: false,
                imageToImage: false,
                imageToImageConfig: null,
                imageEffects: null,
                isOverlay: false,
                isPrintArea: false,
                pageEpsId: canvas.getFirstActivePageEpsId(),
                isLimitImageToPlaceholder: false,
                lockMovement: false,
                lockScaling: false,
                CrosswordConfig: null,
                calendarConfig: null,
                textTyped: $scope.defaultCrosswordText,
                outlineColor: '#000000',
                outlineWidth: 0,
                hasTextMask: false
            };
        };

        $scope.addImagePlaceholder = function (event, override) {
            const constructorProperties = { ...$scope.buildImagePlaceholderProperties(), ...override };
            const image = new fabric.ImagePlaceholder(null, constructorProperties);

            image.name = getCanvasElementTitle(image);
            image.addedOnEdit = false;
            if ($scope.editMode) {
                image.addedOnEdit = true;
            }

            canvas.add(image);
            canvas.setActiveObject(image, event);
            TestImageService.showStaticImage(canvas, image, {
                imageUrl: require('@/assets/images/photo-example.png')
            });
        };

        $scope.addCrossword = async function (event) {
            $scope.loadCrosswordTextures();

            const crossword = new fabric.ImagePlaceholder(null, $scope.buildImagePlaceholderProperties());

            crossword.addedOnEdit = $scope.editMode;
            crossword.crossword = true;

            canvas.add(crossword);
            canvas.setActiveObject(crossword, event);
            TestImageService.showStaticImage(canvas, crossword, {
                imageUrl: require('@/assets/images/crossword-example.png')
            });
        };

        $scope.addWordCloud = function (event) {
            const wordcloud = new fabric.ImagePlaceholder(null, $scope.buildImagePlaceholderProperties());
            const defaultFont = fontManagerService.defaultFont;

            wordcloud.addedOnEdit = $scope.editMode;
            wordcloud.wordCloudConfig = {
                minFontSize: 0,
                maxFontSize: 100,
                maxWords: 200,
                font: defaultFont.Path,
                useImageColors: true,
                shapeMap: []
            };
            wordcloud.name = getCanvasElementTitle(wordcloud);

            canvas.add(wordcloud);
            canvas.setActiveObject(wordcloud, event);
            TestImageService.showStaticImage(canvas, wordcloud, {
                imageUrl: require('@/assets/images/wordcloud-example.png')
            });
        };

        $scope.addWordSearch = function (event) {
            const wordSearch = new fabric.ImagePlaceholder(null, $scope.buildImagePlaceholderProperties());
            const defaultFont = fontManagerService.defaultFont;

            wordSearch.addedOnEdit = $scope.editMode;
            wordSearch.wordSearchConfig = {
                fontSize: 20,
                gridCols: 20,
                gridRows: 20,
                wordColor: '#7258E0',
                highlightColor: '#EDE9FB',
                gridColor: '#EBF9FA',
                backgroundColor: '#FFFFFF00',
                fillerColor: '#EBF9FA',
                highlightStrokeColor: undefined,
                highlightStrokeWidth: 0,
                font: defaultFont.Path
            };

            wordSearch.name = getCanvasElementTitle(wordSearch);
            canvas.add(wordSearch);
            canvas.setActiveObject(wordSearch, event);
            TestImageService.showStaticImage(canvas, wordSearch, {
                imageUrl: require('@/assets/images/wordsearch-example.png')
            });
        };

        $scope.addMap = async function (event) {
            const map = new fabric.ImagePlaceholder(null, {
                originX: 'center',
                originY: 'center',
                centeredRotation: true,
                left: canvasWidth / 2,
                top: canvasHeight / 2,
                stroke: 'black',
                strokeWidth: canvas.getVisibleStrokeWidth(),
                strokeDashArray: canvas.getDashedArray(),
                id: $scope.getLastElementId() + 1,
                uuid: uuidv4(),
                fullColor: true,
                grading: false,
                lockSkewingX: true,
                lockSkewingY: true,
                lockScalingFlip: false,
                width: 0.3 * canvasWidth,
                height: 0.3 * canvasWidth,
                zIndex: canvas.getHighestZIndex() + 1,
                color: MultipleFontService.createColorObj({
                    hex: '#000000',
                    cmyk: '0,0,0,1'
                }),
                hasStaticImage: false,
                isColorOptions: false,
                RemoveBackground: false,
                isOverlay: false,
                isPrintArea: false,
                coverMaskArea: true,
                mapConfig: {
                    hasPin: false,
                    // latitude, logitude and zoom for global map view
                    latitude: 17.9,
                    longitude: -37.34,
                    zoom: 1.077,
                    availableStyles: [MAP_STYLE_PRESETS[0].value],
                    defaultStyle: MAP_STYLE_PRESETS[0].value
                },
                pageEpsId: canvas.getFirstActivePageEpsId()
            });
            map.name = getCanvasElementTitle(map);
            map.addedOnEdit = !!$scope.editMode;

            canvas.add(map);
            canvas.moveTo(map, map.zIndex);
            canvas.setActiveObject(map, event);
            const image = await mapUtils.getStaticMapImage(map.mapConfig);
            TestImageService.showStaticImage(canvas, map, { imageUrl: image });
        };

        $scope.addStarMap = async function (event) {
            const parameters = {
                canvas,
                canvasWidth,
                canvasHeight,
                id: $scope.getLastElementId() + 1,
                uuid: uuidv4()
            };
            const vectorPlaceholderProperties = VectorUtilService.buildVectorPlaceholderProperties(parameters);
            var starMap = new fabric.VectorPlaceholder({
                ...vectorPlaceholderProperties,
                starMapConfig: {
                    selectedLocation: [0, 0],
                    selectedDate: new Date(),
                    showConstellations: true,
                    showMilkyWay: true,
                    showGridLines: true,
                    shopperConfigEnabled: false,
                    defaultStyle: JSON.parse(angular.toJson(starMapUtils.STAR_MAP_STYLES[0])),
                    availableStyles: JSON.parse(angular.toJson([starMapUtils.STAR_MAP_STYLES[0]]))
                }
            });

            starMap.set('zIndex', canvas.getHighestZIndex() + 1);
            starMap.set('centeredRotation', true);
            starMap.set('cornerSize', 0.015 * canvas.width);
            starMap.set('transparentCorners', false);
            starMap.vectors = [];

            starMap.set('addedOnEdit', false);
            if ($scope.editMode) {
                starMap.set('addedOnEdit', true);
            }

            if ($('#vectorEPSLoader')[0]) {
                $('#vectorEPSLoader')[0].value = null;
            }

            canvas.add(starMap);
            canvas.moveTo(starMap, starMap.zIndex);
            canvas.setActiveObject(starMap, event);
            starMap.name = getCanvasElementTitle(starMap);
            starMap.setCoords();

            var mutex = ProductService.getStarMapMutex();
            const starmapSVG = await starMapUtils.showCelestialContainer(starMap.starMapConfig, mutex);
            $scope.displayStringSVG(starmapSVG, canvas.getActiveObject(), canvas);
        };

        $scope.displayQrWithConfig = async (config = {}, object) => {
            var mutex = ProductService.getQrMutex();
            const content = await QrUtilService.getQrSvg(config, mutex);
            await $scope.displayStringSVG(content, object, canvas);
        };

        $scope.addQr = async function (event) {
            const parameters = {
                canvas,
                canvasWidth,
                canvasHeight,
                id: $scope.getLastElementId() + 1,
                uuid: uuidv4()
            };
            const vectorPlaceholderProperties = VectorUtilService.buildVectorPlaceholderProperties(parameters);
            // New QR elements use the styled config (`options`); existing ones stay on the legacy
            //  shape and keep rendering through /api/QR/GenerateSvg - see qrUtilService.
            const qrConfig = buildStyledQrConfig();
            var qr = new fabric.VectorPlaceholder({
                ...vectorPlaceholderProperties,
                qrConfig
            });

            qr.set('zIndex', canvas.getHighestZIndex() + 1);
            qr.set('centeredRotation', true);
            qr.set('cornerSize', 0.015 * canvas.width);
            qr.set('transparentCorners', false);
            qr.vectors = [];

            qr.set('addedOnEdit', false);
            if ($scope.editMode) {
                qr.set('addedOnEdit', true);
            }

            if ($('#vectorEPSLoader')[0]) {
                $('#vectorEPSLoader')[0].value = null;
            }

            canvas.add(qr);
            canvas.moveTo(qr, qr.zIndex);
            canvas.setActiveObject(qr, event);
            qr.name = getCanvasElementTitle(qr);
            qr.setCoords();

            $scope.displayQrWithConfig(qrConfig, canvas.getActiveObject());
        };

        $scope.addVectorPlaceholder = function (event) {
            const parameters = {
                canvas,
                canvasWidth,
                canvasHeight,
                id: $scope.getLastElementId() + 1,
                uuid: uuidv4()
            };
            const vectorPlaceholderProperties = VectorUtilService.buildVectorPlaceholderProperties(parameters);
            const vectorPlaceholder = new fabric.VectorPlaceholder(vectorPlaceholderProperties);

            // Properties
            vectorPlaceholder.set('zIndex', canvas.getHighestZIndex() + 1);
            vectorPlaceholder.set('centeredRotation', true);
            vectorPlaceholder.set('cornerSize', 0.015 * canvas.width);
            vectorPlaceholder.set('transparentCorners', false);
            vectorPlaceholder.vectors = [];

            vectorPlaceholder.set('addedOnEdit', false);
            if ($scope.editMode) {
                vectorPlaceholder.set('addedOnEdit', true);
            }

            if ($('#vectorEPSLoader')[0]) {
                $('#vectorEPSLoader')[0].value = null;
            }

            vectorPlaceholder.name = getCanvasElementTitle(vectorPlaceholder);
            vectorPlaceholder.setCoords();
            canvas.add(vectorPlaceholder);
            canvas.setActiveObject(vectorPlaceholder, event);
            TestImageService.showStaticImageSvg(canvas, vectorPlaceholder, {
                imageUrl: require('@/assets/images/vector-example.svg')
            });
        };

        $scope.createMoonPhaseMap = () => {
            const baseUrl = '/Content/product-images/moonphase/';
            const map = new Map();
            for (let i = 1; i <= 8; i++) {
                const url = `${baseUrl}${i}.png`;
                map.set(i, url);
            }
            return map;
        };

        $scope.addMoonPhases = async function (event) {
            $scope.addDynamicImage(event, false, {
                dynamicImagesPath: $scope.createMoonPhaseMap(),
                isMoonPhase: true
            });
        };

        $scope.addMetaFilteredImage = async function (event) {
            $scope.addImagePlaceholder(event, {
                imageToImage: true
            });
        };

        $scope.addDynamicImage = function (event, isPrintArea = false, override = {}) {
            const image = DynamicImageService.createDynamicImage(canvas, $scope.getLastElementId() + 1, override);
            // We don't want to delete step one created dynamic images on step2

            image.addedOnEdit = !!$scope.editMode;
            canvas.add(image, false, !isPrintArea);
            canvas.setActiveObject(image, event);

            if (!isPrintArea) DynamicImageService.showDynamicImage(canvas, canvas.getActiveObject(), 1);

            return image;
        };

        $scope.buildDynamicVector = function (isSolidBackground = false) {
            const parameters = {
                canvasWidth,
                canvasHeight,
                id: $scope.getLastElementId() + 1,
                uuid: uuidv4(),
                zIndex: isSolidBackground ? 1 : canvas.getHighestZIndex() + 1,
                isSolidBackground,
                canvas
            };
            const vectorPlaceholder = DynamicVectorService.addDynamicVector(parameters);
            vectorPlaceholder.set('addedOnEdit', !!$scope.editMode);
            if ($('#vectorEPSLoader')[0]) {
                $('#vectorEPSLoader')[0].value = null;
            }
            return vectorPlaceholder;
        };

        $scope.addDynamicEPSPlaceholder = function (event) {
            const vectorPlaceholder = $scope.buildDynamicVector();
            vectorPlaceholder.setCoords();
            canvas.add(vectorPlaceholder);
            canvas.setActiveObject(vectorPlaceholder, event);
            TestImageService.showStaticImageSvg(canvas, vectorPlaceholder, {
                imageUrl: require('@/assets/images/dynamic-vector.svg')
            });
        };

        $scope.adjustSolidBackground = async function (vectorPlaceholder, event = null) {
            canvas.setActiveObject(vectorPlaceholder, event);
            vectorPlaceholder.locked = false;

            $scope.onElementSelectedAlign('fit');
            const vectorString = VectorUtilService.createEPSSolidBg(vectorPlaceholder.width, vectorPlaceholder.height);
            const vectorFile = new File([vectorString], `${uuidv4()}.svg`, { type: 'image/svg+xml' });
            await $scope.displayVectorsOnPlaceholder([vectorFile], true);

            vectorPlaceholder.locked = true;
        };

        $scope.addSolidBg = async function (event, hex = '#B69AF2') {
            const vectorPlaceholder = $scope.buildDynamicVector(true);
            vectorPlaceholder.isSolidBackground = true;
            vectorPlaceholder.applyColoring = true;
            const color = getColorObj({ hex, a: 1 });
            if (color && color.cmyk) {
                vectorPlaceholder.colors = [
                    {
                        hex: color.hex,
                        alpha: color.a,
                        cmyk: `${color.cmyk.c},${color.cmyk.m},${color.cmyk.y},${color.cmyk.k}`,
                        position: 1
                    }
                ];
            }

            vectorPlaceholder.setCoords();
            canvas.insertAt(vectorPlaceholder, 0, false);
            $scope.updateZIndex(1, vectorPlaceholder);
            await $scope.adjustSolidBackground(vectorPlaceholder, event);
        };

        $scope.hasSolidBackground = function () {
            return canvas?._objects?.find(
                (o) =>
                    o.type === 'vector-placeholder' &&
                    o.isSolidBackground &&
                    o.pageEpsId === canvas.getFirstActivePageEpsId()
            );
        };

        $scope.addSpotifyPlayer = function () {
            SpotifyService.addSpotifyPlayer($scope, canvas, canvasWidth, canvasHeight);
        };

        $scope.displayVectorsOnPlaceholder = function (files, isSolidBg = false) {
            const { bulkEdit, selectedObjectGroup, selectedSVGProperties } = $scope;
            const targetObjects = bulkEdit?.enabled ? selectedObjectGroup?._objects : [canvas.getActiveObject()];
            const targetProperties = bulkEdit?.enabled ? bulkEdit?.selectedProperties : selectedSVGProperties;

            for (const targetObject of targetObjects) {
                MultipleFileUploadService.uploadMultipleVectors(
                    files,
                    targetObject,
                    // TODO: need validation position not to be null or 0
                    targetProperties.position,
                    canvas,
                    $scope.editMode,
                    function (progress) {
                        $scope.vectorEPSUploadPercent = progress;
                        $timeout(function () {
                            $scope.$apply();
                        });
                    },
                    function (position) {
                        // Upload started
                        targetProperties.position = position;
                        $scope.uploadingVectorEPS = true;
                        $scope.vectorEPSUploadPercent = 0;
                        $timeout(function () {
                            $scope.$apply();
                        });
                    },
                    function (position) {
                        // Upload end
                        targetProperties.position = position;
                        $scope.uploadingVectorEPS = false;
                        $timeout(function () {
                            $scope.$apply();
                        });
                    },
                    isSolidBg
                );
            }
        };

        $scope.displayStringSVG = function (svgString, object, canvas) {
            if (!svgString.length) return;
            const contentLoadPromise = DynamicVectorService.loadSVGStringOnPlaceholder(svgString, object, canvas);
            $timeout(() => $scope.$apply());
            return contentLoadPromise;
        };

        $scope.displaySVGOnPlaceholder = async function (files) {
            const { bulkEdit, selectedObjectGroup } = $scope;
            const targetObjects = bulkEdit?.enabled ? selectedObjectGroup?._objects : [canvas.getActiveObject()];

            if (files && files[0]) {
                for (const targetObject of targetObjects) {
                    const objects = canvas
                        .getObjects()
                        .filter(
                            (o) => o.id === targetObject.id && o.type === 'vector-placeholder' && o.allowUserUpload
                        );
                    for (const object of objects) {
                        await DynamicVectorService.loadFileOnPlaceholder(files[0], object, canvas);
                    }
                }
                $timeout(() => $scope.$apply());
            }
        };

        $scope.changeDynamicEPSPosition = function () {
            const { bulkEdit, selectedObjectGroup, selectedSVGProperties } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? selectedObjectGroup?._objects
                : canvas.getActiveObjects().filter((object) => object.type === 'vector-placeholder');
            const targetProperties = bulkEdit?.enabled ? bulkEdit?.selectedProperties : selectedSVGProperties;

            const tasks = [];
            for (const targetObject of targetObjects) {
                tasks.push(
                    async () =>
                        await DynamicVectorService.changeDynamicEPSPosition(
                            targetObject,
                            targetProperties.position,
                            canvas
                        )
                );
            }
            ExecutionService.runTasksInChunks(tasks);
        };

        $scope.changeDynamicImageColorPosition = function () {
            const {
                selectedImageProperties,
                imageColorPicker,
                bulkEditImageColorPicker,
                bulkEdit,
                selectedObjectGroup
            } = $scope;
            const { enabled: bulkEditEnabled, selectedProperties: bulkEditSelectedProperties } = bulkEdit;

            const colorPosition = bulkEditEnabled
                ? bulkEditSelectedProperties.colorPosition
                : selectedImageProperties.colorPosition;
            const targetObjects = bulkEditEnabled ? selectedObjectGroup?._objects : [canvas.getActiveObject()];

            const tasks = [];
            for (const targetObject of targetObjects) {
                tasks.push(
                    async () =>
                        await DynamicImageService.changeDynamicImageColorPosition(
                            targetObject,
                            colorPosition,
                            bulkEditEnabled ? bulkEditImageColorPicker : imageColorPicker,
                            canvas
                        )
                );
            }
            ExecutionService.runTasksInChunks(tasks);
        };

        $scope.toggleShapeTransform = function (activeObject, shapeType) {
            activeObject.setTransform({
                points: [],
                type: null
            });
            activeObject.setTransform(
                {
                    points: [],
                    type: 'warpForm'
                },
                {
                    sample: shapeType
                }
            );
        };

        $scope.selectInnerRectangle = function (activeObject) {
            activeObject.fire('object:dblclick');
        };

        /****************************************************************************/
        /****************************** PARAMETERS UPDATE ***************************/
        /****************************************************************************/
        $scope.setExportPPI = function (ppi) {
            $scope.exportPPI = ppi;
            if (canvas) {
                const pageEps = canvas.getFirstActivePageEps();
                canvas.updatePageEps(pageEps, {
                    exportPPI: $scope.exportPPI
                });
            }
        };

        $scope.updateText = function (text, object) {
            const { bulkEdit, allObjectsHaveSamePropertyValue, getValueOrUndefined, selectedObjectGroup } = $scope;
            const targetProperties = bulkEdit.enabled ? bulkEdit.selectedProperties : $scope.selectedTextProperties;
            TextService.updateTexts(text, object, canvas);
            if (!skipSaveTestingValues) {
                $scope.IndexDbService.findAndEditValue(object.uuid, text);
            }
            if (bulkEdit?.enabled) {
                const objects = selectedObjectGroup._objects;
                const sameValues = allObjectsHaveSamePropertyValue(objects, 'getFontSize', true);
                const firstObject = objects[0];
                const currentFontSize = getValueOrUndefined(
                    sameValues,
                    firstObject?.getFontSize ? fabric.util.pxToPt(firstObject?.getFontSize()) : undefined
                );
                targetProperties.currentFontSize = currentFontSize;
            } else {
                targetProperties.currentFontSize = fabric.util.pxToPt(object.getFontSize && object.getFontSize());
            }
            targetProperties.text = object.getText ? object.getText() : object.text;
            object.setEditedProp('text');

            if (object.isPersonalizableText === false) {
                object.defaultValue = targetProperties.text;
                targetProperties.defaultValue = targetProperties.text;
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updatePersonalizableText = function (isPersonalizable, object) {
            if (!object) {
                return;
            }
            object.isPersonalizableText = isPersonalizable;
            object.setEditedProp?.('isPersonalizableText');
            const currentText = object.getText ? object.getText() : object.text;
            object.defaultValue = isPersonalizable ? '' : currentText;
            $scope.selectedTextProperties.defaultValue = object.defaultValue;
        };

        $scope.updateMaskBoundsRectangleCenterX = function (mm = 0) {
            if (!$scope.beforeMergeProduct) return;
            __imageDesign._maskBoundsRectangle.set('left', mmToPixels(mm, $scope.DPI));
            __imageDesign._maskBoundsRectangle.setCoords();
            __imageDesign._maskBoundsRectangle.fire('moving');
            canvas.renderAll();
        };

        $scope.updateMaskBoundsRectangleCenterY = function (mm = 0) {
            if (!$scope.beforeMergeProduct) return;
            __imageDesign._maskBoundsRectangle.set('top', mmToPixels(mm, $scope.DPI));
            __imageDesign._maskBoundsRectangle.setCoords();
            __imageDesign._maskBoundsRectangle.fire('moving');
            canvas.renderAll();
        };

        $scope.updateWidth = function (mm = 1, object, keepRatio = false) {
            if (!object) {
                return;
            }

            if (object.isType('activeSelection')) {
                // The width property of an ActiveSelection always remains static, while getScaledWidth changes!
                // Use the static width as the reference to calculate the new scale
                const newScale = mmToPixels(mm, $scope.DPI) / object.width;
                object.scale(newScale);
            }
            if (
                object.type === 'image-placeholder' &&
                object.hasInitValues &&
                object.hasInitValues() &&
                object.setWidth
            ) {
                object.setWidth(mmToPixels(mm, $scope.DPI) / object.scaleX, keepRatio);
            } else if (object.setWidth) {
                object.setWidth(mmToPixels(mm, $scope.DPI) / object.scaleX);
            } else {
                object.set('width', mmToPixels(mm, $scope.DPI) / object.scaleX);
            }

            object.setCoords();
            if ($scope.editMode) {
                object.editedSize = true;
            }
            canvas.renderAll();

            if (object.isType('activeSelection')) {
                canvas.fire('customilyActiveSelection:modified', { skipWidth: true });
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateHeight = function (mm = 1, object, keepRatio = false) {
            if (!object) {
                return;
            }

            if (object.isType('activeSelection')) {
                // The height property of an ActiveSelection always remains static, while getScaledHeight changes!
                // Use the static height as the reference to calculate the new scale
                const newScale = mmToPixels(mm, $scope.DPI) / object.height;
                object.scale(newScale);
            } else if (
                object.type === 'image-placeholder' &&
                object.hasInitValues &&
                object.hasInitValues() &&
                object.setHeight
            ) {
                object.setHeight(mmToPixels(mm, $scope.DPI) / object.scaleY, keepRatio);
            } else if (object.setHeight) {
                object.setHeight(mmToPixels(mm, $scope.DPI) / object.scaleY);
            } else {
                object.set('height', mmToPixels(mm, $scope.DPI) / object.scaleX);
            }

            object.setCoords();
            if ($scope.editMode) {
                object.editedSize = true;
            }
            canvas.renderAll();

            if (object.isType('activeSelection')) {
                canvas.fire('customilyActiveSelection:modified', { skipHeight: true });
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateMaskBoundsRectangleWidth = function (mm = 0, linked) {
            if (!$scope.beforeMergeProduct) return;

            const px = mmToPixels(mm, $scope.DPI);
            const ratio =
                (__imageDesign._maskBoundsRectangle.width * __imageDesign._maskBoundsRectangle.scaleX) /
                (__imageDesign._maskBoundsRectangle.height * __imageDesign._maskBoundsRectangle.scaleY);

            __imageDesign._maskBoundsRectangle.set('width', px);

            if (linked) {
                const newHeight = px / ratio;
                $scope.updateMaskBoundsRectangleHeight(pixelsToMm(newHeight, $scope.DPI), false);
            }

            __imageDesign._maskBoundsRectangle.setCoords();
            __imageDesign._maskBoundsRectangle.fire('scaling');
            canvas.renderAll();
        };

        $scope.updateMaskBoundsRectangleHeight = function (mm = 0, linked) {
            if (!$scope.beforeMergeProduct) return;

            const px = mmToPixels(mm, $scope.DPI);
            const ratio =
                (__imageDesign._maskBoundsRectangle.width * __imageDesign._maskBoundsRectangle.scaleX) /
                (__imageDesign._maskBoundsRectangle.height * __imageDesign._maskBoundsRectangle.scaleY);
            __imageDesign._maskBoundsRectangle.set('height', px);

            if (linked) {
                const newWidth = px * ratio;
                $scope.updateMaskBoundsRectangleWidth(pixelsToMm(newWidth, $scope.DPI), false);
            }

            __imageDesign._maskBoundsRectangle.setCoords();
            __imageDesign._maskBoundsRectangle.fire('scaling');
            canvas.renderAll();
        };

        $scope.updateMinSizePx = function (size = 0, object) {
            const { selectedTextProperties, bulkEdit } = $scope;
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedTextProperties;

            if (!size) {
                size = 0;
                targetProperties.minSizePx = 0;
            }

            // Don't let the minimum font size to go over the max size
            if (targetProperties) {
                if (size > targetProperties.maxSizePx) {
                    size = targetProperties.maxSizePx;
                    targetProperties.minSizePx = size;
                }
            }

            object.set('minSizePx', fabric.util.parseUnit(size + 'pt'));
            targetProperties.currentFontSize = fabric.util.pxToPt(object.getFontSize());
            $scope.currentFontSizeValidator();

            if ($scope.editMode) {
                object.editedSize = true;
            }
            canvas.requestRenderAll();
        };

        $scope.updateMaxSizePx = function (size = 0, object) {
            const { selectedTextProperties, bulkEdit } = $scope;
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedTextProperties;

            if (!size) {
                size = 0;
                targetProperties.maxSizePx = 0;
            }

            object.set('maxSizePx', fabric.util.parseUnit(size + 'pt'));
            targetProperties.currentFontSize = fabric.util.pxToPt(object.getFontSize());

            if ($scope.editMode) {
                object.editedSize = true;
            }
            canvas.requestRenderAll();
        };

        $scope.updateMultiline = function (multiline, object) {
            object.setMultiline(multiline);
            if ($scope.editMode) {
                object.setEditedProp?.('multiline');
            }
            canvas.requestRenderAll();
        };

        $scope.updateVerticalText = function (verticalText, object) {
            const { selectedTextProperties, bulkEdit } = $scope;
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedTextProperties;

            object.setVerticalText(verticalText);
            targetProperties.verticalText = verticalText;

            if ($scope.editMode) {
                object.setEditedProp?.('verticalText');
            }
            canvas.requestRenderAll();
        };

        $scope.updateCaps = function (caps, object) {
            object.set('caps', caps);
            if ($scope.editMode) {
                object.setEditedProp?.('caps');
            }

            canvas.requestRenderAll();
        };

        $scope.updateDisplayStarMap = async function (config) {
            if (!Celestial) return;
            const { shopperConfigEnabled } = config;
            if (shopperConfigEnabled) {
                if ($scope.svgSelected) {
                    $scope.svgSelected.starMapConfig.showConstellations = shopperConfigEnabled;
                    $scope.svgSelected.starMapConfig.showMilkyWay = shopperConfigEnabled;
                    $scope.svgSelected.starMapConfig.showGridLines = shopperConfigEnabled;
                }
            }

            if ($scope.svgSelected) {
                var mutex = ProductService.getStarMapMutex();
                const starmapSVG = await starMapUtils.updatedDisplayStarMap(starMapUtils.updatedConfig(config), mutex);
                $scope.displayStringSVG(starmapSVG, canvas.getActiveObject(), canvas);
            }
        };

        $scope.updateQrText = async function (newText) {
            if ($scope.svgSelected) {
                const newConfig = setQrData($scope.svgSelected.qrConfig, newText);
                $scope.displayQrWithConfig(newConfig, $scope.svgSelected);
            }
        };

        $scope.updateStarMapStyleList = async function (style, isSelected, object) {
            let starMapStyles = object.starMapConfig?.availableStyles || [];
            let defaultStyle = object.starMapConfig?.defaultStyle;
            let isDefaultRemoved = false;
            //Pushing the style as it is was adding a hashkey to the object in the array
            if (isSelected) starMapStyles.push(JSON.parse(angular.toJson(style)));
            else {
                starMapStyles = starMapStyles.filter((s) => s.label != style.label);
                isDefaultRemoved = style.label == defaultStyle.label;
            }

            let defaultStyleChanged = false;
            if (starMapStyles.length == 1 || isDefaultRemoved) {
                defaultStyle = starMapStyles[0];
                defaultStyleChanged = true;
            }
            object.set('starMapConfig', {
                ...object.starMapConfig,
                defaultStyle,
                availableStyles: starMapStyles
            });

            if (defaultStyleChanged) {
                await $scope.updateDisplayStarMap(object.starMapConfig);
            } else {
                starMapUtils.updatedConfig(object.starMapConfig);
            }

            if ($scope.editMode) {
                object.setEditedProp?.('starMapConfig');
            }
        };

        $scope.disableStarMapStyle = function (style, object) {
            const starMapStyles = object?.starMapConfig?.availableStyles || [];
            return (
                starMapStyles.length == 1 && starMapStyles.map((storedStyle) => storedStyle.label).includes(style.label)
            );
        };

        $scope.updateMap = function (object) {
            let defaultStyle = object.mapConfig?.defaultStyle;
            mapUtils
                .getStaticMapImage({
                    ...object.mapConfig,
                    defaultStyle
                })
                .then((imageUrl) => {
                    TestImageService.showStaticImage(canvas, object, { imageUrl });
                });
        };

        $scope.applyCustomStyleRules = function (mapConfig) {
            const { customStyle } = mapConfig;
            if (!customStyle) return;

            const hasDefault = !!mapConfig.defaultStyle;
            const availables = mapConfig.availableStyles || [];

            const alreadyExists = availables.includes(customStyle);

            if (!hasDefault && availables.length === 0) {
                mapConfig.defaultStyle = customStyle;
                mapConfig.availableStyles = [customStyle];
                return;
            }

            if (!alreadyExists) {
                mapConfig.availableStyles = [...availables, customStyle];
            }
        };

        $scope.setMapImageDisplay = function (showPin, object) {
            const config = { ...object.mapConfig, hasPin: showPin };
            object.set('mapConfig', config);

            if ($scope.editMode) {
                object.setEditedProp?.('mapConfig');
            }
        };

        $scope.openMap = async function (object) {
            if (!$scope.mapElements) return;

            const onCancelClicked = () => {
                mapUtils.closeModal($scope.mapElements.modal);
                mapUtils.clearGeocoder($scope.mapElements.geocoder);
            };

            const setMapImage = () => {
                const snapshot = mapUtils.getMapSnapshot($scope.mapElements.map);
                const img = new Image();
                img.src = snapshot;
                img.onload = () => {
                    object.setElement(img);
                    canvas.renderAll();
                };
            };

            const onSelectClicked = () => {
                onCancelClicked();
                setMapImage();
                const { lng: longitude, lat: latitude } = $scope.mapElements.map.getCenter();
                $scope.selectedMapProps.coordinates = `${longitude}, ${latitude}`;
                const config = {
                    ...object.mapConfig,
                    longitude,
                    latitude,
                    zoom: $scope.mapElements.map.getZoom()
                };

                object.set('mapConfig', config);
                if ($scope.editMode) object.setEditedProp?.('mapConfig');

                // Check if map is source for other elements and set them
                sourceElementUtils.setAllTargetsFromSource(canvas, object);
            };
            mapUtils.openModal($scope.mapElements.modal);
            $scope.mapElements.map.resize();

            await mapUtils.setMapOptions($scope.mapElements.map, object.mapConfig);
            mapUtils.setActionsCallback(onSelectClicked, onCancelClicked);
        };

        $scope.updateImageType = function (type, object) {
            const { selectedImageProperties, editMode, imageColorPicker, bulkEditImageColorPicker, bulkEdit } = $scope;
            const { enabled: bulkEditEnabled, selectedProperties: bulkEditSelectedProperties } = bulkEdit;
            $scope.removeColorLibrary(object);

            if (type == 'single color') {
                object.fullColor = false;
                object.grading = false;
                selectedImageProperties.fullColor = false;
                selectedImageProperties.grading = false;
                object.setMode(fabric.IMAGE_MODE_SINGLE_COLOR);
                if (bulkEditEnabled) {
                    bulkEditSelectedProperties.imageType = fabric.IMAGE_MODE_SINGLE_COLOR;
                    bulkEditSelectedProperties.fullColor = false;
                    bulkEditSelectedProperties.grading = false;
                    bulkEditSelectedProperties.isColorLibraryIdMixed = undefined;
                    bulkEditSelectedProperties.colorLibraryId = undefined;
                    object.setColor('#000000');
                    bulkEditImageColorPicker.setColor('#000000');
                }
                object.colors = undefined;
                object.colorLibraryId = undefined;
            } else if (type == 'grading') {
                object.fullColor = false;
                object.grading = true;

                // Grading is always black for EPS
                object.setMode(fabric.IMAGE_MODE_GRADING);
                object.setColor('#000000');

                if (bulkEditEnabled) {
                    bulkEditSelectedProperties.imageType = fabric.IMAGE_MODE_GRADING;
                    bulkEditSelectedProperties.fullColor = false;
                    bulkEditSelectedProperties.grading = true;
                    bulkEditImageColorPicker.setColor('#000000');
                } else {
                    selectedImageProperties.fullColor = false;
                    selectedImageProperties.grading = true;
                    imageColorPicker.setColor('#000000');
                }
            } else if (type == 'full color') {
                object.fullColor = true;
                object.grading = false;
                selectedImageProperties.fullColor = true;
                selectedImageProperties.grading = false;
                object.setMode(fabric.IMAGE_MODE_FULL_COLOR);

                if (bulkEditEnabled) {
                    bulkEditSelectedProperties.imageType = fabric.IMAGE_MODE_FULL_COLOR;
                    bulkEditSelectedProperties.fullColor = true;
                    bulkEditSelectedProperties.grading = false;
                }
            }

            canvas.renderAll();
            if (editMode) {
                object.setEditedProp?.('fullColor', 'grading', 'colors', 'colorLibraryId');
            }
        };

        $scope.updatePrefix = function (prefix, object) {
            if ($scope.editMode) {
                object.setEditedProp?.('prefix');
            }
            object.set('prefix', prefix);
            canvas.renderAll();
        };

        $scope.updateSuffix = function (suffix, object) {
            if ($scope.editMode) {
                object.setEditedProp?.('suffix');
            }
            object.set('suffix', suffix);
            canvas.renderAll();
        };

        $scope.updateFlipX = function (object) {
            if (!object) {
                return;
            }

            if (object.isType('activeSelection')) {
                object.getObjects()?.forEach((o) => {
                    $scope.updateFlipX(o);
                });

                return;
            }

            const flip = object.getFlip();
            object.setFlip(!flip.flipX, flip.flipY);
            object.setCoords();
            canvas.renderAll();
        };

        $scope.updateFlipY = function (object) {
            if (!object) {
                return;
            }

            if (object.isType('activeSelection')) {
                object.getObjects()?.forEach((o) => {
                    $scope.updateFlipY(o);
                });

                return;
            }

            const flip = object.getFlip();
            object.setFlip(flip.flipX, !flip.flipY);
            object.setCoords();
            canvas.renderAll();
        };

        $scope.setFontSize = function (fontSize, object) {
            if ($scope.editMode) {
                object.editedSize = true;
            }

            object.set('fontSize', fabric.util.parseUnit(fontSize + 'pt'));
            canvas.renderAll();
        };

        $scope.forceFontSize = function (fontSize, object) {
            object.forceFontSize(fabric.util.parseUnit(fontSize + 'pt'));
            canvas.requestRenderAll();
        };

        $scope.updateTextSide = function (side, object) {
            if ($scope.editMode) {
                object.setEditedProp?.('convex');
            }
            object.set('convex', side === 'convex');
            canvas.renderAll();
        };

        $scope.updateId = function (newId, object) {
            if (newId) {
                object.id = newId;
            }
        };

        $scope.updateSelectedElementZIndex = function (object, forward = true) {
            const element = object || canvas.getActiveObject();
            const currentZIndex = element.isType('activeSelection') ? 0 : element.zIndex;
            const zIndexChange = forward ? currentZIndex + 1 : currentZIndex - 1;
            $scope.updateZIndex(zIndexChange, element);
        };

        $scope.bringElementToFront = function (element) {
            $scope.layersInstance.$children[0].bringElementToFront(element);
        };

        $scope.sendElementToBack = function (element) {
            $scope.layersInstance.$children[0].sendElementToBack(element);
        };

        $scope.moveElementForward = function (element) {
            $scope.layersInstance.$children[0].moveElementForward(element);
        };

        $scope.moveElementBackward = function (element) {
            $scope.layersInstance.$children[0].moveElementBackward(element);
        };

        $scope.onArrangeLayer = function (element, position) {
            const action = {
                forward: $scope.moveElementForward,
                backward: $scope.moveElementBackward,
                front: $scope.bringElementToFront,
                back: $scope.sendElementToBack
            };
            action[position]?.(element);
        };

        $scope.updateZIndex = async function (zIndex, object) {
            if (!object) {
                return;
            }

            if (object.isType('activeSelection')) {
                object.getObjects()?.forEach((o) => {
                    let newZIndex = o.zIndex + zIndex;

                    // Z index can't go over the length of the list
                    if (newZIndex < 0) newZIndex = 0;
                    else if (newZIndex > canvas.getObjects().length - 1) newZIndex = canvas.getObjects().length - 1;

                    // Set the z index for this object
                    o.zIndex = newZIndex;
                    canvas.moveTo(o, newZIndex);
                });
            } else {
                // Z index can't go over the length of the list
                if (zIndex <= 0) zIndex = 1;
                else if (zIndex >= canvas.getObjects().length) zIndex = canvas.getObjects().length + 1;

                // Set the z index for this object
                object.zIndex = zIndex;
                canvas.moveTo(object, zIndex);
            }

            canvas.renderAll();
            $scope.layersInstance.$children[0].refreshLayerPanel();

            // update text masks
            await $scope.handleTextAsMaskOnZIndexUpdated();
        };

        $scope.updateRotationLock = function (rotationLock, object) {
            object.set('rotationStep', rotationLock ? 90 : 1);
            if ($scope.editMode) {
                object.setEditedProp?.('rotationStep');
            }
        };

        $scope.updateVectorAllowEdit = function (allowEdit, object) {
            object.set('allowEdit', allowEdit);
            // Keep preventEditMode in sync with the live toggle - it's only computed once at
            //  construction time otherwise, so double-click wouldn't start respecting a checkbox
            //  change until the object gets reconstructed (e.g. on the next step transition).
            object.preventEditMode = !allowEdit;
            $scope.resetVectorPosition(object);

            if (allowEdit) {
                object.set('limitMovement', true);
                $scope.selectedSVGProperties.limitMovement = true;
                if ($scope.editMode) {
                    object.setEditedProp?.('limitMovement');
                }
            } else if (!allowEdit && object.limitMovement) {
                object.set('limitMovement', false);
                $scope.selectedSVGProperties.limitMovement = false;
                if ($scope.editMode) {
                    object.setEditedProp?.('limitMovement');
                }
            }

            if ($scope.editMode) {
                object.setEditedProp?.('allowEdit');
            }
        };

        $scope.adjustVectorPosition = function (vector) {
            if (vector) {
                vector.resetVectorPositionAndSize();
                vector.fire('object:dblclick');
                vector.saveVectorPosition = true;
            }
        };

        $scope.resetVectorPosition = function (vector) {
            if (vector) {
                vector.resetInitPosition();
                $scope.selectedSVGProperties.initWidth = null;
                $scope.selectedSVGProperties.initHeight = null;
                $scope.selectedSVGProperties.initCenterX = null;
                $scope.selectedSVGProperties.initCenterY = null;
                $scope.selectedSVGProperties.initRotation = null;
            }
        };

        $scope.updateVectorLimitMovement = function (limitMovement, object) {
            object.set('limitMovement', limitMovement);
            if ($scope.editMode) {
                object.setEditedProp?.('limitMovement');
            }
        };

        $scope.addFaceCutoutFilter = async (faceCutout, object = null, cleanImageFilters = true) => {
            const { bulkEdit, imageSelected, disableImageFilters } = $scope;
            const targetObject = object ? object : imageSelected;
            const canCleanImageFilters =
                bulkEdit?.enabled &&
                cleanImageFilters &&
                !(targetObject.CutoutFace || targetObject.removeBackgroundCOP);

            if (canCleanImageFilters) {
                disableImageFilters(targetObject, {
                    openAI: true,
                    'cutoutPro-removebg': faceCutout ? true : undefined,
                    'cutoutPro-faceCutout': faceCutout ? undefined : true,
                    removebg: true,
                    'customily-removebg': true,
                    'customily-facecut': true,
                    imageToImage: true
                });
            }

            await CutoutProUtilService.addFaceCutoutFilter($scope, canvas, faceCutout, targetObject);
        };

        $scope.openFreeCredits = function () {
            $window.open('https://www.cutout.pro/?vsource=cutout_share-1679178-plan1');
            $scope.creditsSelected = true;
        };

        $scope.openFreeMonth = function () {
            $window.open('https://www.cutout.pro/?vsource=cutout_share-1679178-plan2');
            $scope.creditsSelected = true;
        };

        $scope.sendRemoveBgAPIKey = async function () {
            await ImageFilterManagerService.filterManager($scope, 'removeBg');
        };

        $scope.sendCutoutproAPIKey = async function () {
            await ImageFilterManagerService.filterManager($scope, 'cutoutPro');
        };

        $scope.activateRemoveBG = async function (value, object) {
            if (value && $scope.bulkEdit?.enabled) {
                $scope.disableImageFilters(object, {
                    openAI: true,
                    'cutoutPro-removebg': true,
                    'cutoutPro-faceCutout': true,
                    'customily-removebg': true,
                    'customily-facecut': true,
                    imageToImage: true
                });
            }

            object.RemoveBackground = value;
            if ($scope.editMode) {
                object.setEditedProp?.('RemoveBackground');
            }

            // Next line means that an image was previously used. If that's the case reusing it from file and avoid API call.
            if (!object.oldImageFile && object.RemoveBackground) {
                if (!$scope.apiKeys.removeBg) {
                    $scope.showApiKeyInput.removeBg = true;
                } else {
                    if (object.imageFile) await RemoveBgService.applyFilter(object, $scope, canvas);
                }
            } else if (object.oldImageFile) {
                // If does not have an oldImageFile it is useless to swap.
                await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [object.oldImageFile], object);
                // Swap between with and without background
                const aux = object.oldImageFile;
                object.oldImageFile = object.imageFile;
                object.imageFile = aux;
            }

            // Hide API input if unchecking remove.bg checkbox
            if (!$scope.apiKeys.removeBg && !object.RemoveBackground) {
                $timeout(() => $scope.$apply());
                $scope.showApiKeyInput.removeBg = false;
            }
        };

        $scope.activateCustomilyRemoveBG = async function (value = false, object) {
            try {
                if (value && $scope.bulkEdit?.enabled) {
                    $scope.disableImageFilters(object, {
                        openAI: true,
                        'cutoutPro-removebg': true,
                        'cutoutPro-faceCutout': true,
                        removebg: true,
                        'customily-facecut': true,
                        imageToImage: true
                    });
                }

                object.CustomilyRemoveBackground = value;
                if ($scope.editMode) {
                    object.setEditedProp?.('CustomilyRemoveBackground');
                }

                // Next line means that an image was previously used. If that's the case reusing it from file and avoid API call.
                if (object.CustomilyRemoveBackground) {
                    if (object.imageFile) await CustomilyRmbgService.applyFilter(object, $scope, canvas);
                } else if (object.oldRBCustImageFile) {
                    // If does not have an oldImageFile it is useless to swap.
                    await MultipleFileUploadService.uploadMultipleImages(
                        $scope,
                        canvas,
                        [object.oldRBCustImageFile],
                        object
                    );
                    // Swap between with and without background
                    const aux = object.oldRBCustImageFile;
                    object.oldRBCustImageFile = object.imageFile;
                    object.imageFile = aux;
                }
            } catch (error) {
                console.log(error);
            }
        };

        $scope.activateImageToImage = async function (value = false, object) {
            try {
                if (value && $scope.bulkEdit?.enabled) {
                    $scope.disableImageFilters(object, {
                        openAI: true,
                        'cutoutPro-removebg': true,
                        'cutoutPro-faceCutout': true,
                        removebg: true,
                        'customily-removebg': true,
                        'customily-facecut': true
                    });
                }

                object.imageToImage = value;
                if ($scope.editMode) {
                    object.setEditedProp?.('imageToImage');
                }

                // Next line means that an image was previously used. If that's the case reusing it from file and avoid API call.
                if (!object.oldImageFile && object.imageToImage && object?.imageToImageConfig?.prompt) {
                    if (object.imageFile)
                        await OpenAIService.imageToImage($scope, canvas, $rootScope.user.Username, object.imageFile);
                } else if (object.oldImageFile) {
                    // If does not have an oldImageFile it is useless to swap.
                    await MultipleFileUploadService.uploadMultipleImages(
                        $scope,
                        canvas,
                        [object.oldImageToImageFile],
                        object
                    );
                    // Swap between with and without background
                    const aux = object.oldImageToImageFile;
                    object.oldImageToImageFile = object.imageFile;
                    object.imageFile = aux;
                }
            } catch (error) {
                console.log(error);
            }
        };

        $scope.activateImageToImagePrompt = async function (value = false, object) {
            try {
                if (!object.imageToImageConfig) {
                    object.imageToImageConfig = {};
                }

                object.imageToImageConfig.prompt = value;
                if ($scope.editMode) {
                    object.setEditedProp?.('imageToImageConfig');
                }
            } catch (error) {
                console.log(error);
            }
        };

        $scope.activateCustomilyFaceCutOut = async function (value = false, object) {
            try {
                if (value && $scope.bulkEdit?.enabled) {
                    $scope.disableImageFilters(object, {
                        openAI: true,
                        'cutoutPro-removebg': true,
                        'cutoutPro-faceCutout': true,
                        removebg: true,
                        'customily-removebg': true,
                        imageToImage: true
                    });
                }

                object.CustomilyFaceCutOut = value;
                if ($scope.editMode) {
                    object.setEditedProp?.('CustomilyFaceCutOut');
                }

                // Next line means that an image was previously used. If that's the case reusing it from file and avoid API call.
                if (object.CustomilyFaceCutOut) {
                    if (object.imageFile) await CustomilyFaceCutOutService.applyFilter(object, $scope, canvas);
                } else if (object.oldFCCustImageFile) {
                    // If does not have an oldImageFile it is useless to swap.
                    await MultipleFileUploadService.uploadMultipleImages(
                        $scope,
                        canvas,
                        [object.oldFCCustImageFile],
                        object
                    );
                    // Swap between with and without background
                    const aux = object.oldFCCustImageFile;
                    object.oldFCCustImageFile = object.imageFile;
                    object.imageFile = aux;
                }
            } catch (error) {
                console.log(error);
            }
        };

        $scope.generateImageFromText = (textTyped) => {
            OpenAIService.textToImage($scope, canvas, $rootScope.user.Username, textTyped);
        };

        $scope.generateImageFromImage = async () => {
            if (!$scope.imageSelected?.imageToImageConfig?.prompt || !$scope.imageSelected.imageFile) {
                throw new Error('Fill the prompt and the image to continue');
            }

            await OpenAIService.imageToImage($scope, canvas, $rootScope.user.Username, $scope.imageSelected.imageFile);
        };

        $scope.adjustImagePosition = function (image) {
            if (image) {
                image.resetImagePositionAndSize();
                image.fire('object:dblclick');
                // Set saveImagePosition AFTER entering edit mode: fire('object:dblclick') calls
                //  setActiveObject on the mask rectangle, which deselects the group, and the
                //  group's 'deselected' handler resets saveImagePosition to false.
                image.saveImagePosition = true;
                // saveImagePosition bypasses the locks, so restore the hidden handles.
                image._applyEditModeLockControls?.();
            }
        };

        $scope.resetImagePosition = function (image) {
            if (image) {
                image.resetInitPosition();
                $scope.selectedImageProperties.initWidth = null;
                $scope.selectedImageProperties.initHeight = null;
                $scope.selectedImageProperties.initCenterX = null;
                $scope.selectedImageProperties.initCenterY = null;
                $scope.selectedImageProperties.initRotation = null;
            }
        };

        $scope.generateCrossword = () => {
            const crossword = canvas.getActiveObject();
            const texturePath = CrosswordService.getCurrentTexture(crossword);
            const textureUrl = texturePath ? buildCloudFrontUrl(texturePath) : null;
            CrosswordService.generateCrossword($scope, canvas, crossword.textTyped, textureUrl);
        };

        $scope.changeCrosswordTexture = function (texturePath) {
            const crossword = canvas.getActiveObject();
            if ($scope.editMode) {
                crossword.setEditedProp?.('CrosswordConfig');
            }

            CrosswordService.changeTexture(texturePath, crossword);
            $scope.generateCrossword(crossword.textTyped);

            canvas.renderAll();
        };

        $scope.customilyCalendar = {
            date: new Date(),
            markerTypes: [
                {
                    value: 'pencil',
                    text: 'Pencil'
                },
                {
                    value: 'pin',
                    text: 'Pin'
                },
                {
                    value: 'circle',
                    text: 'Circle'
                },
                {
                    value: 'rect',
                    text: 'Rect'
                },
                {
                    value: 'heart',
                    text: 'Heart'
                },
                {
                    value: 'heart_outline',
                    text: 'Heart outline'
                }
            ],
            markerType: 'heart',
            markFill: true,
            showHorizontalLine: true,
            monthNames: 'January,February,March,April,May,June,July,August,September,October,November,December',
            dayLetters: 'S,M,T,W,T,F,S'
        };

        $scope.onCalendarDateChange = async () => {
            await $scope._generateCustomilyCalendar($scope.imageSelected);
        };

        $scope.setCustomilyCalendarFont = (font) => {
            if (!font) {
                return;
            }
            const parsedFont = font.Path.replace('Content/', '');
            const fontPath = `${process.env.VUE_APP_CLOUDFRONT_URL}${parsedFont}`;
            $scope.updateCalendarConfig({
                yearMonthFontPath: fontPath,
                yearFontPath: fontPath,
                monthFontPath: fontPath,
                daysTitlesFontPath: fontPath,
                dayFontPath: fontPath
            });
            const fontName = `${font.Name} (${font.Style})`;
            $scope.searchFont = {
                selectedText: fontName,
                previousSelectedText: fontName,
                previousSelectedValue: font.Path,
                searchText: ''
            };
            $scope.selectedImageProperties.fontPath = font.Path;
        };

        $scope._generateCustomilyCalendar = _.debounce(async function (object) {
            try {
                const output = await generateCustomilyCalendar(object, $scope.customilyCalendar.date);
                TestImageService.showStaticImage(canvas, object, {
                    imageUrl: output
                });
                return output;
            } catch (error) {
                console.error('generateCustomilyCalendar', error);
            }
        }, 200);

        $scope.loadCalendarColors = async (object) => {
            try {
                $scope.$applyAsync();
                const options = {
                    ...object.calendarConfig
                };

                const yearColor = options?.yearColor || '#000000';
                const markColor = options?.markColor || '#ff0000';
                const dayColorHighlight = options?.dayColorHighlight || '#000000';

                $scope.calendarTitleColorPicker.setColor({
                    hex: yearColor
                });
                $scope.calendarMarkerColorPicker.setColor({
                    hex: markColor
                });
                $scope.calendarHighlightedColorPicker.setColor({
                    hex: dayColorHighlight
                });
                $scope.$applyAsync();
            } catch (error) {
                console.error('loadColorCalendarConfig', error);
            }
        };

        $scope.addCalendar = async function (event) {
            try {
                const object = new fabric.ImagePlaceholder(null, $scope.buildImagePlaceholderProperties());
                const customilyCalendar = new CustomilyCalendar();
                const options = customilyCalendar.getConfig();

                object.addedOnEdit = $scope.editMode;
                object.calendar = true;
                object.calendarConfig = options;

                canvas.add(object);
                canvas.setActiveObject(object, event);
            } catch (error) {
                console.error('An error ocurred trying to addCalendar', error);
            }
        };

        $scope.updateCalendarConfig = async function (options) {
            if (!options) {
                return;
            }
            const object = canvas.getActiveObject();

            if (!object || !object.calendar) {
                return;
            }

            const updatedOptions = {
                ...object.calendarConfig,
                ...options
            };

            const customilyCalendar = new CustomilyCalendar(updatedOptions);
            const newOptions = customilyCalendar.getConfig();

            object.calendarConfig = {
                ...newOptions
            };

            if ($scope.editMode) {
                object.setEditedProp?.('calendarConfig');
            }

            await $scope._generateCustomilyCalendar(object);

            canvas.requestRenderAll();
        };

        $scope.updateCalendarTitleColor = function (colors) {
            if (!$scope.imageSelected) {
                return;
            }
            $scope.updateCalendarConfig({
                yearMonthColor: `#${colors.HEX}`,
                yearColor: `#${colors.HEX}`,
                monthColor: `#${colors.HEX}`,
                daysTitlesColor: `#${colors.HEX}`,
                dayColor: `#${colors.HEX}`,
                lineColor: `#${colors.HEX}`
            });
        };

        $scope.updateCalendarMarkerColor = function (colors) {
            if (!$scope.imageSelected) {
                return;
            }
            $scope.updateCalendarConfig({
                markColor: `#${colors.HEX}`,
                markBorderColor: `#${colors.HEX}`
            });
        };

        $scope.updateCalendarHighlightColor = function (colors) {
            if (!$scope.imageSelected) {
                return;
            }
            $scope.updateCalendarConfig({
                dayColorHighlight: `#${colors.HEX}`
            });
        };

        $scope.updateTextToImage = function (textToImage, object) {
            if (textToImage && $scope.bulkEdit?.enabled) {
                $scope.disableImageFilters(object, {
                    'cutoutPro-removebg': true,
                    'cutoutPro-faceCutout': true,
                    removebg: true,
                    'customily-removebg': true,
                    'customily-facecut': true,
                    'customily-imageFilter': true,
                    imageToImage: true
                });
            }
            object.set('textToImage', textToImage);
            if ($scope.editMode) {
                object.setEditedProp?.('textToImage');
            }
        };

        $scope.updateImageToImagePrompt = function (prompt, object) {
            object.set('imageToImageConfig', {
                ...object.imageToImageConfig,
                prompt
            });
            if ($scope.editMode) {
                object.setEditedProp?.('imageToImageConfig');
            }
        };

        /****************************************************************************/
        /***************************** TEXT UTILS ***********************************/
        /****************************************************************************/
        $scope.uploadFont = function (files) {
            if (files && files[0]) {
                $scope.uploadingFont = true;
                $scope.fontUploadPercent = 0;

                fontManagerService
                    .uploadFont(files[0], (progress) => {
                        $scope.fontUploadPercent = progress;
                    })
                    .then(async function () {
                        // Font uploaded!
                        const fonts = await fontManagerService.initFonts();
                        $scope.fonts = fonts;
                        $scope.filteredFonts = $scope.fonts;
                        $scope.uploadingFont = false;
                    })
                    .catch(function () {
                        $scope.uploadingFont = false;
                    });
            }
        };

        $scope.deleteFont = function (font) {
            const { bulkEdit, selectedTextProperties } = $scope;
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedTextProperties;

            // Save the current font path because when we click on the delete icon the font is also selected so we
            //  want to go back to the current font after deletion
            let fontPath = targetProperties.fontPath;

            FontManagerService.deleteFont(font).then(async function (fontDeleted) {
                if (fontDeleted) {
                    const fonts = await fontManagerService.initFonts();
                    $scope.fonts = fonts;
                    $scope.filteredFonts = $scope.fonts;
                }
                targetProperties.fontPath = fontPath;
                if (Object.prototype.hasOwnProperty.call($scope, 'searchFont')) {
                    const selectedFont = fontManagerService.findFontByPath(targetProperties.fontPath);
                    if (selectedFont) {
                        const fontName = `${selectedFont.Name} (${selectedFont.Style})`;
                        $scope.searchFont = {
                            selectedText: fontName,
                            previousSelectedText: fontName,
                            previousSelectedValue: targetProperties.fontPath,
                            searchText: ''
                        };
                    } else {
                        $scope.searchFont = {
                            selectedText: '',
                            previousSelectedText: '',
                            previousSelectedValue: '',
                            searchText: ''
                        };
                    }
                    $scope.$applyAsync();
                }
            });
        };

        $scope.deselectAll = async function () {
            canvas.discardActiveObject().requestRenderAll();
            canvas.fire('selection:cleared');
            $scope.textSelected = null;
            $scope.imageSelected = null;
            $scope.svgSelected = null;

            // update texts effects
            await $scope.updateTextEffects();
        };

        $scope.saveDesignTemplate = async () => {
            blockUI.stop();
            blockUI.start(`Saving design template`);
            $timeout(() => $scope.$apply());

            // Set the thumbnail image in the preview as it's used for thumbnail when listing designs
            $scope.deselectAll();
            for (const element of canvas.getObjects()) {
                clearBorder(element);
            }
            canvas.renderAll();
            // Save the template as a design
            const product = await DesignStudioSaveService.processSaving(SaveAs.DesignTemplate);
            blockUI.stop();

            return product;
        };

        $scope.saveProduct = async () => {
            blockUI.stop();
            blockUI.start(`Saving template`);
            $timeout(() => $scope.$apply());

            $scope.deselectAll();
            const product = await DesignStudioSaveService.processSaving(SaveAs.Template);
            blockUI.stop();

            return product;
        };

        $scope.deselectAllAndClearBorders = function () {
            if (!canvas) return;
            $scope.deselectAll();
            const elements = canvas.getObjects();
            for (const element of elements) {
                clearBorder(element);
            }

            canvas.renderAll();
        };

        $scope.onNextStepHandler = function () {
            const previewBgAlreadyExists = !!ProductService.getPreviewImage() || !!ProductService.getPreviewBgColor();
            if (previewBgAlreadyExists || $scope.forProductTemplateCreation) {
                $scope.goToStep2();
                return;
            }
            $scope.showPreviewBackgroundModal = true;
        };

        $scope.onCancelPreviewBackground = function () {
            $scope.showPreviewBackgroundModal = false;
        };

        $scope.onSetPreviewBackground = function (background) {
            ProductService.setProductPreviewBackground(background);
            $scope.goToStep2();
        };

        /**
         * Save all template data from step 1
         * @param {boolean} saveNow wether to skip all other steps and save the template right away
         */
        $scope.goToStep2 = async function (saveNow = false) {
            blockUI.start('Saving data');
            if (colorModeChanged) {
                ProductService.setNeedColorsUpgrade(true);
            }

            // We first deselect all the active elements on the canvas in order for the their
            //  attributes to get updated if modified using multiple selection
            $scope.deselectAll();
            ProductService.clearEPS();
            if (!$scope.enablePageEps) {
                const eps = {
                    width: canvasWidth,
                    height: canvasHeight,
                    dpi: $scope.DPI,
                    exportPPI: $scope.exportPPI,
                    baseEps: baseEPSPath,
                    mirror: $scope.page.mirror,
                    mergeOutput: $scope.page.mergeOutput,
                    name: 'File 1',
                    zIndex: 0,
                    zIndexPreview: 0
                };
                ProductService.addNewEPS(eps, true);
            }
            ProductService.setProductName($scope.page.productName);
            ProductService.setMelcoReferenceId($scope.page.referenceId);
            ProductService.setProductFormat($scope.page.exportFormat);
            ProductService.setProductColorMode($scope.page.exportColorMode);
            ProductService.setMergeFiles($scope.page.MergeFiles);

            //First, we want to save the thumb and snapshot (if required)
            try {
                const guideLine =
                    canvas && canvas.getObjects() ? canvas.getObjects().find((o) => o.isProductGuidelines) : null;
                let wasGuidelineVisible = false;
                if (guideLine && guideLine.visible) {
                    guideLine.set('visible', false);
                    wasGuidelineVisible = true;
                    canvas.renderAll();
                }
                if (saveNow && $scope.forDesignTemplateCreation) {
                    $scope.deselectAllAndClearBorders();
                    const result = await ImageUtilService.limitImageResolution(canvas.toDataURL(), 512, 512);
                    const response = await uploadImageToS3('thumbnail', result.base64);
                    ProductService.setProductThumbnail(response.Path);
                    const previewRepresentation = await getCurrentSelectionAsImage(canvas);
                    const previewRepresentationResponse = await uploadImageToS3('preview', previewRepresentation);
                    ProductService.setProductSnapshotUrl(previewRepresentationResponse.Path);
                }

                if (guideLine && wasGuidelineVisible) {
                    guideLine.set('visible', true);
                    canvas.renderAll();
                }
            } catch (error) {
                console.error('error at saving thumb/snapshot', error);
            }
            // we switch all groups back to visible and unlocked
            // so when merging the Template Design with a Template Product
            // All the layers in the preview are visible and unlocked
            const mgr = getGroupManager();
            ProductService.replaceGroupsByType('eps', mgr?.getAllGroupsWithDefaultLayoutVisibility() || []);

            //Update elements links with the current ones on canvas
            const updatedElementsLinks = ProductService.getElementsLinks().filter(
                (l) =>
                    l.valueFormat === ValueFormat.TextAsMask ||
                    l.valueFormat === ValueFormat.TextAsCutout ||
                    l.valueFormat === ValueFormat.Pattern
            );
            for (const [sourceId, entry] of canvas.getSourceElements()) {
                if (!sourceId || !entry?.sourceType || !entry?.targets) {
                    continue;
                }
                for (const item of entry.targets) {
                    if (!item.targetElement || !item.valueFormat) {
                        continue;
                    }
                    const targetType = getElementType(item.targetElement);
                    if (!targetType) {
                        continue;
                    }
                    updatedElementsLinks.push({
                        sourceId,
                        targetType: targetType,
                        targetId: item.targetElement.uuid,
                        sourceType: entry.sourceType,
                        valueFormat: item.valueFormat
                    });
                }
            }
            ProductService.setElementsLinks(updatedElementsLinks);

            if ($scope.enablePageEps) {
                //discard empty page eps
                const countPageEps = canvas.getElementsPageEps()?.length;
                ProductService.addListEPS(
                    canvas
                        .getElementsPageEps()
                        ?.filter((w) => {
                            if (w.baseImage) {
                                return true;
                            }

                            if (countPageEps > 1) {
                                return canvas.getPageEpsElements(w).length > 0;
                            } else {
                                return true;
                            }
                        })
                        ?.sort((a, b) => b.zIndex - a.zIndex)
                );
            }
            const groups = ProductService.getGroups().filter((g) => g.type === 'eps');
            if (groups.length > 0 && !$scope.page.layoutOptimization) {
                for (const group of groups) {
                    group.position = 0;
                }
            }

            const promises = [];
            const imagePromises = [];

            // We assign a new id for new products, for existing we use the already assigned one
            if (!$scope.editMode && $scope.productGuidPromise) {
                const guid = await $scope.productGuidPromise;
                Sentry.setContext('product', {
                    id: guid,
                    editing: false
                });
                ProductService.setProductId(guid);
                ProductService.setEditMode(false);
            }

            if (!$scope.enablePageEps) {
                if (baseImagePath && !baseImageToUpload && !$scope.reloadedNonEPSBaseImage) {
                    // Save the base image if it has changes
                    ProductService.setEPSBaseImagePath(baseImagePath);
                }
                // Upload the preview image if needed
                else if (baseImageToUpload) {
                    const p = uploadImageToS3('eps', baseImageToUpload).then(function (response) {
                        ProductService.setEPSBaseImagePath(response.Path);
                    });
                    promises.push(p);
                }
            } else if (baseImageToUploadEPS && Object.keys(baseImageToUploadEPS).length > 0) {
                // Upload the preview image if needed
                for (const [key, value] of Object.entries(baseImageToUploadEPS).filter(([, v]) => v != null)) {
                    const p = uploadImageToS3('eps', value).then(function (response) {
                        ProductService.setEPSBaseImagePath(response.Path, key);
                    });
                    promises.push(p);
                }
            }

            ProductService.clearObjectsDeleteOnEPS();

            const skipPreviewElements = $scope.forMyDesigns || $scope.forDesignTemplateCreation;
            const canvasObjectsTypes = {
                'bounded-text': { prodEpsProperty: 'textsEps', prodEpsMethod: 'addEPSTextFromObject' },
                'text-transform': { prodEpsProperty: 'textsEps', prodEpsMethod: 'addEPSTextFromObject' },
                'path-itext': {
                    prodEpsProperty: 'circularTextsEps',
                    prodEpsMethod: 'addEPSCircularTextFromObject'
                },
                'image-placeholder': {
                    prodEpsProperty: 'imagePlaceHoldersEps',
                    prodEpsMethod: 'addEPSPlaceholderImageFromObject'
                },
                'vector-placeholder': {
                    prodEpsProperty: 'vectorEPSEps',
                    prodEpsMethod: 'addEPSVectorEPSFromObject'
                }
            };
            const imagePlaceHolder = 'image-placeholder';
            for (const canvasObject of canvas.getObjects()) {
                // Text objects
                if (Object.keys(canvasObjectsTypes).includes(canvasObject.type)) {
                    const objTypeMatched = canvasObjectsTypes[canvasObject.type];
                    const eps = ProductService.getEps(canvasObject.pageEpsId);
                    const epsElement = eps[objTypeMatched.prodEpsProperty].find(
                        (elCanvas) => elCanvas.uuid === canvasObject.uuid
                    );
                    if (epsElement) {
                        continue;
                    }

                    if (canvasObject.type !== imagePlaceHolder) {
                        promises.push(ProductService[objTypeMatched.prodEpsMethod](canvasObject, skipPreviewElements));
                    } else {
                        if (canvasObject.dynamicImagesPath && typeof canvasObject.dynamicImagesPath !== 'string') {
                            // If it has something stored on the map -> transform it to JSON
                            canvasObject.dynamicImagesPath = JSON.stringify(
                                Array.from(canvasObject.dynamicImagesPath.entries())
                            );
                        }

                        imagePromises.push(
                            (async () => {
                                try {
                                    return {
                                        previewImage: await ProductService.addEPSPlaceholderImageFromObject(
                                            canvasObject,
                                            skipPreviewElements
                                        ),
                                        prodImage: canvasObject
                                    };
                                } catch (error) {
                                    console.error(error);
                                }
                            })()
                        );
                    }
                }
            }

            // Wait for all the promises to finish
            $q.all(promises)
                .then(() => {
                    $q.all(imagePromises)
                        .then(async (addedImages) => {
                            try {
                                if (!skipPreviewElements) {
                                    // Check if the added images in the preview need resizing
                                    if (addedImages && addedImages.length) {
                                        const dynamicImages = addedImages.filter(
                                            (i) =>
                                                i &&
                                                i.previewImage.newlyAdded &&
                                                i.previewImage.previewElement &&
                                                i.previewImage.previewElement.dynamicImagesPath
                                        );
                                        const imagePlaceholdersResult = addedImages.filter(
                                            (i) =>
                                                i &&
                                                i.previewImage.previewElement &&
                                                !i.previewImage.previewElement.dynamicImagesPath &&
                                                i.previewImage.previewElement.maskPath &&
                                                (i.previewImage.newlyAdded || i.prodImage.maskChanged)
                                        );

                                        if (dynamicImages.length) {
                                            console.log('Resizing dynamic images');
                                            await DynamicImageService.limitDynamicImageFileSizes(
                                                dynamicImages.map((i) => i.prodImage),
                                                dynamicImages.map((i) => i.previewImage.previewElement),
                                                ConfigService.MAX_PREVIEW_IMAGE_SIZE
                                            );
                                        }
                                        if (imagePlaceholdersResult.length) {
                                            console.log('Resizing mask images');
                                            await ImageUtilService.limitMaskImagesSize(
                                                imagePlaceholdersResult.map((i) => i.prodImage),
                                                imagePlaceholdersResult.map((i) => i.previewImage.previewElement),
                                                ConfigService.MAX_PREVIEW_IMAGE_SIZE
                                            );
                                        }
                                    }
                                    ProductService.updatePreviewGroups();
                                }

                                if ($scope.fromListing) {
                                    $location.path('/createProduct2').search({
                                        fromListing: 'true',
                                        forProductTemplateCreation: 'true',
                                        forMyProductBases: 'true'
                                    });
                                } else if (saveNow && $scope.forDesignTemplateCreation) {
                                    let product = null;
                                    if ($rootScope.productBuilderDesign) {
                                        await $scope.finishProductBuilderDesignCreation();
                                    } else if ($scope.forMyDesigns) {
                                        ProductService.clearPreviewElements();
                                        product = await $scope.saveDesignTemplate();
                                        const designId = $location.search().designId || '';
                                        if (designId && !$scope.isImportedDesign) {
                                            $mdDialog
                                                .show({
                                                    controller: 'DesignEditModeModalCtrl',
                                                    template: require('../../../../views/pages/create-product/designEditModeModalCtrl.html'),
                                                    locals: {
                                                        designId: designId
                                                    },
                                                    parent: angular.element(document.body),
                                                    clickOutsideToClose: false,
                                                    escapeToClose: false
                                                })
                                                .then(async (data) => {
                                                    await $scope.publishDesign(product, designId, data.action);
                                                    $scope.confirmDesignSaved(
                                                        product.id,
                                                        designId,
                                                        data.action == 'save-update-options'
                                                    );
                                                });
                                        } else {
                                            $rootScope.saveUpdateAndOptions = $scope.isImportedDesign
                                                ? 'save-update-options'
                                                : $rootScope.saveUpdateAndOptions;
                                            const { response: designPublished } = await $scope.publishDesign(
                                                product,
                                                designId,
                                                $rootScope.saveUpdateAndOptions
                                            );
                                            $scope.confirmDesignSaved(product.id, designPublished.id);
                                        }
                                    } else {
                                        if (
                                            $rootScope.user.AccessRoles.Serialized.split(',').includes(
                                                'admin',
                                                'admin-ui'
                                            )
                                        ) {
                                            product = await $scope.saveDesignTemplate();
                                            $scope.confirmDesignSaved(product.id);
                                        } else {
                                            $scope.skipTemplateExitAlert = true;
                                            $location.path('/home');
                                        }
                                    }
                                } else if (
                                    saveNow &&
                                    $scope.editMode &&
                                    !$scope.forProductTemplateCreation &&
                                    !$scope.forDesignTemplateCreation
                                ) {
                                    await $scope.saveProduct();
                                    $scope.skipTemplateExitAlert = true;
                                    $mdToast.show(
                                        $mdToast
                                            .simple()
                                            .textContent('Your template has being saved successfully!')
                                            .position('top right')
                                            .hideDelay(2000)
                                    );
                                } else if ($scope.isUserDesignCreation) {
                                    $location.path('/createProduct2').search({
                                        forUserDesignCreation: 'true',
                                        flowId: $location.search().flowId
                                    });
                                } else if ($scope.createDesignOnTemplate) {
                                    ProductService.clearPreview();
                                    await $scope.saveProduct();
                                    $scope.skipTemplateExitAlert = true;

                                    $location.search('templateId', null);
                                    $location.search('createDesignOnTemplate', null);
                                    $location.path('/store/designLibrary');
                                } else {
                                    blockUI.stop();
                                    $location.path('/createProduct2');
                                }
                            } catch (error) {
                                window.rumReportError(error);
                                blockUI.stop();
                                MdDialogService.showCommonError(
                                    error,
                                    'Something wrong happened while going to step 2'
                                );
                            }

                            // We need this because we are inside an async function
                            $timeout(() => $scope.$apply());
                        })
                        .catch(function (error) {
                            window.rumReportError(error);
                            blockUI.stop();
                            MdDialogService.showCommonError(error, 'Something wrong happened while going to step 2');
                        });
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                    MdDialogService.showCommonError(error, 'Something wrong happened while going to step 2');
                });
        };

        $scope.confirmDesignSaved = function (productId, designId = '', delayedSet = false) {
            $mdDialog
                .show({
                    controller: 'DesignTemplateSavedModalCtrl',
                    template: require('../../../../views/pages/create-product/designTemplateSavedModal.html'),
                    locals: {
                        templateId: productId,
                        designId: designId,
                        delayedSet: $scope.isImportedDesign || delayedSet
                    },
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false
                })
                .then(() => {
                    ProductService.clearProduct();
                    $scope.skipTemplateExitAlert = true;
                    if ($scope.forMyDesigns) {
                        $location.url('/designs');
                    } else {
                        $location.url('/admin/designs');
                    }
                    $timeout(() => $scope.$apply());
                });
            $timeout(() => $scope.$apply());
        };

        $scope.waitForOptionSetGeneration = function (taskIdentifier) {
            return pollUntilComplete(() => getProgress(taskIdentifier));
        };

        $scope.finishProductBuilderDesignCreation = async function () {
            ProductService.clearPreviewElements();
            const designTemplate = await $scope.saveDesignTemplate();

            $scope.showBlockUiLoader(true, 'Generating option set...');

            const designId = $location.search().designId || '';
            const { response: designPublished, taskIdentifier } = await $scope.publishDesign(designTemplate, designId);

            if (taskIdentifier) {
                await $scope.waitForOptionSetGeneration(taskIdentifier);
            }

            const { beforeMergePayload, productModel, productInfo, targetSector } = $rootScope.productBuilderDesign;
            const productBase = productModel || productInfo;
            const lastPrintSectorIndex = productBase.lastPrintSectorIndex;

            beforeMergePayload.editingPrintAreaIndex = lastPrintSectorIndex;
            const templateProductsData = await getBeforeMergeData(beforeMergePayload);

            const printAreaDimensions = $scope.buildNoMovementPrintAreaDimensions(
                templateProductsData,
                lastPrintSectorIndex
            );

            $rootScope.productBuilderDesign.printAreaDimensions = printAreaDimensions;
            productBase.printAreaSectors[lastPrintSectorIndex].printAreaDimensions = printAreaDimensions;

            $rootScope.productBuilderDesign.createdDesign = {
                id: designPublished.id,
                title: designPublished.title || designTemplate.name,
                image: (designPublished.images && designPublished.images[0]) || designTemplate.snapshotUrl || ''
            };
            $rootScope.productBuilderDesign.targetSector = targetSector;

            $scope.showBlockUiLoader(false);
            $scope.skipTemplateExitAlert = true;
            ProductService.clearProduct();
            $location.path($scope.beforeMergeNextPath);
            $timeout(() => $scope.$apply());
        };

        $scope.buildNoMovementPrintAreaDimensions = function (templateProductsData, lastPrintSectorIndex) {
            const pickDims = (d) => ({
                width: d.width,
                height: d.height,
                centerX: d.centerX,
                centerY: d.centerY,
                rotation: d.rotation,
                skewX: d.skewX,
                skewY: d.skewY
            });

            const results = [];
            for (const templateProductData of templateProductsData || []) {
                const printAreaPreviewAndEps = templateProductData.printAreaPreviewAndEps || [];
                const paEps = printAreaPreviewAndEps[lastPrintSectorIndex];
                if (!paEps || !paEps.printAreaEps) continue;

                const visiblePreviews = (paEps.previewPrintAreasPerEpsPrintArea || []).filter((p) => p.isVisible);

                const previewsById = {};
                for (const previewArea of visiblePreviews) {
                    previewsById[previewArea.previewId] = pickDims(previewArea);
                }

                const defaultPreview = visiblePreviews[0];
                results.push({
                    index: lastPrintSectorIndex,
                    eps: pickDims(paEps.printAreaEps),
                    preview: defaultPreview ? pickDims(defaultPreview) : pickDims(paEps.printAreaEps),
                    previews: previewsById,
                    clipPathAbsPosition: paEps.printAreaEps.clipPath
                });
            }

            return results;
        };

        $scope.startFillColorSampler = function (colorPicker) {
            $scope.colorSamplerActive = true;
            ColorSamplerService.startColorSampler(canvas, colorPicker, canvas.getActiveObject(), 'fill');
        };

        $scope.updateImageCover = function (coverMaskArea, object) {
            object.set('coverMaskArea', coverMaskArea);

            // Set the image again so we can see how the new fit/fill looks
            if (object.originalElement) {
                object.setElement(object.originalElement);
                canvas.renderAll();
            }

            if ($scope.editMode) {
                object.setEditedProp?.('coverMaskArea');
            }
        };

        $scope.updateImageAllowEdit = function (allowEdit, object) {
            object.set('allowEdit', allowEdit);
            object.preventEditMode = !allowEdit;
            $scope.resetImagePosition(object);

            if (allowEdit) {
                object.set('limitMovement', true);
                $scope.selectedImageProperties.limitMovement = true;
                if ($scope.editMode) {
                    object.setEditedProp?.('limitMovement');
                }
            } else if (!allowEdit && object.limitMovement) {
                object.set('limitMovement', false);
                $scope.selectedImageProperties.limitMovement = false;
                if ($scope.editMode) {
                    object.setEditedProp?.('limitMovement');
                }
            }

            if ($scope.editMode) {
                object.setEditedProp?.('allowEdit');
            }
        };

        $scope.updateImageAllowSwapLibraryPosition = function (allowSwapLibraryPosition, object) {
            object.set('allowSwapLibraryPosition', allowSwapLibraryPosition);

            if ($scope.editMode) {
                object.setEditedProp?.('allowSwapLibraryPosition');
            }
        };

        $scope.updateImageLimitMovement = function (limitMovement, object) {
            object.set('limitMovement', limitMovement);

            if ($scope.editMode) {
                object.setEditedProp?.('limitMovement');
            }
        };

        $scope.limitImageToPlaceholder = function (limitImageToPlaceholder, object) {
            object.set('isLimitImageToPlaceholder', limitImageToPlaceholder);

            if (object.originalElement) {
                object.setElement(object.originalElement);
                canvas.renderAll();
            }

            if ($scope.editMode) {
                object.setEditedProp?.('isLimitImageToPlaceholder');
            }
        };

        $scope.lockMovement = function (lockMovement, object) {
            object.set('lockMovement', lockMovement);

            if ($scope.editMode) {
                object.setEditedProp?.('lockMovement');
            }
        };

        $scope.lockScaling = function (lockScaling, object) {
            object.set('lockScaling', lockScaling);

            if ($scope.editMode) {
                object.setEditedProp?.('lockScaling');
            }
        };

        $scope.updateVectorCover = async function (coverMaskArea, object) {
            object.set('coverMaskArea', coverMaskArea);

            // Set the svg/pdf again so we can see how the new fit/fill looks. The control
            //  rectangle/init position are reapplied asynchronously once this finishes loading
            //  (see fabric.VectorPlaceholder._set) - render before that resolves and the canvas
            //  paints the placeholder mid-reset instead of its saved position.
            if (object.svgString) {
                object.set('svgString', object.svgString);
                await object._contentLoadPromise;
                canvas.renderAll();
            } else if (object.pdf) {
                object.set('pdf', object.pdf);
                await object._contentLoadPromise;
                canvas.renderAll();
            }

            if ($scope.editMode) {
                object.setEditedProp?.('coverMaskArea');
            }
        };

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Color pickers                                                                       ///
        ///////////////////////////////////////////////////////////////////////////////////////////
        let cancelNextImageColorChangeDebounced = false;
        let debouncedImageColorChange = _.debounce(function (colors, imageSelected) {
            if (!cancelNextImageColorChangeDebounced && imageSelected) {
                imageSelected.set('imageColor', '#' + colors.HEX);
                canvas.renderAll();
            }
            cancelNextImageColorChangeDebounced = false;
        }, 300);
        $scope.imageColorChange = function (colors, isTerminating) {
            const { imageSelected, bulkEdit, selectedObjectGroup } = $scope;
            const { enabled: bulkEditEnabled } = bulkEdit;
            const targetObjects = bulkEditEnabled
                ? selectedObjectGroup?._objects
                : imageSelected
                ? [imageSelected]
                : [];
            const colorHex = '#' + colors.HEX;

            if (targetObjects && targetObjects.length === 0) {
                return;
            }

            clearTimeout($scope.imageColorChangeTimeout);

            const delayedCall = () => {
                for (const targetObject of targetObjects) {
                    if (!targetObject) {
                        continue;
                    }

                    if (isTerminating || bulkEditEnabled) {
                        targetObject.set('imageColor', colorHex);
                    } else {
                        debouncedImageColorChange(colors, targetObject);
                    }
                }
                canvas.renderAll();
            };

            const delay = 100;
            $scope.imageColorChangeTimeout = setTimeout(delayedCall, delay);
        };

        $scope.imageColorSave = function (colors, image) {
            const { imageSelected, editMode, bulkEdit, selectedObjectGroup } = $scope;
            const { enabled: bulkEditEnabled } = bulkEdit;

            const targetObjects = bulkEditEnabled ? selectedObjectGroup?._objects : [imageSelected];
            const targetImages = image ? [image] : targetObjects || [];

            for (const targetImage of targetImages) {
                const color = colors.HEX;
                DynamicImageService.saveDynamicImageColor(colors, targetImage, editMode);
                targetImage.set('imageColor', '#' + color);
            }

            canvas.renderAll();
        };

        $scope.imageColorOutlineChange = function (colors) {
            const { imageSelected, bulkEdit, selectedObjectGroup } = $scope;
            const { enabled: bulkEditEnabled } = bulkEdit;
            const targetObjects = bulkEditEnabled
                ? selectedObjectGroup?._objects
                : imageSelected
                ? [imageSelected]
                : [];
            const colorHex = '#' + colors.HEX;
            if (targetObjects && targetObjects.length === 0) {
                return;
            }

            for (const targetObject of targetObjects) {
                if (!targetObject) {
                    continue;
                }
                targetObject.set('imageOutlineColor', colorHex);
                targetObject.setEditedProp?.('outlineColor');
            }
            canvas.renderAll();
        };

        $scope.changeImageOutlineWidth = function (imageOutlineWidth) {
            if ($scope.imageSelected) {
                $scope.imageSelected.set('imageOutlineWidth', imageOutlineWidth);
                $scope.imageSelected.setEditedProp?.('outlineWidth');
            }
        };

        // Cleanup
        $scope.$on('$destroy', function () {
            console.log('Cleaning up resources from step 1');

            $scope.imageColorPicker.destroy();
            $scope.bulkEditImageColorPicker.destroy();
            $scope.calendarTitleColorPicker.destroy();
            $scope.calendarMarkerColorPicker.destroy();
            $scope.calendarHighlightedColorPicker.destroy();

            blockUI.stop();

            if (canvas) {
                // Remove the canvas element so the next controller won't be able to find it
                canvas.dispose();
                $('#fabric-container').remove();
            }
        });

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Libraries                                                                           ///
        ///////////////////////////////////////////////////////////////////////////////////////////
        $scope.pickColorLibrary = async function (canvasObject = undefined, loadInfo = true) {
            const library = await LibrariesUtilService.showColorLibraryPicker();
            if (!library) return;

            const { bulkEdit, selectedObjectGroup, selectedImageProperties } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? (selectedObjectGroup || canvasObject)._objects
                : canvasObject
                ? [canvasObject]
                : [];
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedImageProperties;

            for (const targetObject of targetObjects) {
                targetObject.colorLibraryId = library.LibraryId;
                if (bulkEdit?.enabled) {
                    targetProperties.colorLibraryId = library.LibraryId;
                }

                if ($scope.editMode) {
                    targetObject.setEditedProp?.('colorLibraryId');
                }

                if (!loadInfo) continue;

                if (targetObject.type === 'image-placeholder') {
                    targetProperties.colorPosition = 1;
                    DynamicImageService.changeDynamicImageColorPosition(
                        targetObject,
                        1,
                        bulkEdit?.enabled ? $scope.bulkEditImageColorPicker : $scope.imageColorPicker,
                        canvas
                    );

                    if (bulkEdit?.enabled) {
                        bulkEdit.selectedProperties.isColorLibraryIdMixed = undefined;
                        bulkEdit.selectedProperties.isColorPositionMixed = undefined;
                    }
                }

                if (!loadInfo) return;

                // Get the name of the selected library
                LibrariesAPIService.getLibraryName(library.LibraryId).then(function (name) {
                    $scope.selectedColorLibraryName = name;
                });
            }
        };
        $scope.removeColorLibrary = function (canvasObject = undefined) {
            const { bulkEdit, selectedObjectGroup, selectedImageProperties } = $scope;
            const targetObjects = bulkEdit?.enabled ? selectedObjectGroup._objects : canvasObject ? [canvasObject] : [];
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedImageProperties;

            for (const targetObject of targetObjects) {
                targetObject.colorLibraryId = null;
                targetProperties.colorLibraryId = null;

                if ($scope.editMode) {
                    targetObject.setEditedProp?.('colorLibraryId');
                }

                // Reset the position to 1 when removing the library
                if (targetObject.type === 'image-placeholder') {
                    targetProperties.colorPosition = 1;
                    DynamicImageService.changeDynamicImageColorPosition(
                        targetObject,
                        1,
                        $scope.imageColorPicker,
                        canvas
                    );
                    if (bulkEdit?.enabled) {
                        bulkEdit.selectedProperties.isColorLibraryIdMixed = undefined;
                        bulkEdit.selectedProperties.isColorPositionMixed = undefined;
                    }
                }
            }
        };

        $scope.pickFontLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize textSelected in order for vue component to detect the change
            $scope.textSelected = null;
            $scope.selectedObjectGroup = null;
            await $scope.pickFontLibrary(object, false);

            if (object.type == 'activeSelection') {
                $scope.selectedObjectGroup = object;
            } else {
                $scope.textSelected = object;
            }
            if (object?.pattern) await $scope.resyncPattern(object);

            $scope.$apply();
        };

        $scope.pickColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            $scope.selectedObjectGroup = null;
            await $scope.pickColorLibrary(object, false);

            if (object.type == 'activeSelection') {
                $scope.selectedObjectGroup = object;
            } else {
                $scope.textSelected = object;
            }
            if (object?.pattern) await $scope.resyncPattern(object);

            $scope.$apply();
        };

        $scope.pickOutlineColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            const library = await LibrariesUtilService.showColorLibraryPicker();
            if (!library) {
                $scope.textSelected = object;
                return;
            }

            object.outlineColorLibraryId = library.LibraryId;

            if ($scope.editMode) {
                object.setEditedProp?.('outlineColorLibraryId');
            }

            $scope.textSelected = object;
            if (object?.pattern) await $scope.resyncPattern(object);
            $scope.$apply();
        };

        $scope.pickShadowColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            const library = await LibrariesUtilService.showColorLibraryPicker();
            if (!library) {
                $scope.textSelected = object;
                return;
            }

            object.shadowColorLibraryId = library.LibraryId;

            if ($scope.editMode) {
                object.setEditedProp?.('shadowColorLibraryId');
            }

            $scope.textSelected = object;
            if (object?.pattern) await $scope.resyncPattern(object);
            $scope.$apply();
        };

        $scope.shadowChanged = async function () {
            $scope.checkIfAnyTextHasAShadow();
            if ($scope.textSelected?.pattern) await $scope.resyncPattern($scope.textSelected);
        };

        $scope.pickOutlineColorLibraryForSelectedGroup = async function () {
            const object = canvas.getActiveObject();
            $scope.selectedObjectGroup = null;
            const library = await LibrariesUtilService.showColorLibraryPicker();
            if (!library) {
                $scope.selectedObjectGroup = object;
                return;
            }

            const children = object.getObjects();

            for (const child of children) {
                child.outlineColorLibraryId = library.LibraryId;
                if ($scope.editMode) {
                    child.setEditedProp('outlineColorLibraryId');
                }
            }

            $scope.selectedObjectGroup = object;
            $scope.$apply();
        };

        $scope.pickStrokeColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            const library = await LibrariesUtilService.showColorLibraryPicker();
            if (!library) {
                $scope.textSelected = object;
                return;
            }

            object.strokeColorLibraryId = library.LibraryId;

            if ($scope.editMode) {
                object.setEditedProp?.('strokeColorLibraryId');
            }

            $scope.textSelected = object;
            $scope.$apply();
        };

        $scope.pickFontLibrary = async function (canvasObject = undefined, fetchLibInfo = true) {
            const { bulkEdit, selectedObjectGroup, selectedTextProperties, editMode } = $scope;
            const targetObjects = bulkEdit?.enabled ? (selectedObjectGroup || canvasObject)._objects : [canvasObject];
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedTextProperties;

            const library = await LibrariesUtilService.showFontLibraryPicker();
            if (!library) return;

            for (const targetObject of targetObjects) {
                targetObject.fontLibraryId = library.LibraryId;
                targetProperties.fontLibraryId = library.LibraryId;

                if (editMode) {
                    targetObject.setEditedProp?.('fontLibraryId');
                }

                // Select the first font from the library
                if (
                    targetObject.type === 'bounded-text' ||
                    targetObject.type === 'path-itext' ||
                    targetObject.type === 'text-transform'
                ) {
                    targetProperties.fontOption = 1;
                    await MultipleFontService.changeFontOption(targetObject, targetProperties.fontOption, canvas);
                    targetProperties.fontPath = targetObject.fontPath;
                }
            }

            if (!fetchLibInfo) return;
            // Get the name of the selected library
            LibrariesAPIService.getLibraryName(library.LibraryId).then(function (name) {
                $scope.selectedFontLibraryName = name;
                $timeout(() => $scope.$apply());
            });
        };

        $scope.pickVectorLibrary = async function (canvasObject = undefined, fetchLib = true) {
            const { bulkEdit, selectedObjectGroup, selectedSVGProperties } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? (selectedObjectGroup || canvasObject)._objects
                : canvasObject
                ? [canvasObject]
                : [];
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedSVGProperties;

            const library = await LibrariesUtilService.showVectorLibraryPicker();
            if (!library) return;

            const tasks = [];

            for (const targetObject of targetObjects) {
                targetObject.vectorLibraryId = library.LibraryId;
                targetProperties.vectorLibraryId = library.LibraryId;

                if ($scope.editMode) {
                    targetObject.setEditedProp?.('vectorLibraryId');
                }

                if (!fetchLib) continue;

                // Select the first font from the library
                if (targetObject.type === 'vector-placeholder') {
                    targetProperties.position = 1;
                    tasks.push(
                        async () => await DynamicVectorService.changeDynamicEPSPosition(targetObject, 1, canvas)
                    );
                }
            }

            await ExecutionService.runTasksInChunks(tasks);

            // Get the name of the selected library
            LibrariesAPIService.getLibraryName(library.LibraryId).then(function (name) {
                $scope.selectedVectorLibraryName = name;
            });
        };

        $scope.pickVectorLibraryForSelectedVector = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize vectorSelected in order for vue component to detect the change
            $scope.svgSelected = null;
            $scope.selectedObjectGroup = null;
            await $scope.pickVectorLibrary(object, false);

            if (object.type == 'activeSelection') {
                $scope.selectedObjectGroup = object;
            } else {
                $scope.svgSelected = object;
            }
            $scope.$apply();
        };

        $scope.pickColorLibraryForSelectedVector = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize vectorSelected in order for vue component to detect the change
            $scope.svgSelected = null;
            await $scope.pickColorLibrary(object, false);

            $scope.svgSelected = object;
            $scope.$apply();
        };

        $scope.pickColorLibraryForSelectedImage = async function () {
            const object = canvas.getActiveObject();
            $scope.imageSelected = null;
            await $scope.pickColorLibrary(object, false);

            if ($scope.isEditMode && typeof setEditedProp === 'function') {
                setEditedProp(object, 'colorLibraryId', object.colorLibraryId);
            }
            $scope.imageSelected = object;
            $scope.$apply();
        };

        $scope.pickImageLibraryForSelectedImage = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize imageSelected in order for vue component to detect the change
            $scope.imageSelected = null;
            const library = await LibrariesUtilService.showImageLibraryPicker();

            if (!library) {
                $scope.imageSelected = object;
                return;
            }

            object.imageLibraryId = library.LibraryId;
            $scope.imageSelected = object;
            $scope.$apply();
        };

        $scope.pickImageLibraryForSelectedGroup = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize selectedObjectGroup in order for vue component to detect the change
            $scope.selectedObjectGroup = null;
            const library = await LibrariesUtilService.showImageLibraryPicker();

            if (!library) {
                $scope.selectedObjectGroup = object;
                return;
            }

            const children = object.getObjects();

            for (const child of children) {
                child.imageLibraryId = library.LibraryId;
            }

            $scope.selectedObjectGroup = object;
            $scope.$apply();
        };

        $scope.pickImageLibraryForWordCloud = async function () {
            const object = canvas.getActiveObject();
            $scope.imageSelected = null;
            const library = await LibrariesUtilService.showImageLibraryPicker();

            if (!library) {
                $scope.imageSelected = object;
                return;
            }

            object.wordCloudConfig = {
                ...object.wordCloudConfig,
                libraryId: library.LibraryId
            };

            $scope.imageSelected = object;
            $scope.$apply();
        };

        $scope.updateMelcoDesignId = function (referenceId) {
            if (referenceId && referenceId.length > 6) {
                MelcoAPIService.getMetaData(referenceId)
                    .then(function (data) {
                        if (data.design_data && data.design_data.letterings) {
                            $scope.melcoTextIds = data.design_data.letterings.map((l) => l.id);
                            $scope.melcoIsValidId = true;
                        } else {
                            $scope.melcoTextIds = [];
                            $scope.melcoIsValidId = false;
                        }
                    })
                    .catch((err) => {
                        $scope.melcoTextIds = [];
                        $scope.melcoIsValidId = false;
                        window.rumReportError(err);
                    });
            }
        };

        $scope.updateMelcoTextId = async function (referenceId, object) {
            if ($scope.editMode) {
                object.setEditedProp?.('referenceId');
            }
            object.set('referenceId', referenceId);
            canvas.renderAll();
        };

        $scope.updateTextAllowEdit = function (object, value = null) {
            let currentState = value;
            if (currentState === null) {
                currentState = !($scope.selectedTextProperties.allowEdit || $scope.selectedTextProperties.oldAllowEdit);
            }
            $scope.selectedTextProperties.allowEdit = currentState;
            $scope.selectedTextProperties.oldAllowEdit = false;

            object.set('allowEdit', $scope.selectedTextProperties.allowEdit);
            object.set('oldAllowEdit', $scope.selectedTextProperties.oldAllowEdit);

            if ($scope.editMode) {
                object.setEditedProp?.('allowEdit');
                object.setEditedProp?.('oldAllowEdit');
            }
            if (object.allowEdit) {
                // disable not compatible fields
                $scope.useAutofill(true);
            } else {
                object.resetEditMode?.();
            }
            canvas.renderAll();
        };

        $scope.adjustTextPosition = function (object) {
            if (object.oldAllowEdit) {
                //convert previous allow edit version to new one
                $scope.selectedTextProperties.allowEdit = true;
                $scope.selectedTextProperties.oldAllowEdit = false;
                if ($scope.editMode) {
                    object.setEditedProp?.('allowEdit');
                    object.setEditedProp?.('oldAllowEdit');
                }
                object.set('oldAllowEdit', $scope.selectedTextProperties.oldAllowEdit);
                object.set('allowEdit', $scope.selectedTextProperties.allowEdit); //This set action already triggers the selection of the internal text for editing
            } else {
                $scope.selectInnerRectangle(object);
            }
        };

        $scope.onTextAdvancedAllowEditChange = function () {
            if (!$scope.textSelected) return;
            if ($scope.textSelected.pattern) $scope.onRemovePattern();
            $scope.updateTextAllowEdit($scope.textSelected);
        };

        $scope.onTextAdvancedUseAsMaskChange = async function (value) {
            if (!$scope.textSelected) return;
            if (value && $scope.textSelected.pattern) $scope.onRemovePattern();
            await $scope.updateTextUseAsMask(value, $scope.textSelected);
        };

        $scope.onTextAdvancedUseAsCutoutChange = async function (value) {
            if (!$scope.textSelected) return;
            if (value && $scope.textSelected.pattern) $scope.onRemovePattern();
            await $scope.updateTextUseAsCutout(value, $scope.textSelected);
        };

        $scope.onTextAdvancedAutofillToggle = function () {
            if (!$scope.textSelected) return;
            if ($scope.textSelected.pattern) $scope.onRemovePattern();
            $scope.useAutofill();
        };

        $scope.onTextAdvancedAdjustTextPosition = function () {
            if (!$scope.textSelected) return;
            $scope.adjustTextPosition($scope.textSelected);
        };

        const TEXT_EFFECT = createTextEffect({ getCanvas: () => canvas, $scope, TextService, ProductService });
        const { applyTextEffect, removeTextEffect, updateTextEffect } = createTextEffectHandlers({
            getCanvas: () => canvas,
            $scope,
            DynamicImageService,
            TestImageService,
            TextService,
            ProductService
        });

        const patternHandlers = createTextPatternHandlers({
            getCanvas: () => canvas,
            $scope,
            TextService,
            ProductService
        });

        $scope.onCreatePattern = async function () {
            const origin = $scope.textSelected;
            if (!origin || origin.type !== 'bounded-text' || origin.pattern) return;
            await $scope.updateTextUseAsMask(false, origin);
            await $scope.updateTextUseAsCutout(false, origin);
            if (origin.allowEdit) $scope.updateTextAllowEdit(origin, false);
            if (origin.autofillSource) $scope.updateAutofillSource('', origin);
            patternHandlers.createPattern(origin);
            $scope.$applyAsync();
        };

        $scope.onPatternConfigChange = function (partial) {
            const origin = $scope.textSelected;
            if (!origin || !origin.pattern || !partial) return;
            patternHandlers.updateConfig(origin, partial);
        };

        $scope.onPatternRefreshFill = function () {
            const origin = $scope.textSelected;
            if (!origin || !origin.pattern) return;
            patternHandlers.refreshFill(origin);
        };

        $scope.onRemovePattern = function () {
            const origin = $scope.textSelected;
            if (!origin || !origin.pattern) return;
            patternHandlers.removePattern(origin);
            $scope.$applyAsync();
        };

        $scope.resyncPattern = async function (origin) {
            if (origin && origin.type === 'bounded-text' && origin.pattern) {
                await patternHandlers.resyncReplicas(origin);
            }
        };

        $scope.repositionPattern = function (origin, resize) {
            if (origin && origin.type === 'bounded-text' && origin.pattern) {
                patternHandlers.repositionReplicas(origin, { resize: !!resize });
            }
        };

        $scope.cleanupDeletedPatterns = function (deleted) {
            if (!deleted || !deleted.length) return;
            for (const element of deleted) {
                if (element.type !== 'bounded-text') continue;
                if (element.pattern) {
                    for (const replica of TextService.getPatternReplicaObjects(canvas, element.uuid)) {
                        canvas.remove(replica);
                    }
                    ProductService.removePatternElementsLinks(element.uuid);
                } else if (element.isPatternReplica) {
                    ProductService.removePatternElementsLinkByReplica(element.uuid);
                }
            }
            updateElementsOrderFromZIndex(canvas);
        };

        $scope.handleTextAsMaskOnZIndexUpdated = async function () {
            const updaters = [
                { filter: 'useAsMask', toggle: $scope.updateTextUseAsMask },
                { filter: 'useAsCutout', toggle: $scope.updateTextUseAsCutout }
            ];
            for (const { filter, toggle } of updaters) {
                for (const o of canvas._objects.filter((o) => o.type === 'bounded-text' && o[filter])) {
                    await toggle(false, o, true);
                    await toggle(true, o, true);
                }
            }
        };

        $scope.updateTextEffects = async function () {
            for (const object of canvas._objects.filter(
                (o) => o.type === 'bounded-text' && (o.useAsMask || o.useAsCutout)
            )) {
                if (object.useAsMask) await $scope.updateTextUseAsMask(true, object);
                else await $scope.updateTextUseAsCutout(true, object);
            }
        };

        $scope.updateTextUseAsMask = async function (useAsMask, object, reorderLayers = false) {
            await updateTextEffect(useAsMask, object, reorderLayers, TEXT_EFFECT.mask);
        };

        $scope.updateTextUseAsCutout = async function (useAsCutout, object, reorderLayers = false) {
            await updateTextEffect(useAsCutout, object, reorderLayers, TEXT_EFFECT.cutout);
        };

        $scope.applyTextMask = async (uuid) => {
            return applyTextEffect(uuid, TEXT_EFFECT.mask);
        };

        $scope.applyTextCutout = async (uuid) => {
            return applyTextEffect(uuid, TEXT_EFFECT.cutout);
        };

        $scope.removeTextMask = (t, o) => removeTextEffect(t, o, TEXT_EFFECT.mask);
        $scope.removeTextCutout = (t, o) => removeTextEffect(t, o, TEXT_EFFECT.cutout);

        $scope.useAutofill = async (disable = false) => {
            if ($scope.selectedTextProperties.autofillSource || disable) {
                $scope.selectedTextProperties.autofillSource = '';
                $scope.updateAutofillSource('', $scope.textSelected);
            } else {
                $scope.selectedTextProperties.autofillSource = 'ORDER_NUMBER';
                $scope.updateAutofillSource('ORDER_NUMBER', $scope.textSelected);

                // disable not compatible fields
                await $scope.updateTextUseAsMask(false, $scope.textSelected);
                await $scope.updateTextUseAsCutout(false, $scope.textSelected);
                $scope.updateTextAllowEdit($scope.textSelected, false);
            }
        };

        $scope.updateAutofillSource = async function (value, object) {
            if (!object) return;
            if ($scope.editMode) {
                object.setEditedProp?.('autofillSource');
            }
            object.set('autofillSource', value);
        };

        $scope.updateDateFormat = async function (value, object) {
            if (!object) return;
            if ($scope.editMode) {
                object.setEditedProp?.('dateFormat');
            }
            object.set('dateFormat', value);
        };

        $scope.dayJsFormatOptions = [
            { value: 'MM-DD-YY', label: '10-14-25' },
            { value: 'MM.DD.YYYY', label: '10.14.2025' },
            { value: 'MM.DD.YY', label: '10.14.25' },
            { value: 'DD/MM/YYYY', label: '14/10/2025' },
            { value: 'DD-MM-YY', label: '14-10-25' },
            { value: 'DD.MM.YYYY', label: '14.10.2025' },
            { value: 'DD.MM.YY', label: '14.10.25' },
            { value: 'YYYY-MM-DD', label: '2025-10-14' },
            { value: 'DD MMM YYYY', label: '14 Oct 2025' },
            { value: 'MMM D, YYYY', label: 'Oct 14, 2025' },
            { value: 'YYYY MMM D', label: '2025 Oct 14' },
            { value: 'DD-MMM-YYYY', label: '14-Oct-2025' },
            { value: 'DD MMMM YYYY', label: '14 October 2025' },
            { value: 'MMMM D, YYYY', label: 'October 14, 2025' },
            { value: 'YYYY MMMM D', label: '2025 October 14' },
            { value: 'dddd, MMMM D, YYYY', label: 'Tuesday, October 14, 2025' }
        ];

        $scope.formatWithLangWarning = [
            'DD MMM YYYY',
            'MMM D, YYYY',
            'YYYY MMM D',
            'DD-MMM-YYYY',
            'DD MMMM YYYY',
            'MMMM D, YYYY',
            'YYYY MMMM D',
            'dddd, MMMM D, YYYY'
        ];

        $scope.onElementPropsUpdated = async function (value) {
            const obj = canvas._objects.find((o) => o.uuid === value && o.type === 'bounded-text');
            if (!obj) return;

            if (obj === $scope.textSelected) {
                $scope.selectedTextProperties.allowEdit = obj.allowEdit;
                $scope.selectedTextProperties.oldAllowEdit = obj.oldAllowEdit;
            }

            if (obj.useAsMask || obj.useAsCutout || obj.pattern) {
                if (obj.useAsMask) await $scope.applyTextMask(value);
                if (obj.useAsCutout) await $scope.applyTextCutout(value);
                if (obj.pattern) await $scope.resyncPattern(obj);
            }
        };

        $scope.onPodProductAssignerClose = function () {
            $scope.skipTemplateExitAlert = true;
            $location.path('/pod/productBases');
        };

        $scope.onVariantsConfiguratorClose = function () {
            $scope.skipTemplateExitAlert = true;
            $location.path('/pod/productBases');
        };

        $scope.showAndUploadDynamicImageToS3 = async function (printAreaDynamicImage, imageUrl) {
            if (imageUrl) {
                printAreaDynamicImage.dynamicImagesPath.set(1, (await uploadImageToS3('preview', imageUrl)).Path);
                DynamicImageService.showDynamicImage(canvas, printAreaDynamicImage, 1);
            }
        };

        $scope.manualTemplateProductResize = function (page) {
            if (!page) return;

            $scope.dimensionsModalSubmittedData = page.submittedData;
            $scope.page.pageWidthDim = page.pageWidthDim;
            $scope.page.pageHeightDim = page.pageHeightDim;
            $scope.pageDimensionsEntered(true, false);
            //Here we're gonna send the dimensions to the step 2 canvas 1000x1000 pixeles
            ProductService.setProductTemplatePreviewTargetSize(1000, 1000);
        };

        $scope.addPrintArea = async function (canvas, width, height, imageUrl) {
            // Add a dynamic image as a print area element
            const printAreaDynamicImage = $scope.addDynamicImage(null, true);
            printAreaDynamicImage.name = 'Print Area';
            toggleElementPrintArea(printAreaDynamicImage, canvas);
            await $scope.showAndUploadDynamicImageToS3(printAreaDynamicImage, imageUrl || $scope.printAreaImageUrl);
            if (width && height) {
                $scope.updateWidth(width, printAreaDynamicImage);
                $scope.updateHeight(height, printAreaDynamicImage);
            }
        };

        //When editing TPs from Printify or Printful, the modal to edit variants is shown first, before loading the template.
        $scope.onVariantsEdited = async function (data) {
            $scope.showVariantsConfiguratorModal = false;
            blockUI.start(`Loading template with id ${$scope.templateId} ...`);
            let loadingPromise;
            console.log(`Loading template product ${$scope.templateId}`);
            loadingPromise = getTemplateProduct($scope.templateId);

            loadingPromise
                .then(async function (p) {
                    ProductService.loadProduct(p);
                    ProductService.setPodAssignments(data.podAssignments);
                    const podService = await getPodProviderById(p.podId);
                    $scope.provider = podService.apiKeyReference;
                    ProductService.setPod({
                        id: podService.id,
                        apiKeyReference: podService.apiKeyReference
                    });
                    const providerName = podService.name.toLocaleLowerCase();
                    const isPrintify = providerName === 'printify';
                    const listEps = ProductService.getListEPS();

                    for (const eps of listEps) {
                        let biggestPlaceholder = null;
                        if (!eps.podPlaceholder) {
                            if (data.biggestPlaceholders && data.biggestPlaceholders.length == 1) {
                                biggestPlaceholder = data.biggestPlaceholders[0];
                            }
                        } else {
                            biggestPlaceholder = data.biggestPlaceholders.find((x) => {
                                return x.id === eps.podPlaceholder;
                            });
                        }
                        if (!biggestPlaceholder) {
                            continue;
                        }

                        const firstPodAssignment = data.podAssignments.find((x) => {
                            return x.placeholderId === eps.podPlaceholder;
                        });
                        const dimensions = isPrintify
                            ? biggestPlaceholder || (await getPlaceholderSize(firstPodAssignment, data.storeUrl))
                            : biggestPlaceholder;
                        if (dimensions) {
                            const widthMm = isPrintify
                                ? pixelsToMm(dimensions.width, 300)
                                : pixelsToMm(dimensions.width, biggestPlaceholder.dpi);
                            const heightMm = isPrintify
                                ? pixelsToMm(dimensions.height, 300)
                                : pixelsToMm(dimensions.height, biggestPlaceholder.dpi);

                            eps.width = mmToPixels(widthMm, $scope.DPI);
                            eps.height = mmToPixels(heightMm, $scope.DPI);
                        }
                    }
                    $scope.editMode = true;
                    await $scope.loadEPS();
                })
                .catch(function (error) {
                    blockUI.stop();
                    window.rumReportError(error);
                    $location.path('/home');
                })
                .finally(() => {
                    $scope.showBlockUiLoader(false);
                });
        };

        $scope.onPodProductAssigned = async function (data) {
            $scope.showPodProductAssignerModal = false;
            let errorTitle = '';
            let errorDescription = '';
            let printAreaImageUrl = require('@/assets/images/print-area-customily.png');
            const biggestPlaceholders = data.biggestPlaceholders;
            const podAssignments = data.podAssignments;
            const podService = await getPodProviderById(data.podId);
            $scope.provider = podService.apiKeyReference;
            ProductService.setPod({
                id: podService.id,
                apiKeyReference: podService.apiKeyReference
            });

            if (podAssignments.length) {
                $scope.enablePageEps = true;
                $location.search({ ...$location.search(), enablePageEpsForPods: 'true' });
                blockUI.start('Loading POD data...');
                $timeout(() => $scope.$apply());
                // If we get here we should have all the placeholders for a single product and a single placeholder type, use the first element as reference
                let productName = 'Sample Template Product';
                $scope.exportPPI = 300;
                $scope.page.exportFormat = 'png';
                const pages = [];
                const placeholders = [...new Set(podAssignments.map((item) => item.placeholderId))];

                if (podService) {
                    const linkPods = {
                        printify: {
                            name: '(Printify)',
                            property: 'size',
                            printAreaUrl: 'printify.png'
                        },
                        printful: {
                            name: '(Printful)',
                            property: 'biggestPlaceholder',
                            printAreaUrl: 'printful.png'
                        }
                    };
                    const providerName = podService.name.toLocaleLowerCase();
                    if (Object.keys(linkPods).includes(providerName)) {
                        const { name, property, printAreaUrl } = linkPods[providerName];
                        const isPrintify = providerName === 'printify';
                        for (const placeholder of placeholders) {
                            const biggestPlaceholder = biggestPlaceholders.find((x) => {
                                return x.id === placeholder;
                            });
                            const firstPodAssignment = podAssignments.find((x) => {
                                return x.placeholderId === placeholder;
                            });

                            const obj = {
                                [property]: isPrintify
                                    ? biggestPlaceholder ||
                                      (await getPlaceholderSize(firstPodAssignment, data.storeUrl))
                                    : biggestPlaceholder
                            };
                            if (obj[property]) {
                                const widthMm = isPrintify
                                    ? pixelsToMm(obj[property].width, 300)
                                    : pixelsToMm(obj[property].width, biggestPlaceholder.dpi);
                                const heightMm = isPrintify
                                    ? pixelsToMm(obj[property].height, 300)
                                    : pixelsToMm(obj[property].height, biggestPlaceholder.dpi);
                                pages.push({ placeholder, widthMm, heightMm });
                            } else {
                                errorTitle = 'Placeholder Data Error';
                                errorDescription = `Couldn't retrieve the placeholder data for placeholder ${firstPodAssignment.placeholderId}. Cannot continue.`;
                                break;
                            }
                        }
                        if (!errorTitle) {
                            const product = await getPodProduct(podAssignments[0], data.storeUrl);
                            if (product) {
                                if (pages.length > 1) {
                                    productName = `${isPrintify ? product.title : product.product.title} ${name}`;
                                } else {
                                    productName = `${isPrintify ? product.title : product.product.title} ${name} - ${
                                        podAssignments[0].placeholderId
                                    } - ${biggestPlaceholders[0]?.aspectRatio}`;
                                }
                                printAreaImageUrl = require(`@/assets/images/print-area-${printAreaUrl}`);
                            } else {
                                errorTitle = 'Placeholder Data Error';
                                errorDescription = `Couldn't retrieve the placeholder data for placeholder ${podAssignments[0].placeholderId}. Cannot continue.`;
                            }
                        }
                    } else {
                        errorTitle = 'Invalid POD service';
                        errorDescription = `'${podService.name}' is not a valid POD provider! Cannot continue.`;
                    }
                }
                if (!errorTitle) {
                    $scope.pageDimensionsEntered(false, false);
                    $scope.page.productName = productName;
                    //$scope.page.pageWidthDim = widthMm;
                    //$scope.page.pageHeightDim = heightMm;
                    // Don't show the resize option or the base file replace button
                    $rootScope.showTemplateResizeBtn = false;
                    $scope.showBaseFileReplace = false;
                    $scope.pageDimensionsEntered(true, false);

                    for (const page of pages.reverse()) {
                        $scope.createPageEps(
                            page.widthMm,
                            page.heightMm,
                            $scope.DPI,
                            '',
                            '',
                            null,
                            false,
                            page.placeholder,
                            true
                        );
                        $scope.addPrintArea(canvas, page.widthMm, page.heightMm, printAreaImageUrl);
                    }

                    $timeout(function () {
                        const firstEps = ProductService.getEps();
                        const pageEps = canvas.getPageEpsById(firstEps.id);
                        canvas.discardActivePageEps();
                        canvas.setActivePageEps(pageEps, true);
                        canvas.discardActiveObject();
                    }, 100);

                    // Save image paths for color element option in step 2
                    const metadata = await getTemplateProductColorImages(podAssignments[0]);
                    if (
                        metadata &&
                        metadata.images.length > 0 &&
                        !metadata.images[0].path.includes('white-background.png')
                    ) {
                        ProductService.setPreviewColorOptionsMetadata(metadata);
                    }
                    ProductService.setPodAssignments(podAssignments);
                    // Save the dimensions the preview should have based on the image size from the color images
                    if (metadata && metadata.images.length > 0) {
                        const previewImage = await ImageUtilService.getImageFromSrc(
                            buildCloudFrontUrl(metadata.images[0].path)
                        );
                        ProductService.setProductTemplatePreviewTargetSize(previewImage.width, previewImage.height);
                    }
                    blockUI.stop();
                    $timeout(() => $scope.$apply());
                    canvas.renderAll();
                }
            } else if (
                !podAssignments.length &&
                podService &&
                !['printify', 'printful'].includes(podService.apiKeyReference)
            ) {
                //If we got here is because the user has selected a POD with manual creation
                $scope.pageDimensionsEntered(false, false);
                const result = await $mdDialog.show({
                    controller: 'PageDimensionsModalCtrl',
                    template: require('../../../../views/pages/create-product/pageDimensionsModal.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    locals: {
                        mode: 'create',
                        initialWidth: $scope.page.pageWidthDim,
                        initialHeight: $scope.page.pageHeightDim,
                        title: null,
                        exportPPI: $scope.exportPPI,
                        initialUnit: null
                    }
                });
                if (result) {
                    blockUI.start('Loading POD data...');
                    $timeout(() => $scope.$apply());
                    const page = result.page;
                    $scope.page.productName = page.productName;
                    $scope.manualTemplateProductResize(page);
                    $scope.createPageEps(
                        $scope.page.pageWidthDim,
                        $scope.page.pageHeightDim,
                        $scope.DPI,
                        '',
                        '',
                        null,
                        false,
                        null,
                        false,
                        null,
                        page.submittedData.unit
                    );
                    $scope.addPrintArea(canvas, $scope.page.pageWidthDim, $scope.page.pageHeightDim, printAreaImageUrl);
                    $scope.pageDimensionsEntered(true, false);
                    let newExportPPI = $scope.getMaxDefaultExportResolution(
                        page.pageWidthDim,
                        page.pageHeightDim,
                        page.pageDPI
                    );
                    $scope.setExportPPI(newExportPPI);
                    //As seen in the doc of BlockUI this loading stop after the completion of AJAX requests
                    //because in this specific situation we are not making request perse, a manual setting
                    //is needed in order to simulate the required behavior.
                    $timeout(() => {
                        blockUI.stop();
                    }, 2500);
                }
            } else {
                errorTitle = 'No POD assignments found!';
                errorDescription = 'No POD assignments were found, please try again or report the issue';
            }

            if (errorTitle) {
                blockUI.stop();
                $scope.skipTemplateExitAlert = true;
                MdDialogService.showCommonError(errorTitle, errorDescription, errorTitle, () => {
                    $location.path('/home');
                });
            }
        };

        if (!$scope.previewMode) {
            $scope.$on('$locationChangeStart', function (event, next, current) {
                if (!next.includes('/createProduct') && !$scope.skipTemplateExitAlert) {
                    if (
                        !confirm(
                            "You're about to exit the template. This means all changes will be lost, do you want to continue?"
                        )
                    ) {
                        event.preventDefault();
                        ProductService.clearChildTemplateProduct();
                    } else {
                        $scope.skipTemplateExitAlert = true;
                        $location.url(`${new URL(next).pathname}`);
                        $scope.beforeMergeProduct = null;
                        $rootScope.beforeMergeProduct = null;
                        ProductService.clearProduct();
                    }
                }
                $rootScope.lastLocation = current;
            });
        }

        $scope.publishDesign = async function (designTemplate, designId, action = $rootScope.saveUpdateAndOptions) {
            let design = {},
                optionSetGenerated = {};
            let listPreviews = designTemplate?.listPreviews || [];
            if (!listPreviews.length && designTemplate.preview) {
                listPreviews = [designTemplate.preview];
            }
            if (designId) {
                design = await getDesign(designId);
                design.images = listPreviews?.map((img) => img.thumbnailPath);
                if (action == $rootScope.saveUpdateAndOptions) {
                    design.isOptionSetReady = false;
                    optionSetGenerated = await createSetFromDesignTemplate(designTemplate.id);
                    design.optionSetId = optionSetGenerated.setId;
                }
            } else {
                optionSetGenerated = await createSetFromDesignTemplate(designTemplate.id);
                design = {
                    designTemplateIds: [designTemplate.id],
                    id: designId,
                    images: listPreviews?.map((img) => img.thumbnailPath),
                    optionSetId: optionSetGenerated.setId,
                    title: designTemplate.name,
                    subtitle: '',
                    isMyDesign: true
                };
            }
            design.snapshotUrl = designTemplate.snapshotUrl;
            const response = await saveDesign(design, designId);
            return { response, taskIdentifier: optionSetGenerated.taskIdentifier };
        };

        $scope.changeBgImagen = function (imagen) {
            const url = imagen.includes('data:image/') ? imagen : buildCloudFrontUrl(imagen);
            fabric.Image.fromURL(
                url,
                function (i) {
                    i.set({
                        originX: 'left',
                        originY: 'top'
                    });
                    i.scaleToWidth(canvasWidth);

                    canvas.setBackgroundImage(i, () => {
                        canvas.renderAll();
                    });

                    if ($('#imageLoader')[0]) {
                        $('#imageLoader')[0].value = null;
                    }
                    $timeout(() => $scope.$apply());
                },
                {
                    crossOrigin: 'Anonymous'
                }
            );
        };

        $scope.addAndOverrideImagePlaceholder = function (base64OrUrl, override = {}) {
            const url = base64OrUrl.includes('data:image/') ? base64OrUrl : buildCloudFrontUrl(base64OrUrl);
            const beforeMergeProductImage = new fabric.ImagePlaceholder(null, {
                ...$scope.buildImagePlaceholderProperties(),
                locked: true,
                ...override
            });

            canvas.add(beforeMergeProductImage);

            TestImageService.showStaticImage(canvas, beforeMergeProductImage, {
                imageUrl: url
            });
        };

        $scope.goHome = function () {
            ProductService.clearChildTemplateProduct();
            $location.url($location.path());
            $location.path('/home');
        };

        $scope.handleModalImport = async function (data) {
            $scope.canvaModalImportData = data;
            const { notFoundFonts, handleClose } = data;
            if (notFoundFonts?.length) {
                handleClose();
                $scope.showFontsReplacementMatcherModal = true;
            } else {
                await $scope.importLayers();
            }
        };

        $scope.importLayers = async function (fontsReplacementMap) {
            const data = $scope.canvaModalImportData;
            const { preserveId, preserveGroups, handleClose, handleError } = data;
            $scope.fontsReplacementMatcherModalIsLoading = true;
            const isCanvaDesign = data.from === 'canva';
            const isCustomilyDesign = data.from === 'customily';
            const isPsdDesign = data.from === 'psd';
            const isAmazonDesign = data.from === 'amazon';
            try {
                if (data.errorMessage) {
                    throw new Error(data.errorMessage);
                }

                let countCanvasElements = $scope.getLastElementId() + 1;
                //this is gonna throw an -Infinity if there is no elements in the canvas
                let countZIndex = canvas.getObjects().length ? canvas.getHighestZIndex() + 1 : 1;
                let psdElementsToEps = {};
                const pageEpsId = canvas.getFirstActivePageEpsId();
                if (!isCustomilyDesign) {
                    if (data.fileDimensions) {
                        const { width, height } = data.fileDimensions;
                        $scope.page.pageWidthDim = pixelsToMm(width, $scope.DPI);
                        $scope.page.pageHeightDim = pixelsToMm(height, $scope.DPI);
                        const newExportPPI = $scope.getMaxDefaultExportResolution(
                            $scope.page.pageWidthDim,
                            $scope.page.pageHeightDim,
                            $scope.DPI
                        );
                        $scope.setExportPPI(newExportPPI);

                        $scope.pageDimensionsEntered(true, false);
                        const pageEps = canvas.getFirstActivePageEps();
                        canvas.updatePageEps(
                            pageEps,
                            {
                                width,
                                height,
                                dpi: $scope.DPI,
                                baseEps: baseEPSPath,
                                baseImage: baseImagePath,
                                exportPPI: $scope.exportPPI
                            },
                            true
                        );
                        const epsInList = ProductService.getEps(pageEpsId);
                        if (epsInList) {
                            epsInList.width = width;
                            epsInList.height = height;
                        }
                    }

                    const { fileElements, pageBackgroundColor, importedFileName, asPng } = data;

                    if ($scope.forDesignFromCanva && importedFileName?.length) {
                        $scope.page.productName = importedFileName;
                        $scope.designTitle = importedFileName;
                    }

                    if (pageBackgroundColor?.length) {
                        await $scope.addSolidBg(undefined, pageBackgroundColor);
                    }

                    psdElementsToEps = {
                        textsEps: [],
                        circularTextsEps: [],
                        imagePlaceHoldersEps: [],
                        vectorEPSEps: []
                    };
                    const fileElementsCount = fileElements.length;
                    for (const item of fileElements) {
                        const {
                            top,
                            left,
                            width,
                            height,
                            rotation,
                            flipX,
                            flipY,
                            name,
                            zIndex,
                            visible
                        } = item.metadata;
                        const parameters = {
                            canvas,
                            scope: $scope,
                            canvasWidth,
                            canvasHeight,
                            pageEpsId,
                            name: name || '',
                            uuid: uuidv4(),
                            flipX: false,
                            flipY: false
                        };

                        const topToPixels = isCanvaDesign && !asPng ? pptxUnitsToPixels(top, $scope.DPI) : top;
                        const leftToPixels = isCanvaDesign && !asPng ? pptxUnitsToPixels(left, $scope.DPI) : left;
                        const widthToPixels = isCanvaDesign && !asPng ? pptxUnitsToPixels(width, $scope.DPI) : width;
                        const heightToPixels = isCanvaDesign && !asPng ? pptxUnitsToPixels(height, $scope.DPI) : height;
                        const override = {
                            top: topToPixels,
                            left: leftToPixels,
                            width: widthToPixels,
                            height: heightToPixels,
                            rotation,
                            visible,
                            centerX: leftToPixels + widthToPixels / 2,
                            centerY: topToPixels + heightToPixels / 2,
                            id: item.id,
                            zIndex: fileElementsCount - item.id + 1,
                            flipX,
                            flipY
                        };

                        if (zIndex) {
                            override.zIndex = zIndex;
                            override.id = zIndex;
                        }

                        if (['FromFileTextElement', 'FromFileCurvedTextElement'].includes(item.type)) {
                            const {
                                colorFill,
                                colorOptions,
                                textAlign,
                                font,
                                fontOptions,
                                fontSize,
                                lineSpacing,
                                textValue,
                                multiline
                            } = item.metadata;
                            override.multiline = multiline;
                            if (textValue?.length) {
                                override.text = textValue;
                            }

                            if (colorOptions?.length) {
                                const fontColorsMap = new Map(colorOptions.map((color, index) => [index + 1, color]));
                                const selectedIndex = colorFill
                                    ? colorOptions.findIndex((color) => color.hex === colorFill.hex)
                                    : -1;
                                override.fontColorOption = selectedIndex >= 0 ? selectedIndex + 1 : 1;
                                override.color = fontColorsMap.get(override.fontColorOption);
                                override.fontColorsMap = fontColorsMap;
                            } else if (colorFill) {
                                const fontColorsMap = new Map([[1, colorFill]]);
                                override.color = fontColorsMap.get(1);
                                override.fontColorsMap = fontColorsMap;
                            }

                            if (textAlign?.length) {
                                override.textAlign = textAlign;
                            }

                            const findFontEntry = (fontOption) => {
                                const style = fontOption.style === 'Italics' ? 'Italic' : fontOption.style;
                                const fontFound = $scope.fonts.find(
                                    (f) => f.Name === fontOption.family && f.Style === style
                                );
                                if (fontFound) return fontFound;
                                if (fontsReplacementMap?.size) return fontsReplacementMap.get(fontOption.rawTypeface);
                                return undefined;
                            };

                            if (fontOptions?.length) {
                                const resolvedFonts = fontOptions
                                    .map((fontOption) => ({
                                        rawTypeface: fontOption.rawTypeface,
                                        entry: findFontEntry(fontOption)
                                    }))
                                    .filter(({ entry }) => !!entry);

                                if (resolvedFonts.length) {
                                    const fontsMap = new Map(
                                        resolvedFonts.map(({ entry }, index) => [index + 1, entry.Path])
                                    );
                                    const selectedIndex = font
                                        ? resolvedFonts.findIndex((f) => f.rawTypeface === font.rawTypeface)
                                        : -1;
                                    const selected = resolvedFonts[selectedIndex >= 0 ? selectedIndex : 0].entry;

                                    override.fontsMap = fontsMap;
                                    override.fontOption = selectedIndex >= 0 ? selectedIndex + 1 : 1;
                                    override.fontFamily = `${selected.Name}_${selected.Style}`;
                                    override.fontName = `${selected.Name}_${selected.Style}`;
                                    override.fontPath = selected.Path;
                                }
                            } else if (font) {
                                const fontEntry = findFontEntry(font);
                                if (fontEntry) {
                                    const fontsMap = new Map([[1, fontEntry.Path]]);
                                    override.fontsMap = fontsMap;
                                    override.fontFamily = `${fontEntry.Name}_${fontEntry.Style}`;
                                    override.fontName = `${fontEntry.Name}_${fontEntry.Style}`;
                                    override.fontPath = fontEntry.Path;
                                    override.fontOption = 1;
                                }
                            }

                            if (fontSize) {
                                const fontSizeInPixels = pptxFontSizeToPixels(fontSize, $scope.DPI).toFixed(2);
                                override.minSizePx = fontSizeInPixels;
                                override.maxSizePx = fontSizeInPixels;
                                override.lineSpacing = lineSpacing;
                            }
                            if (isAmazonDesign) {
                                const fontSizeInPixels = fabric.util.pxToPt(fontSize ?? 300, $scope.DPI);
                                override.minSizePx = fontSizeInPixels / 2;
                                override.maxSizePx = fontSizeInPixels;
                                override.lineSpacing = lineSpacing;
                            }
                        }

                        switch (item.type) {
                            case 'FromFileTextElement':
                                psdElementsToEps.textsEps.push(
                                    TextService.buildBoundedTextProperties(
                                        { ...parameters, itext: false },
                                        {
                                            ...override,
                                            minSizePx: override.minSizePx ?? fabric.util.parseUnit(1 + 'pt')
                                        }
                                    )
                                );
                                break;

                            case 'FromFileCurvedTextElement':
                                psdElementsToEps.circularTextsEps.push(
                                    TextService.buildCircularTextProperties(parameters, {
                                        ...override,
                                        verticalDiameter: height,
                                        horizontalDiameter: width
                                    })
                                );
                                break;
                            case 'FromFileImageElement': {
                                const { imgUrl, maskUrl, imageOptions } = item.metadata;
                                if (maskUrl?.length) override.maskPath = maskUrl;

                                if (imageOptions?.length) {
                                    const dynamicImagesPath = new Map(
                                        imageOptions.map((url, index) => [index + 1, url])
                                    );
                                    const selectedIndex = imgUrl ? imageOptions.findIndex((url) => url === imgUrl) : -1;
                                    override.dynamicImageVariation = selectedIndex >= 0 ? selectedIndex + 1 : 1;
                                    override.dynamicImagesPath = dynamicImagesPath;
                                } else {
                                    // Fall back to the same stock photo used by placeholders when the
                                    // source has no real image, so dynamicImagesPath never stores an
                                    // undefined value (which becomes null once persisted and crashes
                                    // dynamicImageService.js on the next product load).
                                    const dynamicImageUrl = imgUrl || require('@/assets/images/photo-example.png');
                                    override.dynamicImagesPath = new Map([[1, dynamicImageUrl]]);
                                }
                                override.name = name || '';
                                psdElementsToEps.imagePlaceHoldersEps.push(
                                    DynamicImageService.buildDynamicImageProperties(
                                        canvas,
                                        countCanvasElements,
                                        override
                                    )
                                );
                                break;
                            }

                            case 'FromFileImagePlaceholderElement': {
                                const { imgUrl, maskUrl } = item.metadata;
                                const url = imgUrl || require('@/assets/images/photo-example.png');
                                override.testingUrl = url;
                                if (maskUrl?.length) override.maskPath = maskUrl;
                                psdElementsToEps.imagePlaceHoldersEps.push({
                                    ...$scope.buildImagePlaceholderProperties(),
                                    ...override
                                });
                                break;
                            }

                            case 'FromFileVectorElement': {
                                const { svgPath } = item.metadata;
                                if (svgPath) {
                                    override.vectors = [{ svgPath, position: 0 }];
                                }
                                psdElementsToEps.vectorEPSEps.push({
                                    ...DynamicVectorService.buildDynamicVectorProperties(parameters, override)
                                });
                                break;
                            }

                            case 'FromFileVectorPlaceholderElement': {
                                const { colorFill, svgString } = item.metadata;
                                if (colorFill) {
                                    const vectorString = VectorUtilService.createEPSSolidBg(
                                        override.width,
                                        override.height,
                                        colorFill.hex
                                    );
                                    override.svgString = vectorString;
                                } else if (svgString) {
                                    override.svgString = svgString;
                                }
                                psdElementsToEps.vectorEPSEps.push({
                                    ...VectorUtilService.buildVectorPlaceholderProperties(parameters, override),
                                    vectors: []
                                });
                                break;
                            }
                            case 'FromFileCalendarElement': {
                                const customilyCalendar = new CustomilyCalendar();
                                const options = customilyCalendar.getConfig();

                                override.calendar = true;
                                override.calendarConfig = options;
                                psdElementsToEps.imagePlaceHoldersEps.push({
                                    ...$scope.buildImagePlaceholderProperties(),
                                    ...override
                                });
                                break;
                            }
                            case 'FromFileMapElement': {
                                override.mapConfig = {
                                    hasPin: false,
                                    latitude: 17.9,
                                    longitude: -37.34,
                                    zoom: 1.077,
                                    availableStyles: [MAP_STYLE_PRESETS[0].value],
                                    defaultStyle: MAP_STYLE_PRESETS[0].value
                                };
                                psdElementsToEps.imagePlaceHoldersEps.push({
                                    ...$scope.buildImagePlaceholderProperties(),
                                    ...override
                                });
                                break;
                            }
                            case 'FromFileMoonPhaseElement': {
                                override.isMoonPhase = true;
                                psdElementsToEps.imagePlaceHoldersEps.push({
                                    ...$scope.buildImagePlaceholderProperties(),
                                    ...override
                                });
                                break;
                            }
                            case 'FromFileStarMapElement': {
                                override.starMapConfig = {
                                    selectedLocation: [0, 0],
                                    selectedDate: new Date(),
                                    showConstellations: true,
                                    showMilkyWay: true,
                                    showGridLines: true,
                                    shopperConfigEnabled: false,
                                    defaultStyle: JSON.parse(angular.toJson(starMapUtils.STAR_MAP_STYLES[0])),
                                    availableStyles: JSON.parse(angular.toJson([starMapUtils.STAR_MAP_STYLES[0]]))
                                };
                                const vectorParams = {
                                    canvas,
                                    canvasWidth,
                                    canvasHeight,
                                    id: $scope.getLastElementId() + 1,
                                    uuid: uuidv4()
                                };
                                override.vectors = [];
                                psdElementsToEps.vectorEPSEps.push({
                                    ...VectorUtilService.buildVectorPlaceholderProperties(vectorParams),
                                    ...override
                                });
                                break;
                            }
                            default:
                                console.warn(`Unexpected item type: ${item.type}`);
                                break;
                        }
                    }
                }

                const groupsMapping = {};
                if (preserveGroups) {
                    for (const [index, group] of data.canvasGroups.sort((a, b) => b.zIndex - a.zIndex).entries()) {
                        let groupToLoad = { ...group };
                        const newId = uuidv4();
                        groupsMapping[group.id] = newId;

                        groupToLoad = {
                            ...groupToLoad,
                            id: newId,
                            uuid: uuidv4(),
                            pageEpsId: canvas.getFirstActivePageEpsId(),
                            position: preserveId ? group.position : index + 1
                        };
                        canvas.addGroup(groupToLoad, true);
                    }
                }
                const { textsEps, circularTextsEps, imagePlaceHoldersEps, vectorEPSEps } = isCustomilyDesign
                    ? data.canvasElements
                    : psdElementsToEps;

                const normalizeCanvasElements = (canvasElements) => {
                    return canvasElements.map((item) => {
                        const newCanvasElement = {
                            ...item,
                            groupId: groupsMapping[item.groupId] ?? null,
                            id: isCanvaDesign ? item.zIndex : preserveId ? item.id : countCanvasElements,
                            uuid: uuidv4(),
                            pageEpsId: pageEpsId,
                            locked: false,
                            visible: isCustomilyDesign ? true : item.visible,
                            zIndex: preserveId ? item.zIndex : isCustomilyDesign ? countZIndex : item.zIndex
                        };
                        countCanvasElements++;
                        countZIndex++;
                        return newCanvasElement;
                    });
                };

                const normalizeAndLoad = async (elements, loadFunction) => {
                    elements = normalizeCanvasElements(elements);
                    const tasks = elements.map((element) => async () => await loadFunction(element, pageEpsId));
                    return await ExecutionService.runTasksInChunks(tasks);
                };

                await starMapUtils.showCelestialContainer();

                const loadTextsPromise = normalizeAndLoad(textsEps, loadText);
                const loadCircularTextsPromise = normalizeAndLoad(circularTextsEps, loadCircularText);
                const loadImagesPromise = normalizeAndLoad(imagePlaceHoldersEps, loadImage);
                const loadVectorEPSPromise = normalizeAndLoad(vectorEPSEps, loadVector);

                const [texts, circularTexts, images, vectors] = await Promise.all([
                    loadTextsPromise,
                    loadCircularTextsPromise,
                    loadImagesPromise,
                    loadVectorEPSPromise
                ]);

                const elements = [...texts, ...circularTexts, ...images, ...vectors].sort(
                    (a, b) => b.zIndex - a.zIndex
                );

                if (isCustomilyDesign || isPsdDesign || isAmazonDesign) {
                    CanvasUtilService.scaleCanvasElementsForPreview(canvas, elements, pageEpsId, false, true);
                }

                const reversedElements = [...elements].reverse();

                reversedElements.forEach((canvasElement) => {
                    if (canvasElement) {
                        canvasElement.addedOnEdit = !!$scope.editMode;
                        canvas.add(canvasElement, true, false);
                    }
                });

                updateElementsOrderFromZIndex(canvas);
                handleClose();
            } catch (error) {
                $scope.isModalImportErrorOpen = true;
                $scope.modalImportErrorMessage = error.message;
                handleError();
            } finally {
                $scope.showFontsReplacementMatcherModal = false;
                $scope.canvaModalImportData = null;
                $scope.fontsReplacementMatcherModalIsLoading = false;
            }
        };

        $scope.onModalImportErrorClose = function () {
            $scope.isModalImportErrorOpen = false;
        };

        $scope.onModalInitializeErrorClose = function () {
            $scope.isModalInitializeErrorOpen = false;
            $location.path('/home');
        };

        $scope.onModalErrorCopyMessage = function () {
            $mdToast.show($mdToast.simple().textContent('Error copied!').position('top right').hideDelay(2000));
        };

        $scope.onModalErrorFailedToCopy = function (message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(`Couldn't copy to clipboard, error: ${message}`)
                    .position('top right')
                    .hideDelay(2000)
                    .toastClass('md-toast-error')
            );
        };
        $scope.updateObjectsPropertyFromGroup = (value, selectedObjectGroup, callback) => {
            const objects = selectedObjectGroup?._objects;
            if (!objects) {
                return;
            }
            canvas.temporaryDiscardActiveObject(() => {
                for (const object of objects) {
                    if (value === undefined) {
                        callback(object);
                    } else {
                        callback(value, object);
                    }
                }
            });
        };

        $scope.objectHasProp = (object, property) => {
            return (
                Object.prototype.hasOwnProperty.call(object, property) &&
                object[property] !== null &&
                object[property] !== undefined
            );
        };

        $scope.getObjectType = (object) => {
            const { objectHasProp } = $scope;
            const hasProp = {
                dynamicImagesPath: objectHasProp(object, 'dynamicImagesPath'),
                mapConfig: objectHasProp(object, 'mapConfig'),
                wordCloudConfig: objectHasProp(object, 'wordCloudConfig'),
                starMapConfig: objectHasProp(object, 'starMapConfig'),
                qrConfig: objectHasProp(object, 'qrConfig'),
                allowUserUpload: objectHasProp(object, 'allowUserUpload'),
                wordSearchConfig: objectHasProp(object, 'wordSearchConfig')
            };
            const objectType = object?.type;

            const isImagePlaceholder = objectType === 'image-placeholder';
            const isDynamicImage = isImagePlaceholder && hasProp.dynamicImagesPath;
            const isMoonPhase = isImagePlaceholder && object?.isMoonPhase;
            const isMap = isImagePlaceholder && hasProp.mapConfig;
            const isOverlay = isImagePlaceholder && hasProp.isColorOptions;
            const isProductColors = isImagePlaceholder && hasProp.isOverlay;
            const isWordCloud = isImagePlaceholder && hasProp.wordCloudConfig;
            const isVectorPlaceholder = objectType === 'vector-placeholder' && hasProp.allowUserUpload;
            const isDynamicVector = objectType === 'vector-placeholder' && !hasProp.allowUserUpload;
            const isStarMap = isVectorPlaceholder && hasProp.starMapConfig;
            const isQr = isVectorPlaceholder && hasProp.qrConfig;
            const isWordSearch = isImagePlaceholder && hasProp.wordSearchConfig;

            if (isImagePlaceholder && !isDynamicImage && !isMap && !isStarMap && !isWordCloud && !isWordSearch) {
                return 'image-placeholder';
            } else if (
                isDynamicImage &&
                !isMap &&
                !isStarMap &&
                !isOverlay &&
                !isProductColors &&
                !isMoonPhase &&
                !isWordCloud &&
                !isWordSearch
            ) {
                return 'dynamic-image';
            } else if (isMap && !isDynamicImage && !isStarMap && !isWordCloud) {
                return 'map';
            } else if (isWordCloud) {
                return 'word-cloud';
            } else if (objectType === 'bounded-text') {
                return 'bounded-text';
            } else if (objectType === 'text-transform') {
                return 'text-transform';
            } else if (objectType === 'path-itext') {
                return 'path-itext';
            } else if (isVectorPlaceholder && !isDynamicVector && !isStarMap) {
                return 'vector-placeholder';
            } else if (isDynamicVector && !isStarMap && !isDynamicImage) {
                return 'dynamic-vector';
            } else if (isStarMap && !isDynamicImage) {
                return 'star-map';
            } else if (isQr && !isDynamicImage) {
                return 'qr';
            } else if (isWordSearch) {
                return 'word-search';
            }

            return null;
        };

        $scope.areAllObjectsOfType = (objects, targetType) =>
            (objects && objects.every((object) => $scope.getObjectType(object) === targetType)) || false;

        $scope.areAllObjectsOfSameType = (objects) => {
            if (!objects || !objects.length > 0) {
                return null;
            }

            const firstType = $scope.getObjectType(objects[0]);
            return $scope.areAllObjectsOfType(objects, firstType) ? true : null;
        };

        $scope.allObjectsHaveSamePropertyValue = (objects, property, isFunction = false) => {
            if (objects.length === 0) {
                return false;
            }

            const getPropertyValue = (obj) => {
                if (obj[property] === null) {
                    return undefined;
                }
                return isFunction && typeof obj[property] === 'function' ? obj[property]() : obj[property];
            };

            const firstObject = objects[0];
            const firstValue = getPropertyValue(firstObject);

            return objects.every((object) => {
                const itemValue = getPropertyValue(object);
                return itemValue === firstValue;
            });
        };

        $scope.checkIfAllObjectsHaveEmptyProperty = (objects, property) => {
            if (!objects || !objects.length > 0) return false;
            return objects.every(
                (item) =>
                    (Object.prototype.hasOwnProperty.call(item, property) && item[property]?.length <= 0) ||
                    item[property] === undefined ||
                    item[property] === null
            );
        };

        $scope.someHaveProp = (objects, property) => {
            return objects.some(
                (item) =>
                    Object.prototype.hasOwnProperty.call(item, property) &&
                    item[property] !== null &&
                    item[property] !== undefined
            );
        };

        $scope.getValueOrUndefined = (condition, value) => {
            return condition ? value : undefined;
        };

        $scope.objectsHasSameColors = (objects) => {
            const { checkIfAllObjectsHaveEmptyProperty } = $scope;
            if (!objects.length > 0) return true;

            if (checkIfAllObjectsHaveEmptyProperty(objects, 'colors')) return true;

            const firstObjectColors = objects[0]?.colors;

            if (firstObjectColors === undefined) return true;

            for (const object of objects) {
                const { colors } = object;

                if (!colors) return false;

                if (colors.length !== firstObjectColors.length) return false;

                for (let i = 0; i < colors.length; i++) {
                    const firstColor = firstObjectColors[i];
                    const currentColor = colors[i];

                    if (
                        firstColor.position !== currentColor.position ||
                        firstColor.hex !== currentColor.hex ||
                        firstColor.cmyk !== currentColor.cmyk ||
                        firstColor.alpha !== currentColor.alpha
                    ) {
                        return false;
                    }
                }
            }

            return true;
        };

        $scope.getImageTypeFromObjects = (objects) => {
            const { allObjectsHaveSamePropertyValue, objectsHasSameColors } = $scope;

            if (!objects.length > 0) {
                return undefined;
            }

            if (
                !(
                    allObjectsHaveSamePropertyValue(objects, 'fullColor') &&
                    allObjectsHaveSamePropertyValue(objects, 'grading')
                )
            ) {
                return undefined;
            }

            const { fullColor, grading } = objects[0];

            const isSingleColor = !fullColor && !grading;
            const isGrading = !fullColor && grading;

            if (isSingleColor) {
                if (!objectsHasSameColors(objects)) {
                    return undefined;
                }

                return fabric.IMAGE_MODE_SINGLE_COLOR;
            }

            if (isGrading) {
                return fabric.IMAGE_MODE_GRADING;
            }

            return fabric.IMAGE_MODE_FULL_COLOR;
        };

        $scope.resetObjectsColorPosition = async (objects) => {
            const { bulkEdit, bulkEditImageColorPicker } = $scope;
            bulkEdit.selectedProperties.colorPosition = 1;
            bulkEdit.selectedProperties.isColorPositionMixed = false;
            const promises = objects.map(async (object) => {
                object.selectedColorPosition = 1;
                return DynamicImageService.changeDynamicImageColorPosition(
                    object,
                    object.selectedColorPosition,
                    null,
                    canvas
                );
            });
            await Promise.all(promises);

            if (bulkEdit.selectedProperties.imageType) {
                const firstObject = objects[0];
                if (firstObject.getColor) {
                    bulkEditImageColorPicker.setColor(firstObject.getColor());
                }
            }
        };

        $scope.normalizeArray = (arrayToNormalize = [], propertyToSort, propertiesToIgnore = []) => {
            return arrayToNormalize
                .map((object) => {
                    const normalizedObject = {};
                    Object.keys(object)
                        .filter((key) => !propertiesToIgnore.includes(key))
                        .sort()
                        .forEach((key) => {
                            normalizedObject[key] = object[key];
                        });
                    return normalizedObject;
                })
                .sort((a, b) => {
                    const aValue = a[propertyToSort];
                    const bValue = b[propertyToSort];
                    if (aValue == null && bValue == null) return 0;
                    if (aValue == null) return -1;
                    if (bValue == null) return 1;
                    return String(aValue).localeCompare(String(bValue));
                });
        };

        $scope.allObjectsHaveSameArrayObjectProperties = (objects, property, propertyToSort) => {
            if (!objects || objects.length === 0 || objects.some((obj) => !obj[property])) {
                return false;
            }
            const firstNormalized = JSON.stringify($scope.normalizeArray(objects[0][property], propertyToSort, ['id']));
            return objects.every((obj) => {
                const currentNormalized = JSON.stringify($scope.normalizeArray(obj[property], propertyToSort, ['id']));
                return currentNormalized === firstNormalized;
            });
        };

        $scope.checkBulkEditType = (objects) => {
            const { bulkEdit, getObjectType, areAllObjectsOfType } = $scope;
            const firstType = getObjectType(objects[0]);
            if (!areAllObjectsOfType(objects, firstType)) {
                return undefined;
            }

            bulkEdit.showImagePlaceholder = firstType === 'image-placeholder';
            bulkEdit.showDynamicImage = firstType === 'dynamic-image';
            bulkEdit.showMap = firstType === 'map';
            bulkEdit.showTextBox = firstType === 'bounded-text';
            bulkEdit.showPathIText = firstType === 'path-itext';
            bulkEdit.showVectorPlaceholder = firstType === 'vector-placeholder';
            bulkEdit.showDynamicVector = firstType === 'dynamic-vector';
            bulkEdit.showStarMap = firstType === 'star-map';
            bulkEdit.showQr = firstType === 'qr';
        };

        $scope.initBulkEditProperties = async () => {
            try {
                const {
                    selectedObjectGroupProperties,
                    selectedObjectGroup,
                    allObjectsHaveSamePropertyValue,
                    allObjectsHaveSameArrayObjectProperties,
                    someHaveProp,
                    getValueOrUndefined,
                    getImageTypeFromObjects,
                    bulkEdit,
                    checkBulkEditType,
                    checkIfAllObjectsHaveEmptyProperty
                } = $scope;

                const objects = selectedObjectGroup._objects;
                if (!objects.length > 0) {
                    bulkEdit.enabled = false;
                    return;
                }

                const firstObject = objects[0];

                bulkEdit.type = firstObject?.type;
                const sameValues = {
                    id: allObjectsHaveSamePropertyValue(objects, 'id'),
                    left: allObjectsHaveSamePropertyValue(objects, 'left'),
                    top: allObjectsHaveSamePropertyValue(objects, 'top'),
                    angle: allObjectsHaveSamePropertyValue(objects, 'angle'),
                    width: allObjectsHaveSamePropertyValue(objects, 'width'),
                    height: allObjectsHaveSamePropertyValue(objects, 'height'),
                    skewX: allObjectsHaveSamePropertyValue(objects, 'skewX'),
                    skewY: allObjectsHaveSamePropertyValue(objects, 'skewY'),
                    hasMask: allObjectsHaveSamePropertyValue(objects, 'hasMask'),
                    coverMaskArea: allObjectsHaveSamePropertyValue(objects, 'coverMaskArea'),
                    isLimitImageToPlaceholder: allObjectsHaveSamePropertyValue(objects, 'isLimitImageToPlaceholder'),
                    lockMovement: allObjectsHaveSamePropertyValue(objects, 'lockMovement'),
                    lockScaling: allObjectsHaveSamePropertyValue(objects, 'lockScaling'),
                    rotationStep: allObjectsHaveSamePropertyValue(objects, 'rotationStep'),
                    RemoveBackground: allObjectsHaveSamePropertyValue(objects, 'RemoveBackground'),
                    removeBackgroundCOP: allObjectsHaveSamePropertyValue(objects, 'removeBackgroundCOP'),
                    CustomilyRemoveBackground: allObjectsHaveSamePropertyValue(objects, 'CustomilyRemoveBackground'),
                    CustomilyFaceCutOut: allObjectsHaveSamePropertyValue(objects, 'CustomilyFaceCutOut'),
                    CustomilyImageFilter: allObjectsHaveSamePropertyValue(objects, 'CustomilyImageFilter'),
                    CutoutFace: allObjectsHaveSamePropertyValue(objects, 'CutoutFace'),
                    textToImage: allObjectsHaveSamePropertyValue(objects, 'textToImage'),
                    imageToImage: allObjectsHaveSamePropertyValue(objects, 'imageToImage'),
                    imageToImageConfig: allObjectsHaveSamePropertyValue(objects, 'imageToImageConfig'),
                    fullColor: allObjectsHaveSamePropertyValue(objects, 'fullColor'),
                    grading: allObjectsHaveSamePropertyValue(objects, 'grading'),
                    colorPosition: allObjectsHaveSamePropertyValue(objects, 'selectedColorPosition'),
                    colorLibraryId: allObjectsHaveSamePropertyValue(objects, 'colorLibraryId'),
                    getFontSize: allObjectsHaveSamePropertyValue(objects, 'getFontSize', true),
                    text: allObjectsHaveSamePropertyValue(objects, 'text'),
                    dynamicImageVariation: allObjectsHaveSamePropertyValue(objects, 'dynamicImageVariation'),
                    imageLibraryId: allObjectsHaveSamePropertyValue(objects, 'imageLibraryId'),
                    isColorOptions: allObjectsHaveSamePropertyValue(objects, 'isColorOptions'),
                    selectedPosition: allObjectsHaveSamePropertyValue(objects, 'selectedPosition'),
                    vectorLibraryId: allObjectsHaveSamePropertyValue(objects, 'vectorLibraryId'),
                    fontPath: allObjectsHaveSamePropertyValue(objects, 'fontPath'),
                    fontLibraryId: allObjectsHaveSamePropertyValue(objects, 'fontLibraryId'),
                    fontOption: allObjectsHaveSamePropertyValue(objects, 'fontOption'),
                    minSizePx: allObjectsHaveSamePropertyValue(objects, 'minSizePx'),
                    maxSizePx: allObjectsHaveSamePropertyValue(objects, 'maxSizePx'),
                    tracking: allObjectsHaveSamePropertyValue(objects, 'getTrackingAmount', true),
                    lineSpacing: allObjectsHaveSamePropertyValue(objects, 'lineSpacing'),
                    textAlign: allObjectsHaveSamePropertyValue(objects, 'textAlign'),
                    textVerticalAlign: allObjectsHaveSamePropertyValue(objects, 'textVerticalAlign'),
                    multiline: allObjectsHaveSamePropertyValue(objects, 'multiline'),
                    verticalText: allObjectsHaveSamePropertyValue(objects, 'verticalText'),
                    caps: allObjectsHaveSamePropertyValue(objects, 'caps'),
                    type: allObjectsHaveSamePropertyValue(objects, 'type'),
                    imageEffects: allObjectsHaveSameArrayObjectProperties(objects, 'imageEffects', 'presetId')
                };
                const containProps = {
                    dynamicImagesPath: someHaveProp(objects, 'dynamicImagesPath'),
                    mapConfig: someHaveProp(objects, 'mapConfig'),
                    starMapConfig: someHaveProp(objects, 'starMapConfig'),
                    qrConfig: someHaveProp(objects, 'qrConfig'),
                    allowUserUpload: someHaveProp(objects, 'allowUserUpload'),
                    calendarConfig: someHaveProp(objects, 'calendarConfig'),
                    imageToImageConfig: someHaveProp(objects, 'imageToImageConfig'),
                    imageEffects: !checkIfAllObjectsHaveEmptyProperty(objects, 'imageEffects')
                };

                bulkEdit.selectedProperties = {
                    id: getValueOrUndefined(sameValues.id, firstObject?.id),
                    isIdMixed: !sameValues.id,
                    centerX: getValueOrUndefined(sameValues.left, selectedObjectGroupProperties.centerX),
                    isCenterXMixed: !sameValues.left,
                    centerY: getValueOrUndefined(sameValues.top, selectedObjectGroupProperties.centerY),
                    isCenterYMixed: !sameValues.top,
                    rotation: getValueOrUndefined(sameValues.angle, firstObject?.angle),
                    isRotationMixed: !sameValues.angle,
                    width: getValueOrUndefined(sameValues.width, pixelsToMm(firstObject?.width, $scope.DPI)),
                    isWidthMixed: !sameValues.width,
                    height: getValueOrUndefined(sameValues.height, pixelsToMm(firstObject?.height, $scope.DPI)),
                    isHeightMixed: !sameValues.height,
                    locked: firstObject?.locked,
                    objectCount: objects.length,
                    skewX: getValueOrUndefined(sameValues.skewX, firstObject?.skewX),
                    isSkewXMixed: !sameValues.skewX,
                    skewY: getValueOrUndefined(sameValues.skewY, firstObject?.skewY),
                    isSkewYMixed: !sameValues.skewY,
                    imageType: getImageTypeFromObjects(objects),
                    hasMask: sameValues.hasMask === true ? firstObject?.hasMask : true,
                    coverMaskArea: getValueOrUndefined(sameValues.coverMaskArea, firstObject?.coverMaskArea),
                    isLimitImageToPlaceholder: getValueOrUndefined(
                        sameValues.isLimitImageToPlaceholder,
                        firstObject?.isLimitImageToPlaceholder
                    ),
                    lockMovement: getValueOrUndefined(sameValues.lockMovement, firstObject?.lockMovement),
                    lockScaling: getValueOrUndefined(sameValues.lockScaling, firstObject?.lockScaling),
                    rotationLock:
                        getValueOrUndefined(sameValues.rotationStep, firstObject?.rotationStep) === 90 ? true : false,
                    RemoveBackground: getValueOrUndefined(sameValues.RemoveBackground, firstObject?.RemoveBackground),
                    removeBackgroundCOP: getValueOrUndefined(
                        sameValues.removeBackgroundCOP,
                        firstObject?.removeBackgroundCOP
                    ),
                    CustomilyRemoveBackground: getValueOrUndefined(
                        sameValues.CustomilyRemoveBackground,
                        firstObject?.CustomilyRemoveBackground
                    ),
                    CustomilyFaceCutOut: getValueOrUndefined(
                        sameValues.CustomilyFaceCutOut,
                        firstObject?.CustomilyFaceCutOut
                    ),
                    CustomilyImageFilter: getValueOrUndefined(
                        sameValues.CustomilyImageFilter,
                        firstObject?.CustomilyImageFilter
                    ),
                    isPencilDrawingActive:
                        sameValues.CustomilyImageFilter && firstObject?.CustomilyImageFilter === ImageFilter.PENCIL,
                    isAquaFilterActive:
                        sameValues.CustomilyImageFilter && firstObject?.CustomilyImageFilter === ImageFilter.AQUA,
                    CutoutFace: getValueOrUndefined(sameValues.CutoutFace, firstObject?.CutoutFace),
                    textToImage: getValueOrUndefined(sameValues.textToImage, firstObject?.textToImage),
                    imageToImage: getValueOrUndefined(sameValues.imageToImage, firstObject?.imageToImage),
                    imageToImageConfig: getValueOrUndefined(
                        sameValues.imageToImageConfig,
                        firstObject?.imageToImageConfig
                    ),
                    fullColor: getValueOrUndefined(sameValues.fullColor, firstObject?.fullColor),
                    grading: getValueOrUndefined(sameValues.grading, firstObject?.grading),
                    colorPosition: getValueOrUndefined(sameValues.colorPosition, firstObject?.selectedColorPosition),
                    isColorPositionMixed: !sameValues.colorPosition,
                    colorLibraryId: getValueOrUndefined(sameValues.colorLibraryId, firstObject?.colorLibraryId),
                    isColorLibraryIdMixed: !sameValues.colorLibraryId,
                    currentFontSize: getValueOrUndefined(
                        sameValues.getFontSize,
                        firstObject?.getFontSize ? fabric.util.pxToPt(firstObject?.getFontSize()) : undefined
                    ),
                    isCurrentFontSizeMixed: !sameValues.currentFontSize,
                    text: getValueOrUndefined(
                        sameValues.text,
                        firstObject?.getText ? firstObject?.getText() : firstObject?.text
                    ),
                    isTextMixed: !sameValues.text,
                    dynamicImageVariation: getValueOrUndefined(
                        sameValues.dynamicImageVariation,
                        firstObject?.dynamicImageVariation
                    ),
                    isDynamicImageVariationMixed: !sameValues.dynamicImageVariation,
                    imageLibraryId: getValueOrUndefined(sameValues?.imageLibraryId, firstObject?.imageLibraryId),
                    isImageLibraryIdMixed: !sameValues?.imageLibraryId,
                    isColorOptions: getValueOrUndefined(sameValues?.isColorOptions, firstObject?.isColorOptions),
                    position: getValueOrUndefined(sameValues?.selectedPosition, firstObject?.selectedPosition),
                    isPositionMixed: !sameValues?.selectedPosition,
                    vectorLibraryId: getValueOrUndefined(sameValues?.vectorLibraryId, firstObject?.vectorLibraryId),
                    isVectorLibraryIdMixed: !sameValues?.vectorLibraryId,
                    fontPath: getValueOrUndefined(sameValues?.fontPath, firstObject?.fontPath),
                    isFontPathMixed: !sameValues?.fontPath,
                    fontLibraryId: getValueOrUndefined(sameValues?.fontLibraryId, firstObject?.fontLibraryId),
                    isFontLibraryIdMixed: !sameValues?.fontLibraryId,
                    fontOption: getValueOrUndefined(sameValues.fontOption, firstObject?.fontOption),
                    isFontOptionMixed: !sameValues.fontOption,
                    minSizePx: getValueOrUndefined(
                        sameValues.minSizePx,
                        fabric.util.pxToPt(firstObject?.minSizePx) || 0
                    ),
                    isMinSizePxMixed: !sameValues.minSizePx,
                    maxSizePx: getValueOrUndefined(
                        sameValues.maxSizePx,
                        fabric.util.pxToPt(firstObject?.maxSizePx) || 0
                    ),
                    isMaxSizePxMixed: !sameValues.maxSizePx,
                    tracking: getValueOrUndefined(sameValues.tracking, firstObject?.tracking),
                    isTrackingMixed: !sameValues.tracking,
                    lineSpacing: getValueOrUndefined(sameValues.lineSpacing, firstObject?.lineSpacing * 100),
                    isLineSpacingMixed: !sameValues.lineSpacing,
                    textAlign: getValueOrUndefined(sameValues.textAlign, firstObject?.textAlign),
                    isTextAlignMixed: !sameValues.textAlign,
                    textVerticalAlign: getValueOrUndefined(
                        sameValues.textVerticalAlign,
                        firstObject?.textVerticalAlign
                    ),
                    isTextVerticalAlignMixed: !sameValues.textVerticalAlign,
                    multiline: getValueOrUndefined(sameValues.multiline, firstObject?.multiline),
                    verticalText: getValueOrUndefined(sameValues.verticalText, firstObject?.verticalText),
                    caps: getValueOrUndefined(sameValues.caps, firstObject?.caps),
                    fontColorsMap: getValueOrUndefined(sameValues.fontColorsMap, firstObject?.fontColorsMap),
                    type: getValueOrUndefined(sameValues.type, firstObject?.type),
                    imageEffects: getValueOrUndefined(sameValues.imageEffects, firstObject?.imageEffects),
                    containsImageEffects: containProps.imageEffects,
                    containsCalendarConfig: containProps.calendarConfig,
                    containsAllowUserUpload: containProps.allowUserUpload ? true : false,
                    containsDynamicImagesPath: containProps.dynamicImagesPath,
                    containsMapConfig: containProps.mapConfig,
                    containsStarMapConfig: containProps.starMapConfig,
                    containsQrConfig: containProps.qrConfig
                };

                checkBulkEditType(objects);

                bulkEdit.selectedProperties.imageType = bulkEdit.selectedProperties.imageType
                    ? bulkEdit.selectedProperties.imageType
                    : undefined;

                if (bulkEdit.showImagePlaceholder) {
                    if (
                        bulkEdit.selectedProperties.colorLibraryId &&
                        !bulkEdit.selectedProperties.isColorLibraryIdMixed
                    ) {
                        LibrariesAPIService.getLibraryName(bulkEdit.selectedProperties.colorLibraryId).then(
                            async function (name) {
                                $scope.selectedColorLibraryName = name;
                            }
                        );
                    }
                } else if (bulkEdit.showTextBox) {
                    if (
                        bulkEdit.selectedProperties.fontLibraryId &&
                        !bulkEdit.selectedProperties.isFontLibraryIdMixed
                    ) {
                        LibrariesAPIService.getLibraryName(bulkEdit.selectedProperties.fontLibraryId).then(
                            async function (name) {
                                $scope.selectedFontLibraryName = name;
                            }
                        );
                    }

                    if (bulkEdit.selectedProperties.isFontPathMixed) {
                        $scope.searchFont.selectedText = 'Mixed';
                    }
                    return;
                }
            } catch (error) {
                console.log(error);
            }
        };

        $scope.disableImageFilters = async (object, filters) => {
            try {
                const {
                    bulkEdit,
                    updateTextToImage,
                    activateRemoveBG,
                    activateCustomilyRemoveBG,
                    activateCustomilyFaceCutOut,
                    activateCustomilyImageFilter,
                    activateImageToImage
                } = $scope;

                if (filters['openAI']) {
                    bulkEdit.selectedProperties.textToImage = false;
                    updateTextToImage(false, object);
                }
                if (filters['imageToImage']) {
                    bulkEdit.selectedProperties.imageToImage = false;
                    bulkEdit.selectedProperties.imageToImageConfig = null;
                    activateImageToImage(false, object);
                }
                if (filters['cutoutPro-removebg']) {
                    bulkEdit.selectedProperties.removeBackgroundCOP = false;
                    await CutoutProUtilService.addFaceCutoutFilter($scope, canvas, false, object, true);
                }
                if (filters['cutoutPro-faceCutout']) {
                    bulkEdit.selectedProperties.CutoutFace = false;
                    await CutoutProUtilService.addFaceCutoutFilter($scope, canvas, true, object, true);
                }
                if (filters['removebg']) {
                    bulkEdit.selectedProperties.RemoveBackground = false;
                    await activateRemoveBG(false, object);
                }
                if (filters['customily-removebg']) {
                    bulkEdit.selectedProperties.CustomilyRemoveBackground = false;
                    await activateCustomilyRemoveBG(false, object);
                }
                if (filters['customily-facecut']) {
                    bulkEdit.selectedProperties.CustomilyFaceCutOut = false;
                    await activateCustomilyFaceCutOut(false, object);
                }
                if (filters['customily-imageFilter']) {
                    bulkEdit.selectedProperties.CustomilyImageFilter = 0;
                    bulkEdit.selectedProperties.isPencilDrawingActive = false;
                    bulkEdit.selectedProperties.isAquaFilterActive = false;
                    await activateCustomilyImageFilter(null, object);
                }
            } catch (error) {
                console.log(error);
            }
        };

        $scope.scrollToSelectedVirtualItem = async function () {
            if (!$scope.filteredFonts || $scope.filteredFonts.length === 0) {
                return;
            }

            // Find the index of the selected item
            const selectedIndex = $scope.filteredFonts.findIndex(
                (item) => `${item.Name} (${item.Style})` === $scope.searchFont.selectedText
            );

            // Ensure the index exists
            if (selectedIndex >= 0) {
                await new Promise((resolve) => $timeout(resolve, 50));
                // Calculate the height of the virtual item
                const itemHeight = 48; // Height in pixels of each item
                const virtualRepeatContainer = document.querySelector(
                    '.autocomplete-font-container .md-virtual-repeat-scroller'
                );

                if (virtualRepeatContainer) {
                    // Scroll the container to the index of the selected item
                    virtualRepeatContainer.scrollTop = selectedIndex * itemHeight;
                }
            }
        };

        $scope.searchFonts = function (query) {
            try {
                if (!query) {
                    $scope.filteredFonts = $scope.fonts;
                    return;
                }
                $scope.filteredFonts = $scope.fonts.filter(function (font) {
                    const string = `${font.Name} (${font.Style})`;
                    return string.toLowerCase().includes((query || '').toLowerCase());
                });
            } catch (error) {
                console.log(error);
            }
        };

        $scope.setPreviousFont = function () {
            $scope.searchFont.searchText = '';
        };

        $scope.downloadCurrentCanvasAsImage = async function () {
            if (!canvas) return;
            await handleDownloadCurrentCanvasAsImage(canvas, $scope.page.productName);
        };

        $scope.activatePencilFilter = async function (value = false, object) {
            $scope.activateCustomilyImageFilter(value, object, ImageFilter.PENCIL);
        };

        $scope.activateAquaFilter = async function (value = false, object) {
            $scope.activateCustomilyImageFilter(value, object, ImageFilter.AQUA);
        };

        $scope.activateCustomilyImageFilter = async function (value = false, object, filter = ImageFilter.DEFAULT) {
            try {
                const { bulkEdit, selectedImageProperties } = $scope;
                const targetProperties = bulkEdit?.enabled ? bulkEdit?.selectedProperties : selectedImageProperties;

                if (value && bulkEdit?.enabled) {
                    $scope.disableImageFilters(object, {
                        openAI: true
                    });
                }

                object.CustomilyImageFilter = value ? filter : 0;
                targetProperties.isPencilDrawingActive = object.CustomilyImageFilter === ImageFilter.PENCIL;
                targetProperties.isAquaFilterActive = object.CustomilyImageFilter === ImageFilter.AQUA;
                targetProperties.CustomilyImageFilter = value ? filter : 0;
                if ($scope.editMode) {
                    object.setEditedProp?.('CustomilyImageFilter');
                }

                // Next line means that an image was previously used. If that's the case reusing it from file and avoid API call.
                if (object.CustomilyImageFilter) {
                    if (object.imageFile) await CustomilyImageFilterService.applyFilter(object, filter, $scope, canvas);
                } else if (object.oldCustomilyImageFilterFile) {
                    // If does not have an oldImageFile it is useless to swap.
                    await MultipleFileUploadService.uploadMultipleImages(
                        $scope,
                        canvas,
                        [object.oldCustomilyImageFilterFile],
                        object
                    );
                    // Swap between with and without background
                    const aux = object.oldCustomilyImageFilterFile;
                    object.oldCustomilyImageFilterFile = object.imageFile;
                    object.imageFile = aux;
                }
            } catch (error) {
                console.log(error);
            }
        };

        let __imageDesign = null;

        //Captures the user's adjustment on the default preview as proportional deltas relative to
        //the original print area dimensions. These deltas are applied to the corresponding print
        //area on every other preview so all previews stay in sync.
        $scope.captureDefaultPreviewDeltas = function () {
            if (!__imageDesign?._maskBoundsRectangle) return null;
            const defaultPreviewId = $scope.beforeMergeDefaultPreviewId;
            const editingId = $scope.beforeMergeEditingPrintAreaId;
            const originals = $scope.beforeMergeOriginalPrintAreas[defaultPreviewId] || [];
            const original = editingId ? originals.find((pa) => pa.printAreaId === editingId) : originals[0];
            if (!original || !original.width || !original.height) return null;

            const r = __imageDesign._maskBoundsRectangle;
            const currentWidth = r.width / r.scaleX;
            const currentHeight = r.height / r.scaleY;
            return {
                scaleRatioX: currentWidth / original.width,
                scaleRatioY: currentHeight / original.height,
                offsetRatioX: (r.left - original.centerX) / original.width,
                offsetRatioY: (r.top - original.centerY) / original.height,
                angleDelta: (__imageDesign.angle || 0) - (original.rotation || 0)
            };
        };

        //Returns the adjusted print area for `previewId` matching the currently-edited print area
        //(by uuid). Always reads from the immutable original snapshot so deltas don't double-apply.
        $scope.getAdjustedPrintAreaForPreview = function (previewId, deltas) {
            const originals = $scope.beforeMergeOriginalPrintAreas[previewId] || [];
            const editingId = $scope.beforeMergeEditingPrintAreaId;
            const target = editingId ? originals.find((pa) => pa.printAreaId === editingId) : originals[0];
            if (!target) return null;
            if (!deltas) return { ...target };

            return {
                ...target,
                width: target.width * deltas.scaleRatioX,
                height: target.height * deltas.scaleRatioY,
                centerX: target.centerX + deltas.offsetRatioX * target.width,
                centerY: target.centerY + deltas.offsetRatioY * target.height,
                rotation: (target.rotation || 0) + (deltas.angleDelta || 0)
            };
        };

        $scope.addDesignRepresentation = async function (printAreaPreview, designPreviewUrl) {
            try {
                const { width, height, centerX, centerY } = printAreaPreview;

                $scope.beforeMergeProduct.initialDimensions = {
                    ...printAreaPreview,
                    width: pixelsToMm(width, $scope.DPI),
                    height: pixelsToMm(height, $scope.DPI),
                    centerX: pixelsToMm(centerX, $scope.DPI),
                    centerY: pixelsToMm(centerY, $scope.DPI)
                };

                const imgProps = $scope.buildImagePlaceholderProperties();

                const image = new fabric.ImagePlaceholder(null, {
                    ...imgProps,
                    width,
                    height,
                    left: centerX,
                    top: centerY,
                    angle: printAreaPreview.rotation,
                    _maskBoundsRectangle_mtr: false
                });

                const defaultClipPath = fabric.util.object.clone(image.clipPath);
                if (printAreaPreview.clipPath) {
                    const clipPathObject =
                        printAreaPreview.clipPath && typeof printAreaPreview.clipPath === 'string'
                            ? tryParseJson(printAreaPreview.clipPath)
                            : printAreaPreview.clipPath;
                    image.clipPath = clipPathObject ? await loadClipPathFromObject(clipPathObject) : null;
                }
                if (!image.clipPath) {
                    image.clipPath = defaultClipPath;
                }
                image.name = 'Print Area';
                image.addedOnEdit = false;
                canvas.add(image);
                canvas.renderAll();

                const url = (designPreviewUrl || '').replace('x-request=cl-core-html', 'x-request=cl-core-js');

                const resizedBase64 = await loadAndResizeImageIntoBase64(fabric.util, url, width, height);
                TestImageService.showStaticImage(canvas, image, { imageUrl: resizedBase64 });
            } catch (error) {
                console.error('Error adding design representation:', error);
                throw error;
            }
        };

        $scope.processImagesInLoop = async function (designPrintAreas) {
            try {
                $scope.isProcessingImages = true;
                const sectorIdx = $scope.beforeMergeProduct.productModel?.lastPrintSectorIndex;
                const { currentTemplateProductIndex } = $scope.beforeMergeProduct;

                if (!designPrintAreas[sectorIdx]) return;
                const design = designPrintAreas[sectorIdx];
                const selectedPrintAreaSector = $scope.beforeMergeDesignsToBeProcessed[currentTemplateProductIndex];
                if (!selectedPrintAreaSector) return;

                await $scope.addDesignRepresentation(
                    selectedPrintAreaSector.printAreaPreview,
                    design.designSnapshotUrl
                );
                return selectedPrintAreaSector.printAreaPreview;
            } catch (error) {
                console.error('Error processing images:', error);
            } finally {
                $scope.isProcessingImages = false;
                $scope.$apply();
            }
        };

        $scope.reinitializeDesignPreviewSelection = function (object) {
            if (!$scope.beforeMergeProduct) return;
            __imageDesign = object;
            const boundsRectangle = __imageDesign._maskBoundsRectangle;
            const _width = pixelsToMm(boundsRectangle.width / boundsRectangle.scaleX, $scope.DPI);
            const _height = pixelsToMm(boundsRectangle.height / boundsRectangle.scaleY, $scope.DPI);
            $scope.beforeMergeProduct.initialDimensions = {
                centerY: pixelsToMm(boundsRectangle.top, $scope.DPI),
                centerX: pixelsToMm(boundsRectangle.left, $scope.DPI),
                angle: __imageDesign.angle,
                width: _width,
                height: _height
            };

            __imageDesign.set('locked', true);
        };

        $scope.getClipPathAbsolutePosition = function (object) {
            if (!object.clipPath) return null;
            const clipPath = object.clipPath;
            const localPoint =
                object.originX === 'left' && object.originY === 'top'
                    ? new fabric.Point(clipPath.left, clipPath.top)
                    : clipPath.getCenterPoint();
            const objectMatrix = object.calcTransformMatrix();
            const absolutePoint = fabric.util.transformPoint(localPoint, objectMatrix);
            return {
                left: absolutePoint.x,
                top: absolutePoint.y
            };
        };

        $scope.moveToDefaultPreviewAndProcessMerge = function () {
            blockUI.start('Processing design...');
            const onDefault = $scope.beforeMergeIsDefaultActive !== false;
            if (!onDefault) {
                canvas.fire('preview:selected', { PreviewId: $scope.beforeMergeDefaultPreviewId });
            }
            setTimeout(() => {
                $scope.processMerge();
                blockUI.stop();
            }, 1000);
        };

        $scope.processMerge = function () {
            const getDesignNewDimensionProps = function (object) {
                let loadedImageObject = null;
                if (object) {
                    const boundsRectangle = object._maskBoundsRectangle;
                    const _width = boundsRectangle.width / boundsRectangle.scaleX;
                    const _height = boundsRectangle.height / boundsRectangle.scaleY;
                    loadedImageObject = {
                        top: boundsRectangle.top,
                        left: boundsRectangle.left,
                        angle: object.angle,
                        width: _width,
                        height: _height
                    };
                }
                return loadedImageObject;
            };
            const getDefaultDesignProperties = () => {
                //we are jumping the product image that is the first canvas object.
                const imageDesign = canvas
                    .getObjects()
                    .find((obj) => obj?.name && obj?.name.toLowerCase() === 'print area');
                if (!imageDesign) return null;
                return {
                    props: getDesignNewDimensionProps(imageDesign),
                    imageDesignWidth: imageDesign.width,
                    imageDesignHeight: imageDesign.height,
                    imageDesignLeft: imageDesign.left,
                    imageDesignTop: imageDesign.top,
                    clipPathAbsPosition:
                        imageDesign.clipPath && imageDesign.clipPath.path
                            ? $scope.getClipPathAbsolutePosition(imageDesign)
                            : undefined
                };
            };

            $timeout(() => {
                $scope.beforeMergeAdjustedDeltas = $scope.captureDefaultPreviewDeltas();

                const { printAreaEps, printAreaPreview, index: printAreaIndex } =
                    $scope.beforeMergeDesignsToBeProcessed[$scope.beforeMergeProduct.currentTemplateProductIndex] || {};
                const results = [];
                const {
                    props,
                    imageDesignWidth,
                    imageDesignHeight,
                    imageDesignLeft,
                    imageDesignTop,
                    clipPathAbsPosition
                } = getDefaultDesignProperties();

                const designRotation = ((props.angle || 0) * Math.PI) / 180;
                const printAreaEpsRotation = ((printAreaEps.rotation || 0) * Math.PI) / 180;
                const angleDiff = printAreaEpsRotation - designRotation;
                const deltaX = props.left - imageDesignLeft;
                const deltaY = props.top - imageDesignTop;

                const rotatedX = deltaX * Math.cos(angleDiff) - deltaY * Math.sin(angleDiff);
                const rotatedY = deltaX * Math.sin(angleDiff) + deltaY * Math.cos(angleDiff);
                const newWidth = (props.width / imageDesignWidth) * printAreaEps.width;
                const newHeight = (props.height / imageDesignHeight) * printAreaEps.height;
                const scaledX = (rotatedX / imageDesignWidth) * printAreaEps.width;
                const scaledY = (rotatedY / imageDesignHeight) * printAreaEps.height;
                const newPosX = printAreaEps.centerX + scaledX;
                const newPosY = printAreaEps.centerY + scaledY;

                //previews is a map keyed by previewId — one entry per preview (including the
                //default), each holding the adjusted print-area dimensions for that preview.
                //Consumers can iterate uniformly without special-casing default vs non-default.
                const previewsById = {};
                for (const preview of $scope.beforeMergePreviews || []) {
                    const adjusted = $scope.getAdjustedPrintAreaForPreview(
                        preview.previewId,
                        $scope.beforeMergeAdjustedDeltas
                    );
                    if (adjusted) previewsById[preview.id] = adjusted;
                }

                const newDesignDimensionsForCurrentTemplateProductSize = {
                    index: printAreaIndex,
                    preview: {
                        ...printAreaPreview,
                        centerX: props.left,
                        centerY: props.top,
                        width: props.width,
                        height: props.height
                    },
                    eps: {
                        centerX: newPosX,
                        centerY: newPosY,
                        width: newWidth,
                        height: newHeight
                    },
                    previews: previewsById,
                    clipPathAbsPosition: clipPathAbsPosition
                };

                results.push(newDesignDimensionsForCurrentTemplateProductSize);

                $rootScope.beforeMergeProduct.printAreaDimensions = results;
                const { productInfo, productModel, printAreaDimensions } = $rootScope.beforeMergeProduct;
                const product = productModel || productInfo;
                const { printAreaSectors } = product;
                const childTemplateProductPrintAreaSectors = [];

                if (!printAreaSectors[product.lastPrintSectorIndex].printAreaDimensions) {
                    printAreaSectors[product.lastPrintSectorIndex].printAreaDimensions = [];
                    printAreaSectors[product.lastPrintSectorIndex].printAreaDimensions.push(
                        printAreaDimensions.find((printArea) => printArea.index === product.lastPrintSectorIndex)
                    );
                } else {
                    printAreaSectors[product.lastPrintSectorIndex].printAreaDimensions[
                        $scope.beforeMergeProduct.currentTemplateProductIndex
                    ] = printAreaDimensions.find((printArea) => printArea.index === product.lastPrintSectorIndex);
                }

                if (childTemplateProductPrintAreaSectors.length) {
                    productInfo.printAreaSectors = [
                        ...productInfo.printAreaSectors,
                        childTemplateProductPrintAreaSectors
                    ];
                }
                if ($scope.createProductBtnTitle().toLocaleLowerCase() === 'next variant') {
                    $scope.beforeMergeProduct.currentTemplateProductIndex++;
                    const { placeholderId } = $rootScope.beforeMergeProduct;
                    $scope.initializeCurrentBeforeMergeIteration(
                        $scope.beforeMergeProduct.currentTemplateProductIndex,
                        placeholderId
                    );
                    return;
                }
                $scope.skipTemplateExitAlert = true;
                ProductService.clearProduct();
                $scope.$apply(function () {
                    $location.path($scope.beforeMergeNextPath);
                });
            });
        };

        $scope.goBackToPodSelection = function () {
            $scope.skipTemplateExitAlert = true;
            $location.path($scope.beforeMergeNextPath);
        };

        $scope.uploadTexture = async function (file) {
            try {
                if (!file || !file.name) {
                    return;
                }
                blockUI.start('Uploading texture');
                const name = await TextureService.uploadTexture(file);
                $scope.textures = await TextureService.getAllTextures();
                const selectedTexture = $scope.textures.find((t) => t.Name === name);
                if (selectedTexture) {
                    $scope.selectedTextProperties.texture = selectedTexture.Path;
                    $scope.changeFontTexture($scope.selectedTextProperties.texture, $scope.textSelected);
                }
                blockUI.stop();
            } catch (error) {
                window.rumReportError(error);
                $timeout(() => $scope.$apply());
                blockUI.stop();
            }
        };

        $scope.deleteTexture = function (texturePath) {
            const { bulkEdit, selectedTextProperties } = $scope;
            const targetProperties = bulkEdit?.enabled ? bulkEdit.selectedProperties : selectedTextProperties;

            // Save the current texture path because when we click on the delete icon the font is also selected so we
            //  want to go back to the current texture after deletion
            const selectedTexture = $scope.textSelected.texture;

            TextureService.deleteTexture(texturePath).then(async function (textureDeleted) {
                if (textureDeleted) {
                    $scope.textures = await TextureService.getAllTextures();
                }
                if (selectedTexture === texturePath) {
                    $scope.changeFontTexture($scope.textures[0].Path);
                } else {
                    targetProperties.texture = selectedTexture;
                }
            });
        };

        $scope.getThumbnailExpandedToBoundingBox = async function () {
            try {
                const listPreviews = ProductService.getListPreview();
                const thumbnail = listPreviews?.[0]?.thumbnailPath || '';
                if (!thumbnail?.length) return null;

                const path = buildCloudFrontUrl(thumbnail);
                const visibleElements = canvas
                    .getObjects()
                    .filter((obj) => obj.visible && !obj.isProductGuidelines && obj instanceof window.fabric.Object);

                if (visibleElements.length === 0) return null;

                const { width: placeholderWidth, height: placeholderHeight } = calculateBoundingBox(visibleElements);

                const resizedBase64 = await loadAndResizeImageIntoBase64(
                    fabric.util,
                    path,
                    placeholderWidth,
                    placeholderHeight
                );
                const snapshotPath = await uploadImageToS3('preview', resizedBase64);
                return snapshotPath;
            } catch (err) {
                console.error('Error in getThumbnailExpandedToBoundingBox:', err);
                throw err;
            }
        };

        $scope.isSolidBgSelected = () => {
            const activeObject = canvas?.getActiveObject();
            return activeObject?.isSolidBackground && !activeObject.isType('activeSelection');
        };

        $scope.checkIfAnyTextHasAShadow = () => {
            $scope.atLeastOneTextWithShadow = canvas
                .getObjects()
                .filter((o) => o.type === 'bounded-text')
                .some((o) => o.shadowType != null);
        };

        $scope.stepOneLayersSettingsProps = {
            title: 'Layers',
            events: {
                toggleLock: $scope.layersElementLockToggle,
                toggleVisibility: $scope.layersElementVisibilityToggle,
                togglePrintArea: $scope.layersElementPrintAreaToggle,
                toggleOverlay: $scope.layersElementOverlayToggle,
                titleChanged: $scope.layersTitleChange,
                positionChange: $scope.layersPositionChange,
                sourceElementLinked: $scope.layersSourceElementLinked,
                sourceElementUnlinked: $scope.layersSourceElementUnlinked
            }
        };

        $scope.contextMenuEvents = {
            resize: $scope.resizePage,
            productSpecs: $scope.openProductSpecModal,
            downloadCanvasImage: $scope.downloadCurrentCanvasAsImage,
            fitToCanvas: () => $scope.onElementSelectedAlign('fit'),
            flipHorizontal: $scope.updateFlipX,
            flipVertical: $scope.updateFlipY,
            bringForward: $scope.moveElementForward,
            sendBackward: $scope.moveElementBackward,
            bringToFront: $scope.bringElementToFront,
            sendToBack: $scope.sendElementToBack
        };

        $scope.isMultiDynamicImageEnabled = function () {
            const user = $rootScope.user;
            if (!user) return false;

            const roles = user.AccessRoles?.Serialized.split(',');

            const isAdmin = roles?.includes('admin');
            const impersonatedFromAdminUser = user.ImpersonatedFromAdminUser;
            const impersonatedFromChildUser = user.ImpersonatedFromChildUser;
            const isMultiDynamicImageEnabled = roles?.includes('multi-dynamic-image');
            const stores = user?.Stores || [];
            const hasShopifyStores = stores.some((store) => store.Type === StoreType.Shopify);

            return Boolean(
                (isAdmin || impersonatedFromAdminUser || isMultiDynamicImageEnabled || hasShopifyStores) &&
                    !impersonatedFromChildUser
            );
        };

        $scope.onUserUpdated = function () {
            $rootScope.user = null;
            AuthService.getSession().then(async (user) => {
                store.commit('user', user);
                $rootScope.user = user;
            });
        };

        $scope.initialize = async function () {
            try {
                $scope.showBlockUiLoader(true, 'Loading dependencies...');
                await Promise.all([$scope.loadMap(), initializePaper(), $scope.loadFonts()]);
                $scope.showBlockUiLoader(false);
                await $scope.initializeCanvas(true);
                await TemplatePermissionsService.initTemplatePermissionSteps($scope);
                if ($scope.fromListing) {
                    $scope.updateHasPrintAreaElements();
                }
            } catch (error) {
                console.error('Error during initialization:', error);
                window.rumReportError(error);
                $scope.modalInitializeErrorMessage = error.message;
                $scope.isModalInitializeErrorOpen = true;
            } finally {
                $scope.showBlockUiLoader(false);
                $scope.$applyAsync(() => {});
            }
        };

        $scope.initialize();
    }
})();
